export default {
  app: {
    name: "سناب كاب",
  },
  language: {
    label: "اللغة",
    en: "الإنجليزية",
    ar: "العربية",
  },
  toolbar: {
    back: "عودة",
    pendingRequests: "الطلبات قيد الانتظار",
    noPendingRequests: "لا توجد طلبات قيد الانتظار",
    logoutError: "حدث خطأ (راجع وحدة التحكم)",
    profile: "الملف الشخصي",
    logout: "تسجيل الخروج",
  },
  orderCard: {
    discount: "الحسم",
    voucher: "كود الحسم",
    cancellationReason: "سبب إلغاء الزبون",
    paidOnline: "دُفع إلكترونياً",
    merchantAccount: "إلى حساب",
    transaction: "عملية",
    chargedToBusiness: "الحساب على المنشأة",
    paidFromWallet: "دُفع من المحفظة الإلكترونية",
    walletRemaining: "المتبقي",
  },
  wallet: {
    cashTopup: "إضافة رصيد (نقدي)",
    manualAdjust: "تعديل يدوي",
    add: "إضافة رصيد - Add",
    remove: "سحب رصيد - Remove",
    channel: "المصدر",
    channelAdmin: "تحويل يدوي (إدارة)",
    channelCenter: "تحويل عبر مركز شحن",
    channelHint: "تحويل يدوي (إدارة): يضيفه الأدمن مباشرة. مركز شحن: دُفع نقداً في مركز شحن.",
    cashTopupHint: "إضافة رصيد مقابل دفعة نقدية مستلمة (يُسجَّل كعملية شحن).",
    manualAdjustHint: "زيادة أو إنقاص الرصيد يدوياً مع ذكر السبب (تصحيح مدقّق).",
    amount: "المبلغ (ل.س)",
    direction: "العملية",
    reason: "السبب (مطلوب، مدقّق)",
  },
  agent: {
    pageTitle: "مندوب الشحن",
    searchTitle: "البحث عن مركز معتمد",
    searchHint: "الاسم أو رقم الهاتف أو الرقم التسلسلي",
    search: "بحث",
    balance: "الرصيد",
    lowBalance: "رصيد منخفض",
    disabled: "معطّل",
    lastRecharge: "آخر شحن",
    rechargeTitle: "شحن رصيد المركز",
    amount: "المبلغ",
    notes: "ملاحظات",
    noGps: "الموقع غير متاح (فعّل GPS)",
    recharge: "شحن",
    rechargeConfirm: "شحن {amount} ل.س لمركز {center}؟",
    rechargeDone: "تم شحن {center}. الرصيد الجديد: {balance} ل.س",
    recentRecharges: "آخر عمليات الشحن",
    rechargedBy: "نفّذها",
    recentDriverTransfers: "آخر تحويلات السائقين",
    myOps: "سجل عملياتي",
    date: "التاريخ",
    status: "الحالة",
    center: "المركز",
    driver: "السائق",
    done: "منفّذة",
    cancelled: "ملغاة",
    cancel: "إلغاء العملية",
    cancelReasonPrompt: "سبب الإلغاء؟",
    cancelDone: "تم إلغاء العملية وعكس الرصيد",
  },
  // Unified report engine chrome (requirements doc 2026-09-09). Only the
  // page's own controls live here; every report's title, column labels and
  // caveats are supplied by the server with the data that produced them.
  reports: {
    pageTitle: "التقارير",
    catalogTitle: "دليل التقارير",
    searchCatalog: "بحث في التقارير",
    backToCatalog: "العودة إلى دليل التقارير",
    refresh: "تحديث",
    apply: "تطبيق",
    print: "طباعة",
    total: "الإجمالي",
    period: "الفترة",
    dateBasis: "الأساس الزمني",
    generatedAt: "تاريخ الإصدار",
    warning: "تنبيه",
    note: "ملاحظة",
    notesTitle: "ملاحظات على قراءة التقرير",
    noRows: "لا توجد بيانات ضمن هذه الفترة أو هذه الفلاتر",
    noColumns: "لا توجد أعمدة لعرضها",
    noReportsPermitted: "لا توجد تقارير متاحة لصلاحياتك الحالية",
    previous: "السابق",
    next: "التالي",
    status: "الحالة",
    statusAll: "الكل",
    statusReady: "جاهز",
    statusPartial: "جزئي",
    statusLegacy: "منشور مسبقاً",
    statusBlocked: "بيانات غير متوفرة",
    blockedHeading: "هذا التقرير غير قابل للإنتاج حالياً",
    blockedMissing: "البيانات غير المتوفرة",
    blockedRecommendation: "ما يلزم لتفعيله",
    noPermission: "لا تملك صلاحية الاطلاع على هذا التقرير",
    failedToLoad: "تعذر تحميل التقرير",
    failedExport: "تعذر تصدير التقرير",
  },
  finance: {
    nav: {
      settlements: "التسويات",
      chartOfAccounts: "دليل الحسابات",
      journalEntries: "قيود اليومية",
      assets: "الأصول ورأس المال",
      adjustments: "التعديلات",
      reports: "التقارير",
      trialBalance: "ميزان المراجعة",
      balanceSheet: "قائمة المركز المالي",
      incomeStatement: "قائمة الدخل",
      generalJournalSummary: "سجل اليومية العامة المجمع",
      driverStatement: "كشف حساب السائق (الرحلات)",
      cashFlowStatement: "قائمة التدفقات النقدية",
      equityChanges: "التغيرات في حقوق الملكية",
      accountStatement: "كشف حساب مفصّل",
      accountingBalance: "ميزان المحاسبة",
      accountsInventory: "جرد الحسابات",
      postingRules: "القيود التلقائية",
      periodLocks: "إقفال الفترات",
      employees: "الموظفون والرواتب",
      // final-version doc 2026-10-05: grouped two-row finance nav.
      groups: {
        operations: "العمليات اليومية",
        accountsSetup: "إعداد الحسابات",
        ledgers: "الدفاتر والتقارير",
        statements: "القوائم المالية",
      },
    },
    ui: {
      navLabel: "أقسام المالية",
    },
    postingRules: {
      pageTitle: "القيود المحاسبية التلقائية",
      rulesTab: "قواعد الترحيل",
      failuresTab: "إخفاقات الترحيل",
      depreciationTab: "اهتلاك السيارات",
      engineOn: "المحرك مفعّل",
      engineOff: "المحرك متوقف",
      eventKey: "الحدث",
      ruleName: "العملية",
      mapping: "طرفا القيد (مدين / دائن)",
      active: "مفعّل",
      inactive: "متوقف",
      editMapping: "تعديل الحسابات",
      editMappingHint: "يمكن إعادة توجيه أي طرف إلى حساب آخر من دليل الحسابات. مسح التخصيص يعيد الحساب الافتراضي. جميع التعديلات مسجلة في سجل التدقيق.",
      overrideAccount: "حساب بديل",
      debit: "مدين",
      credit: "دائن",
      save: "حفظ",
      saved: "تم حفظ الربط",
      failedSave: "تعذر حفظ القاعدة",
      failedLoad: "تعذر تحميل قواعد الترحيل",
      manualEntry: "تسجيل قيد",
      operationRef: "رقم العملية",
      memo: "البيان",
      post: "ترحيل",
      posted: "تم ترحيل القيد",
      failedPost: "تعذر ترحيل القيد",
      retry: "إعادة المحاولة",
      retried: "تمت إعادة الترحيل",
      reviewOnly: "للمراجعة - قيد يدوي",
      reviewOnlyHint: "دفع إلكتروني مؤكد وصل بعد تسوية الرحلة: خُصم المبلغ من الراكب ولم يُسجَّل قيد آلي. راجعه وسجّل قيداً يدوياً عند الحاجة.",
      error: "الخطأ",
      carId: "رقم السيارة",
      captainId: "رقم السائق",
      carOwnerId: "رقم مالك السيارة",
      businessAccountId: "رقم حساب المنشأة",
      transferCenterId: "رقم مركز الشحن",
      paymentMethodCode: "رمز وسيلة الدفع",
      car: "السيارة",
      monthlyAmount: "المبلغ الشهري",
      startMonth: "شهر البداية",
      endMonth: "شهر النهاية",
      notes: "ملاحظات",
      addSchedule: "إضافة جدول",
      runMonth: "الشهر (YYYY-MM)",
      runDepreciation: "ترحيل الاهتلاك",
      amountTotal: "الإجمالي",
      amountGateway: "مبلغ بوابة الدفع",
      amountWallet: "مبلغ المحفظة",
      amountBusiness: "مبلغ حساب الأعمال",
      amountCaptainNet: "صافي السائق (النقد - الحصة)",
      amountCaptainCashCollected: "النقد الذي قبضه السائق من الراكب",
      amountDiscount: "حسم القسيمة",
      amountCommission: "إيراد العمولة",
      amountCommissionThirdParty: "عمولة (سيارة الغير)",
      amountRideRevenue: "إيراد الرحلة",
      amountDriverShare: "حصة السائق",
      amountOwnerShare: "حصة مالك السيارة (2118)",
      amountStoreCommission: "عمولة المتجر",
      amountDeliveryFee: "رسوم التوصيل",
      amountDriverDue: "مستحقات السائق",
      amountStoreDue: "مستحقات المتجر",
      resolver_captain_deferred: "حساب السائق الفرعي (تلقائي)",
      resolver_captain_deferred_counterparty: "حساب السائق المستلم (تلقائي)",
      resolver_center_deferred: "حساب مركز الشحن الفرعي (تلقائي)",
      resolver_business_deferred: "حساب المنشأة الفرعي (تلقائي)",
      resolver_owner_payable: "حساب مالك السيارة الفرعي (تلقائي)",
      resolver_company_captain_deferred: "حساب السائق الفرعي — سائقو الشركة (تلقائي)",
      resolver_gateway_asset: "حساب البوابة (حسب وسيلة الدفع)",
      docRef: "رقم القيد بالدليل",
      appliesWhen: "يُطبَّق عند",
      entryKind: "نوع القيد",
      kindAll: "الكل",
      kindManual: "قيود يدوية",
      kindAutomatic: "قيود آلية",
      amountCash: "المبلغ نقداً (الصندوق)",
      amountBank: "المبلغ عن طريق البنك",
      amountGatewayChannel: "المبلغ عبر بوابة الدفع",
      amountNet: "صافي المبلغ المحول",
      amountGross: "إجمالي المبلغ المستحق",
      amountFee: "عمولة بوابة الدفع",
      amountGatewayNet: "صافي المبلغ لدى البوابة",
      amountCaptainShare: "حصة السائق (الفرق)",
      amountPlatformCommission: "عمولة المنصة (يلا غو)",
      amountCreditConsumed: "الرصيد المستهلك من المنصة",
      amountCaptainFavour: "الفرق لصالح السائق",
      amountCenterFavour: "الفرق لصالح مركز الشحن",
      amountCompanyLoss: "خسارة الشركة",
      amountCompanyGain: "ربح الشركة",
      resolver_center_receivable: "حساب مركز الشحن المدين (تلقائي)",
      accountMissing: "لا يوجد حساب مطابق في دليل الحسابات",
    },
    periodLocks: {
      pageTitle: "إقفال الفترات المحاسبية",
      title: "إقفال الفترات الشهرية",
      monthsToShow: "عدد الأشهر المعروضة",
      month: "الشهر",
      status: "الحالة",
      open: "مفتوح",
      closed: "مقفل",
      closedBy: "أقفله",
      closedAt: "تاريخ الإقفال",
      reopenedBy: "أعاد فتحه",
      reopenedAt: "تاريخ إعادة الفتح",
      note: "الملاحظة",
      snapshots: "التقارير المجمّدة",
      close: "إقفال الشهر",
      reopen: "إعادة الفتح",
      notClosable: "الشهر لم ينتهِ بعد",
      openCount: "أشهر مفتوحة",
      closedCount: "أشهر مقفلة",
      closeTitle: "إقفال شهر {month}",
      closeWarning: "إقفال الشهر يرفض من الآن فصاعداً كل قيد مؤرّخ داخله — يدوياً كان أم آلياً، ولا يُعاد تأريخه — ويُجمّد لقطة كل تقرير مالي لهذا الشهر، فيبقى ما يُصدر اليوم قابلاً للإصدار بنفس الأرقام دائماً.",
      closeOrderHint: "نفّذ الإقفال إلى الحسابات الختامية أولاً: قيوده مؤرّخة داخل الفترة وستُرفض بعد قفل الشهر.",
      closeNote: "ملاحظة الإقفال (اختيارية)",
      closeConfirm: "تأكيد الإقفال",
      closeDone: "تمّ إقفال الشهر",
      reopenTitle: "إعادة فتح شهر {month}",
      reopenWarning: "إعادة الفتح تسمح بتغيير قوائم مالية صدرت فعلاً: يمكن ترحيل قيود داخل الشهر من جديد، وقد تختلف الأرقام التي أصدرها المحاسب عن الأستاذ العام.",
      reopenSnapshotNote: "اللقطات المجمّدة لهذا الشهر باقية كما هي ولا تتغيّر بإعادة الفتح، فما صدر سابقاً يبقى قابلاً للإصدار. ولإصدار أرقام جديدة يجب إقفال الشهر من جديد بعد التعديل.",
      reopenReason: "سبب إعادة الفتح (مطلوب)",
      reopenReasonRequired: "سبب إعادة الفتح مطلوب — إعادة فتح فترة مقفلة إجراء استثنائي ويجب توثيقه.",
      reopenTypeToConfirm: "اكتب {month} للتأكيد",
      reopenTypeMismatch: "الشهر المكتوب لا يطابق الشهر المطلوب.",
      reopenConfirm: "تأكيد إعادة الفتح",
      reopenDone: "تمّ إعادة فتح الشهر",
      snapshotResult: "نتيجة تجميد تقارير شهر {month}",
      captured: "جُمّدت",
      failedSnapshots: "تعذّر تجميدها",
      skipped: "مستثناة — لا توجد أرقام لتجميدها",
      warnings: "تنبيهات",
      earlierOpenMonths: "أشهر أقدم ما زالت مفتوحة",
      earlierOpenHint: "الإقفال خارج الترتيب مسموح، لكن هذه الأشهر الأقدم ما زالت مفتوحة — تأكّد أن ذلك مقصود.",
      snapshotCatalog: "التقارير التي يُجمّدها الإقفال",
      snapshotCatalogHint: "هذه هي التقارير التي تُخزّن أرقامها عند إقفال الشهر.",
      noMonths: "لا توجد أشهر لعرضها",
      failedLoad: "تعذّر تحميل إقفالات الفترات",
      failedClose: "تعذّر إقفال الشهر",
      failedReopen: "تعذّر إعادة فتح الشهر",
    },
    employees: {
      pageTitle: "الموظفون والرواتب",
      title: "الموظفون",
      employeeNo: "الرقم الوظيفي",
      fullName: "الاسم الكامل",
      department: "القسم",
      jobTitle: "المسمّى الوظيفي",
      phone: "الهاتف",
      hiredAt: "تاريخ التعيين",
      terminatedAt: "تاريخ انتهاء الخدمة",
      basicSalary: "الراتب الأساسي (التعاقدي)",
      basicSalaryHint: "رقم العقد. يُستخدم لتعبئة مكوّن «الأساسي» للشهر، ولا يُجمع بذاته في تقرير الرواتب.",
      active: "على رأس العمل",
      inactive: "موقوف",
      allDepartments: "كل الأقسام",
      allStatuses: "الكل",
      addEmployee: "إضافة موظف",
      editEmployee: "تعديل موظف",
      newEmployee: "موظف جديد",
      saved: "تمّ حفظ بيانات الموظف",
      deleteTitle: "أرشفة موظف",
      deleteWarning: "يُؤرشف الموظف ولا يُمحى، وتُترك مكوّنات رواتبه المسجّلة كما هي عمداً، ليبقى أي شهر صُرف فعلاً مطابقاً.",
      deleteConfirm: "أرشفة",
      deleted: "تمت أرشفة الموظف",
      nameRequired: "الاسم الكامل مطلوب.",
      noEmployees: "لا يوجد موظفون مسجّلون",
      failedLoad: "تعذّر تحميل الموظفين",
      failedSave: "تعذّر حفظ بيانات الموظف",
      failedDelete: "تعذّر أرشفة الموظف",
      payrollTitle: "كشف الرواتب",
      payrollFor: "رواتب {name}",
      selectEmployee: "اختر موظفاً لفتح كشف رواتبه",
      month: "شهر الراتب",
      kind: "الطرف",
      earning: "استحقاق",
      deduction: "اقتطاع",
      component: "المكوّن",
      amount: "المبلغ",
      memo: "البيان",
      batch: "دفعة الصرف",
      addRow: "إضافة سطر",
      removeRow: "حذف السطر",
      saveMonth: "حفظ الشهر",
      replaceHint: "الحفظ يعيد كتابة شهر الموظف بالكامل، فلا يبقى السطر الأصلي بعد تصحيحه ليُجمع مرتين.",
      monthSaved: "تمّ حفظ شهر الرواتب",
      seedFromContract: "تعبئة من الراتب التعاقدي",
      seedHint: "يُنشئ مكوّن الراتب الأساسي من العقد، وللموظف الذي لا يوجد له أي مكوّن في ذلك الشهر فقط.",
      seedDone: "تمّ إنشاء {created} مكوّن من أصل {considered} موظف",
      gross: "إجمالي الاستحقاقات",
      deductionsTotal: "إجمالي الاقتطاعات",
      net: "صافي الراتب",
      noComponents: "لا يوجد مسجّل لهذا الشهر",
      deleteComponent: "حذف السطر",
      componentDeleted: "تمّ حذف السطر",
      amountRequired: "كل سطر يحتاج مكوّناً ومبلغاً.",
      lockedHint: "الشهر المقفل يرفض تعديل الرواتب — أعد فتح الفترة أولاً إن كان التعديل ضرورياً فعلاً.",
      failedLoadPayroll: "تعذّر تحميل شهر الرواتب",
      failedSaveMonth: "تعذّر حفظ شهر الرواتب",
      failedSeed: "تعذّرت التعبئة من الرواتب التعاقدية",
      failedDeleteComponent: "تعذّر حذف السطر",
      components: {
        basic: "الراتب الأساسي",
        allowance: "بدلات",
        bonus: "مكافأة",
        overtime: "ساعات إضافية",
        insurance: "تأمينات",
        tax: "ضريبة دخل",
        advance: "سلفة",
        fine: "غرامة",
        other: "أخرى",
      },
    },
    common: {
      performedBy: "الموظف المنفّذ",
      performedBySystem: "النظام (قيد آلي)",
      from: "من",
      to: "إلى",
      amount: "المبلغ",
      apply: "تطبيق",
      back: "عودة",
      refresh: "تحديث",
      search: "بحث",
      load: "تحميل",
      csv: "CSV",
      pdf: "PDF",
      date: "التاريخ",
      type: "النوع",
      note: "ملاحظة",
      source: "المصدر",
      status: "الحالة",
      actions: "الإجراءات",
      phone: "الهاتف",
      email: "البريد الإلكتروني",
      name: "الاسم",
      category: "الفئة",
      balance: "الرصيد",
      captain: "السائق",
      id: "المعرف",
      code: "الرمز",
      revenue: "الإيراد",
      bonus: "المكافأة",
      penalty: "الغرامة",
      hrDeduction: "حسم الموارد البشرية",
      net: "الصافي",
      settled: "المسدّد",
      credit: "دائن",
      debit: "مدين",
      memo: "البيان",
      account: "الحساب",
      cancel: "إلغاء",
      reason: "السبب",
      all: "الكل",
      month: "الشهر",
    },
    assets: {
      pageTitle: "الأصول ورأس المال",
      registerAsset: "تسجيل أصل / رأس مال",
      entryType: "نوع الإدخال",
      capitalInjection: "إدخال رأس مال",
      vehiclePurchase: "شراء مركبة",
      assetPurchase: "شراء أصل آخر",
      assetAccount: "حساب الأصل",
      fundingAccount: "الحساب المقابل",
      assetName: "اسم الأصل",
      assetCategory: "فئة الأصل",
      vendorName: "المصدر / المورّد",
      postDate: "تاريخ الترحيل",
      recentEntries: "أحدث قيود الأصول",
      capitalTotal: "إدخالات رأس المال",
      vehicleTotal: "أصول المركبات",
      otherAssetsTotal: "الأصول الأخرى",
      filters: "الفلاتر",
      clearFilters: "مسح الفلاتر",
      postEntry: "ترحيل قيد الأصل",
      assetPosted: "تم ترحيل قيد الأصل",
      failedLoad: "فشل تحميل قيود الأصول",
      failedPost: "فشل ترحيل قيد الأصل",
      requiredFields: "حساب الأصل والحساب المقابل والمبلغ واسم الأصل مطلوبة",
      assetEntrySource: "قيد أصل / رأس مال",
      status: "الحالة",
      originalEntry: "القيد الأصلي",
    },
    payments: {
      pageTitle: "التسويات",
      addSettlement: "إضافة تسوية",
      paidToDriver: "مدفوع للسائق",
      receivedFromDriver: "مستلم من السائق",
      pending: "معلّق",
      done: "منجز",
      pendingPayments: "المدفوعات المعلّقة",
      donePayments: "المدفوعات المنجزة",
      firstName: "الاسم الأول",
      lastName: "الاسم الأخير",
      settlementSaved: "تم حفظ التسوية",
      failedLoadStatus: "فشل تحميل مدفوعات {status}",
      failedSaveSettlement: "فشل حفظ التسوية",
    },
    ledger: {
      pageTitle: "كشف حساب السائق",
      entryType: "نوع الحركة",
      currentBalance: "الرصيد الحالي",
      restrictedBonus: "الرصيد الترحيبي المقيّد المتبقي",
      restrictedBonusHint: "يغطي عمولة الشركة فقط، ولا يُصرف نقداً ولا يُحوَّل",
      withdrawableBalance: "الرصيد القابل للصرف",
      pendingBookings: "الحجوزات المعلّقة",
      settledToDriver: "المسدّد للسائق",
      receivedFromDriver: "المستلم من السائق",
      booking: "الحجز",
      balanceAfter: "الرصيد بعد الحركة",
      bookingRevenue: "إيراد الحجز",
      settlement: "تسوية",
      adjustment: "تعديل",
      failedLoadBalance: "فشل تحميل رصيد السائق",
      failedLoadEntries: "فشل تحميل حركات الكشف",
      paidToDriver: "مدفوع للسائق",
      receivedFromDriverLabel: "مستلم من السائق",
    },
    coa: {
      kind: "النوع",
      kindMain: "رئيسي",
      kindSub: "فرعي",
      kindClosing: "ختامي",
      nature: "طبيعة الحساب",
      natureBoth: "دائن مدين",
      natureNone: "فارغ",
      level: "المستوى",
      closingAccount: "الحساب الختامي",
      closingAccountOptional: "الحساب الختامي (يبقى فارغاً للميزانية فقط)",
      financialType: "التصنيف المالي (للتقارير)",
      allKinds: "كل الأنواع",
      allNatures: "كل الطبائع",
      systemAccount: "حساب نظامي",
      account: "الحساب",
      parentRequired: "الحساب الرئيسي إلزامي للحسابات الفرعية",
      closingRequired: "الحساب الختامي إلزامي للحسابات الرئيسية والفرعية",
      periodClose: "إقفال الفترة",
      periodClosePreview: "معاينة قيود الإقفال",
      periodCloseConfirm: "تنفيذ الإقفال",
      periodCloseDone: "تم إنشاء قيود الإقفال",
      periodCloseNothing: "لا توجد أرصدة بحاجة إلى إقفال في هذه الفترة",
      pageTitle: "دليل الحسابات",
      chartOfAccounts: "دليل الحسابات",
      searchTree: "ابحث برقم الحساب أو اسمه",
      expandAll: "توسيع الكل",
      collapseAll: "طي الكل",
      addChild: "إضافة حساب فرعي",
      includesChildren: "الإجمالي يشمل الحسابات الفرعية",
      noResults: "لا توجد حسابات مطابقة",
      addAccount: "إضافة حساب",
      editAccount: "تعديل الحساب",
      accountCode: "رمز الحساب",
      accountNameEn: "اسم الحساب بالإنجليزية",
      accountNameAr: "اسم الحساب بالعربية",
      parentAccount: "الحساب الأب",
      noParent: "بدون حساب أب",
      description: "الوصف",
      manualPosting: "السماح بالترحيل اليدوي",
      saveAccount: "حفظ الحساب",
      accountSaved: "تم حفظ الحساب",
      failedSave: "فشل حفظ الحساب",
      codeConflictTitle: "الرمز مستخدم مسبقاً",
      codeConflictBody: 'الرمز {code} مستخدم حالياً للحساب "{name}".',
      swapCodesHint: "يمكن تبديل الرمزين بين الحسابين: يأخذ هذا الحساب الرمز الجديد ويأخذ الحساب الآخر الرمز الحالي لهذا الحساب.",
      swapCodes: "تبديل الرمزين",
      requiredFields: "رمز الحساب والاسم الإنجليزي والنوع والرصيد الطبيعي مطلوبة",
      typeAsset: "أصل",
      typeLiability: "التزام",
      typeEquity: "حقوق ملكية",
      typeRevenue: "إيراد",
      typeExpense: "مصروف",
      balanceDebit: "مدين",
      balanceCredit: "دائن",
      normalBalance: "الرصيد الطبيعي",
      debitTotal: "إجمالي المدين",
      creditTotal: "إجمالي الدائن",
      active: "نشط",
      inactive: "غير نشط",
      failedLoad: "فشل تحميل دليل الحسابات",
      deleteAccount: "حذف الحساب",
      deleteConfirmTitle: "تأكيد حذف الحساب",
      deleteConfirmBody: 'سيتم حذف الحساب {code} — "{name}" نهائياً ولا يمكن التراجع. هل أنت متأكد؟',
      deleteBlockedSystem: "هذا حساب نظامي تسجَّل عليه القيود الآلية ولا يمكن حذفه — يمكن تعديل اسمه ورمزه وموقعه في الشجرة بدلاً من ذلك.",
      deleteBlockedChildren: "لا يمكن حذف حساب لديه حسابات فرعية — احذف أو انقل الحسابات الفرعية أولاً.",
      accountDeleted: "تم حذف الحساب",
      failedDelete: "فشل حذف الحساب",
      exportedAt: "تاريخ التصدير",
    },
    adjustments: {
      pageTitle: "تعديلات السائقين",
      captainAdjustments: "تعديلات السائقين",
      adjustmentType: "نوع التعديل",
      postingDate: "تاريخ الترحيل",
      postAdjustment: "ترحيل التعديل",
      recentAdjustmentJournals: "آخر قيود التعديلات",
      captainAmountRequired: "السائق والمبلغ مطلوبان",
      adjustmentPosted: "تم ترحيل التعديل",
      failedPost: "فشل ترحيل التعديل",
      failedLoad: "فشل تحميل التعديلات",
      accountCodeSearch: "بحث برقم الحساب",
      lineAccounts: "أرقام الحسابات",
    },
    journals: {
      pageTitle: "قيود اليومية",
      operationRef: "رقم العملية",
      bookingId: "رقم الرحلة",
      newCashMovement: "حركة نقدية جديدة",
      direction: "الاتجاه",
      counterAccount: "الحساب المقابل",
      captainOptional: "السائق (اختياري)",
      referenceNo: "المرجع",
      postingDate: "تاريخ الترحيل",
      newPayrollBatch: "دفعة رواتب جديدة",
      paidAt: "تاريخ الدفع",
      recipient: "المستفيد",
      lineMemo: "بيان السطر",
      addPayrollLine: "إضافة سطر رواتب",
      total: "الإجمالي",
      newJournalEntry: "قيد يومية جديد",
      journalDate: "تاريخ القيد",
      addLine: "إضافة سطر",
      postEntry: "ترحيل القيد",
      postCashMovement: "ترحيل الحركة النقدية",
      postPayrollBatch: "ترحيل دفعة الرواتب",
      noMemo: "بلا بيان",
      reset: "إعادة ضبط",
      manualJournals: "قيود يدوية",
      bookingRevenue: "إيراد الحجوزات",
      settlementPaid: "تسوية مدفوعة",
      settlementReceived: "تسوية مستلمة",
      bonusAdjustments: "تعديلات المكافآت",
      penaltyAdjustments: "تعديلات الغرامات",
      hrDeductions: "حسومات الموارد البشرية",
      cashMovements: "الحركات النقدية",
      payrollBatches: "دفعات الرواتب",
      assetEntries: "قيود الأصول",
      cashIn: "نقد داخل",
      cashOut: "نقد خارج",
      debitCreditMustMatch: "يجب أن يتطابق إجمالي المدين والدائن",
      journalPosted: "تم ترحيل القيد",
      failedPostJournal: "فشل ترحيل القيد",
      accountAmountRequired: "الحساب والمبلغ مطلوبان",
      cashMovementPosted: "تم ترحيل الحركة النقدية",
      failedCashMovement: "فشل ترحيل الحركة النقدية",
      payrollGreaterThanZero: "يجب أن يكون إجمالي دفعة الرواتب أكبر من صفر",
      payrollPosted: "تم ترحيل دفعة الرواتب",
      failedPayroll: "فشل ترحيل دفعة الرواتب",
      failedLoad: "فشل تحميل قيود اليومية",
      reverseEntry: "عكس القيد",
      reverseEntryTitle: "عكس قيد اليومية",
      reverseReasonHint: "اشرح سبب عكس هذا القيد",
      reverseEntryConfirm: "ترحيل قيد العكس",
      reversePosted: "تم ترحيل قيد العكس",
      failedReverse: "فشل عكس القيد",
      statusPosted: "مرحل",
      statusReversed: "تم عكسه",
      statusReversal: "قيد عكسي",
      reversedBy: "تم عكسه بواسطة",
      reversalOf: "عكس للقيد",
      reversalSource: "قيد عكسي",
      failedLoadAccounts: "تعذّر تحميل دليل الحسابات",
      useDriverAccount: "استخدام حساب السائق {code}",
      driverHasNoAccount: "لا يوجد حساب فرعي لهذا السائق بعد",
      entityLeafWarning: "يُرحَّل إلى دفتر الأستاذ فقط ولا يغيّر رصيد محفظة السائق/المركز في التطبيق",
      payrollMode: "طريقة الترحيل",
      payrollModePaid: "استحقاق وصرف",
      payrollModeAccrued: "استحقاق فقط",
      payrollModePaidHint: "قيد استحقاق (من حـ الرواتب إلى حـ المستفيد) ثم قيد صرف (من حـ المستفيد إلى حـ الصندوق/المصرف)",
      payrollModeAccruedHint: "قيد استحقاق فقط على حساب المستفيد، ويُصرف لاحقاً",
      payrollCreditAccount: "حساب الصرف (صندوق أو مصرف)",
      payrollCreditAccountHint: "اتركه فارغاً للصرف من الصندوق الرئيسي",
      beneficiaryType: "نوع المستفيد",
      employee: "موظف",
      driver: "سائق",
      freeTextBeneficiary: "اسم فقط",
      freeTextBeneficiaryHint: "بدون حساب فرعي: يُذكر الاسم في بيان القيد ويُرحَّل إلى حساب الصرف مباشرة",
      noEmployees: "لا يوجد موظفون، أضفهم من شاشة الموظفين",
      failedLoadEmployees: "تعذّر تحميل قائمة الموظفين",
      payrollDriverAccount: "يُرحَّل إلى حساب السائق {code}",
      payrollDriverAccountNew: "سيُنشأ الحساب الفرعي للسائق عند الترحيل",
      payrollRecipientRequired: "حدد موظفاً أو سائقاً أو أدخل اسم المستفيد لكل سطر",
      payrollResultTitle: "تم ترحيل القيود التالية:",
      closeDialog: "إغلاق",
      searchText: "بحث (مرجع، بيان، اسم المستفيد)",
      entriesTotal: "عدد القيود: {count}",
      perPage: "لكل صفحة",
      // final-version doc 2026-10-05 ("one hour difference"): the entry date
      // is the operation date; the recording time is when the entry was made.
      recordedAt: "وقت التسجيل",
      recordedAtHint: "تاريخ القيد هو وقت العملية نفسها (للرحلة: وقت انتهائها)، أما وقت التسجيل فهو وقت إنشاء القيد في النظام (للرحلة: وقت دفعها)",
    },
    reports: {
      pageTitle: "التقارير المالية",
      trialBalance: "ميزان المراجعة",
      captainStatement: "كشف حساب السائق",
      monthlySettlements: "التسويات الشهرية",
      loadTrialBalance: "تحميل ميزان المراجعة",
      selectCaptainFirst: "اختر سائقًا أولًا",
      failedLoadTrialBalance: "فشل تحميل ميزان المراجعة",
      failedLoadCaptainStatement: "فشل تحميل كشف حساب السائق",
      failedLoadMonthlySettlements: "فشل تحميل التسويات الشهرية",
      failedDownloadReport: "فشل تنزيل التقرير",
      bookingRevenue: "إيراد الحجوزات",
      settledToDriver: "المسدّد للسائق",
      receivedFromDriver: "المستلم من السائق",
      captainId: "معرف السائق",
      driverAccountCode: "رقم حساب السائق",
      entry: "الحركة",
    },
    trialBalance: {
      pageTitle: "ميزان المراجعة",
      title: "ميزان المراجعة",
      openFullReport: "فتح التقرير الكامل",
      debitMovements: "الحركات المدينة",
      creditMovements: "الحركات الدائنة",
      balanceSide: "نوع الرصيد",
      sideDebit: "مدين",
      sideCredit: "دائن",
      sideBalanced: "متوازن",
      notes: "الملاحظات",
      totals: "الإجماليات",
      totalDebit: "إجمالي الحركات المدينة",
      totalCredit: "إجمالي الحركات الدائنة",
      totalsMatch: "الإجماليات متطابقة",
      totalsMismatch: "الإجماليات غير متطابقة",
      totalsMismatchWarning: "إجمالي الحركات المدينة لا يساوي إجمالي الحركات الدائنة، يرجى المراجعة.",
      difference: "الفرق",
      abnormalCount: "أرصدة غير طبيعية",
      codeFrom: "من حساب (الرمز)",
      codeTo: "إلى حساب (الرمز)",
      maxLevel: "حتى المستوى",
      allLevels: "كل المستويات",
      contextRow: "معروض لاكتمال الشجرة (خارج نطاق الفلترة)",
      printPdf: "طباعة / PDF",
      noteAssetCredit: "الرصيد الدائن في الأصول نادر وقد يكون هناك مشكلة، يرجى المراجعة.",
      noteLiabilityDebit: "الرصيد المدين في المطاليب نادر وقد يكون هناك مشكلة، يرجى المراجعة.",
      noteExpenseCredit: "المفروض أن المصاريف دائماً مدين، يرجى المراجعة.",
    },
    balanceSheet: {
      pageTitle: "قائمة المركز المالي",
      title: "قائمة المركز المالي",
      asOfDate: "في تاريخ",
      currency: "نوع العملة",
      currencyNew: "العملة الجديدة",
      currencyOld: "العملة القديمة",
      item: "البند",
      value: "القيمة",
      totalAssets: "إجمالي الأصول",
      totalLiabilities: "إجمالي المطاليب",
      totalEquity: "إجمالي حقوق الملكية",
      currentPeriodResult: "نتيجة الفترة الجارية (غير مرحّلة)",
      computedNote: "قيمة محتسبة من حسابات الإيرادات والمصاريف غير المرحّلة",
      netOfProvision: "بعد خصم {name} ({amount})",
      liabilitiesPlusEquity: "المطاليب + حقوق الملكية",
      balancedMessage: "المعادلة متوازنة (الأصول = المطاليب + حقوق الملكية).",
      unbalancedMessage: "المعادلة غير متوازنة، يرجى مراجعة القيود المحاسبية.",
      balancedShort: "متوازنة",
      unbalancedShort: "غير متوازنة",
      failedLoad: "فشل تحميل قائمة المركز المالي",
    },
    incomeStatement: {
      pageTitle: "قائمة الدخل",
      title: "قائمة الدخل",
      fromDate: "من تاريخ",
      toDate: "إلى تاريخ",
      comparison: "نوع المقارنة",
      comparisonNone: "بدون مقارنة",
      comparisonPreviousPeriod: "مقارنة مع الفترة السابقة",
      comparisonPreviousYear: "مقارنة مع نفس الفترة من العام السابق",
      comparisonNeedsDates: "المقارنة تتطلب تحديد تاريخي بداية ونهاية الفترة",
      item: "البيان",
      currentPeriod: "الفترة الحالية",
      previousPeriod: "الفترة السابقة",
      change: "التغير",
      sections: {
        operating_revenue: "الإيرادات التشغيلية",
        cost_of_revenue: "المصاريف التشغيلية المباشرة (تكلفة الإيرادات)",
        general_admin: "المصاريف التشغيلية غير المباشرة (عمومية وإدارية)",
        non_operating_revenue: "الإيرادات غير التشغيلية",
        non_operating_expense: "المصاريف غير التشغيلية",
      },
      subtotals: {
        operating_revenue: "إجمالي الإيرادات التشغيلية",
        cost_of_revenue: "إجمالي تكلفة الإيرادات",
        general_admin: "إجمالي المصاريف العمومية والإدارية",
        non_operating_revenue: "إجمالي الإيرادات غير التشغيلية",
        non_operating_expense: "إجمالي المصاريف غير التشغيلية",
      },
      grossProfit: "الربح الإجمالي",
      operatingProfit: "الربح التشغيلي",
      profitBeforeTax: "صافي الربح قبل الضريبة",
      incomeTax: "ضريبة الدخل",
      profitAfterTax: "صافي الربح بعد الضريبة",
      profitShort: "ربح",
      lossShort: "خسارة",
      excludedWarning: "توجد حركات محاسبية ضمن الفترة خارج بنود قائمة الدخل (الصافي: {amount}) ولا تظهر في القائمة — يرجى مراجعة دليل الحسابات.",
      failedLoad: "فشل تحميل قائمة الدخل",
    },
  },
  fleet: {
    maintenance: {
      pageTitle: "صيانة المركبات",
      title: "سجلّ الصيانة",
      addRecord: "تسجيل صيانة",
      editRecord: "تعديل السجل",
      car: "المركبة",
      plateNumber: "رقم اللوحة",
      serviceDate: "تاريخ الصيانة",
      category: "نوع الصيانة",
      vendor: "الورشة / المورّد",
      cost: "التكلفة",
      odometer: "عدّاد الكيلومترات",
      odometerHint: "اتركه فارغاً إن لم تذكر الورشة قراءة العدّاد — الصفر هنا يُفسد كل رقم مسافة يُشتقّ منه.",
      invoiceNo: "رقم الفاتورة",
      notes: "ملاحظات",
      postingState: "الترحيل",
      posted: "مُرحّل",
      unposted: "غير مُرحّل",
      journalEntry: "قيد رقم {id}",
      retryPost: "إعادة الترحيل",
      postRetried: "تمت إعادة محاولة الترحيل",
      postingFailed: "حُفظ السجل ولم يصل مصروفه إلى الأستاذ العام",
      allCategories: "كل الأنواع",
      allStates: "الكل",
      search: "الورشة أو الفاتورة أو الملاحظات أو اللوحة",
      from: "من",
      to: "إلى",
      apply: "تطبيق",
      clearFilters: "مسح",
      rowsTotal: "عدد السجلات المعروضة",
      totalCost: "إجمالي التكلفة (المعروض)",
      totalPosted: "المُرحّل (المعروض)",
      totalUnposted: "غير المُرحّل (المعروض)",
      totalsHint: "الإجماليات تخصّ السجلات المُحمّلة حالياً لا كامل السجلّ المُرشّح.",
      expenseAccount: "حساب المصروف",
      cashAccount: "حساب الصندوق",
      missingAccounts: "غير موجود في شجرة الحسابات",
      saved: "تمّ حفظ سجل الصيانة",
      deleteTitle: "حذف السجل",
      deleteWarning: "لا يُحذف إلا سجل لم يصل إلى الأستاذ العام.",
      deleteConfirm: "حذف",
      deleted: "تمّ حذف السجل",
      frozenHint: "هذا السجل مُرحّل: لا يمكن تعديل المبلغ أو التاريخ أو المركبة. اعكس القيد من شاشة القيود المحاسبية أولاً.",
      requiredFields: "المركبة والتاريخ والنوع والتكلفة جميعها مطلوبة.",
      noRecords: "لا توجد سجلات صيانة",
      failedLoad: "تعذّر تحميل سجلّ الصيانة",
      failedSave: "تعذّر حفظ السجل",
      failedDelete: "تعذّر حذف السجل",
      failedPost: "تعذّر ترحيل المصروف",
      failedOptions: "تعذّر تحميل الأنواع والحسابات",
      failedCars: "تعذّر تحميل قائمة المركبات — القائمة فارغة بسبب خطأ لا لعدم وجود المركبة. أعد المحاولة.",
      carsTruncated: "قائمة المركبات معروضة حتى {count} مركبة فقط — إن لم تجد اللوحة المطلوبة فالقائمة غير كاملة، ولا تختر مركبة أخرى.",
      categories: {
        periodic: "صيانة دورية",
        repair: "إصلاح عطل",
        tyres: "إطارات",
        oil: "زيوت وفلاتر",
        insurance: "تأمين",
        licensing: "ترخيص ورسوم",
        other: "أخرى",
      },
    },
  },
  menu: {
    transferCenters: "مراكز الشحن",
    driversAccounting: "محاسبة السائقين",
    transferCentersAccounting: "محاسبة مراكز الشحن",
    carOwners: "مالكو السيارات",
    businessBalances: "أرصدة محافظ الأعمال",
    passengerWallets: "محافظ الركاب",
    transfers: "التحويلات",
    driversTransfers: "تحويلات السائقين",
    transferCentersTransfers: "تحويلات مراكز الشحن",
    finance: "المالية",
    captainLedger: "كشف حساب السائق",
    chartOfAccounts: "دليل الحسابات",
    journalEntries: "قيود اليومية",
    assets: "الأصول",
    adjustments: "التعديلات",
    reportCatalog: "دليل التقارير",
    financeReports: "التقارير المالية",
    trialBalance: "ميزان المراجعة",
    balanceSheet: "قائمة المركز المالي",
    incomeStatement: "قائمة الدخل",
    generalJournalSummary: "سجل اليومية العامة المجمع",
    driverStatement: "كشف حساب السائق (الرحلات)",
    cashFlowStatement: "قائمة التدفقات النقدية",
    equityChanges: "التغيرات في حقوق الملكية",
    accountStatement: "كشف حساب مفصّل",
    accountingBalance: "ميزان المحاسبة",
    accountsInventory: "جرد الحسابات",
    autoEntries: "القيود التلقائية",
    periodLocks: "إقفال الفترات",
    employees: "الموظفون والرواتب",
    transferAgent: "مندوب الشحن",
    paymentMethods: "طرق الدفع",
    headers: {
      main: "الرئيسية",
      people: "الأشخاص",
      financialMarketing: "المالية والتسويق",
      operationsConfig: "العمليات والإعدادات",
    },
    requests: "الطلبات",
    createBooking: "إنشاء حجز",
    bookings: "الحجوزات",
    bookingComplaints: "شكاوى الحجوزات",
    userComplaints: "شكاوى المستخدمين",
    tracking: "التتبع",
    staff: "الموظفون",
    roles: "الصلاحيات",
    drivers: "السائقون",
    passengers: "الركاب",
    normal: "عادي",
    businessAccounts: "محافظ الأعمال",
    accounting: "المحاسبة",
    statistics: "الإحصائيات",
    vouchers: "القسائم",
    marketingVouchers: "قسائم تسويقية",
    personalVouchers: "قسائم شخصية",
    passengersMarketing: "تسويق الركاب",
    services: "الخدمات",
    cameras: "الكاميرات (الرحلة الآمنة)",
    zones: "المناطق",
    cancellationReasons: "أسباب الإلغاء",
    cars: "السيارات",
    carBrands: "ماركات السيارات",
    carColors: "ألوان السيارات",
    carMaintenance: "الصيانة",
    settings: "الإعدادات",
  },
  // Accountant doc 2026-10-03 item 1.9: the Snap charge center gift channel.
  snapCenterGifts: {
    isCompany: "مركز شحن تابع للشركة (مركز شحن سناب)",
    isCompanyHint: "يتيح للمركز إرسال هدايا من رصيد هدايا مستقل عن رصيده النقدي، وتُقيَّد كل هدية مصروفاً على الشركة (مدين 51413 هدايا / دائن المستفيد)",
    yes: "نعم",
    no: "لا",
    giftBalance: "رصيد الهدايا",
    addGiftBudget: "تعديل رصيد الهدايا",
    dialogTitle: "رصيد هدايا مركز الشحن",
    dialogHint: "تمويل رصيد الهدايا لا يولّد قيداً محاسبياً، ويُقيَّد المصروف عند إرسال كل هدية. التخفيض يُستخدم لتصحيح خطأ ولا يجعل الرصيد سالباً.",
    currentBalance: "رصيد الهدايا الحالي",
    amount: "المبلغ (ل.س)",
    notes: "ملاحظة",
    add: "إضافة",
    reduce: "تخفيض (تصحيح)",
    cancel: "إلغاء",
    amountInvalid: "أدخل مبلغاً موجباً",
    savedToast: "تم تعديل رصيد الهدايا",
    failedToast: "تعذر تعديل رصيد الهدايا",
    companyOnTitle: "تحويل المركز إلى مركز تابع للشركة",
    companyOnConfirm: "سيتمكن هذا المركز من إرسال هدايا من رصيد الهدايا، وتُقيَّد كمصروف على الشركة. هل تريد المتابعة؟",
    companyOffTitle: "إلغاء صفة المركز التابع للشركة",
    companyOffConfirm: "لن يتمكن هذا المركز من إرسال الهدايا بعد الآن، ويبقى رصيد الهدايا محفوظاً. هل تريد المتابعة؟",
    companyChangedToast: "تم تحديث نوع المركز",
    companyChangeFailed: "تعذر تحديث نوع المركز",
    tabGiftMovements: "حركات رصيد الهدايا",
    type: "النوع",
    typeBUDGET_TOPUP: "تمويل",
    typeBUDGET_REDUCTION: "تخفيض",
    typeGIFT: "هدية",
    balanceAfter: "الرصيد بعد العملية",
    recipient: "المستفيد",
    recipientCaptain: "سائق",
    recipientPassenger: "راكب",
    operation: "رقم العملية",
    recipientId: "رقم المستفيد",
    recipientBusiness: "منشأة",
    user: "بواسطة",
    date: "التاريخ",
  },
  // Accountant doc 2026-10-03 item 1.5: automatic cancellation compensation.
  cancellationCompensation: {
    title: "تعويض إلغاء الرحلة للسائق",
    basis: "أساس قياس المسافة",
    statusBefore: "حالة الطلب لحظة الإلغاء",
    gpsKm: "مسافة الاقتراب حسب GPS",
    referenceKm: "مسافة الاقتراب المرجعية (من موقع بدء التحرك)",
    referenceSource: "مصدر المسافة المرجعية",
    arrivedAtPickup: "ضغط \"وصلت\" قرب نقطة الالتقاط",
    metersFromPickup: "{m} م من نقطة الالتقاط",
    yes: "نعم",
    no: "لا",
    processNow: "معالجة التعويض الآن",
    processNowHint: "لم تُنفَّذ مهمة التعويض التلقائي لهذا الطلب. يطبّق هذا الزر القاعدة التلقائية نفسها الآن، ولا يدفع مرتين.",
    processed: "تمت معالجة التعويض",
    processFailed: "تعذّرت معالجة التعويض",
    capKm: "الحد الأعلى المعتمد للمسافة",
    approachKm: "مسافة الاقتراب المعتمدة",
    freeKm: "المسافة المجانية",
    billableKm: "الكيلومترات المستحقة",
    rate: "القيمة عن كل كيلومتر",
    amount: "مبلغ التعويض",
    journalEntry: "القيد المحاسبي",
    grantedBy: "منحه يدوياً",
    grantedAt: "تاريخ المنح",
    note: "ملاحظة",
    error: "الخطأ",
    kmUnit: "كم",
    grantKm: "مسافة الاقتراب (كم)",
    grantKmHint: "المسافة التي قطعها السائق نحو الراكب حسب تقديرك (من الخريطة مثلاً)",
    grantNote: "ملاحظة (اختياري)",
    grant: "منح التعويض يدوياً",
    grantPreview: "التعويض المتوقع: {amount} ل.س",
    granted: "تم منح التعويض وإضافته إلى محفظة السائق",
    grantFailed: "تعذّر منح التعويض",
    loadFailed: "تعذّر تحميل بيانات تعويض الإلغاء",
    codes: {
      GRANTED: "دُفع التعويض",
      BELOW_THRESHOLD: "دون المسافة المجانية",
      NO_DATA: "لا توجد بيانات مسافة",
      FAILED: "فشلت المعالجة",
      DISABLED: "التعويض غير مفعّل",
      NOT_CANCELLED: "الطلب غير ملغى",
      CAPTAIN_CANCELLED: "ألغاه السائق",
      SYSTEM_CANCELLED: "ألغاه النظام",
      CC_EXCLUDED: "إلغاء مركز الاتصال غير مشمول",
      BEFORE_START: "قبل تحرّك السائق",
      REDISTRIBUTED: "تحويل إلى طلب فوري",
      NOT_PROCESSED: "لم يُعالَج",
    },
    explain: {
      GRANTED: "أُضيف التعويض إلى محفظة السائق وقُيِّد على الشركة (مدين 503 / دائن الحساب الفرعي للسائق).",
      BELOW_THRESHOLD: "مسافة اقتراب السائق لم تتجاوز المسافة المجانية، فلا يستحق تعويضاً.",
      NO_DATA: "تعذّر قياس مسافة اقتراب السائق (لا يوجد GPS ولا مسافة مقدّرة ولا مواقع في سجل الحالات). يمكن لمن يملك صلاحية التسويات المالية منح التعويض يدوياً بمسافة يحددها.",
      FAILED: "حدث خطأ أثناء معالجة التعويض ولم يُدفع أي مبلغ. يمكن منحه يدوياً.",
      DISABLED: "آلية التعويض التلقائي متوقفة من الإعدادات، فلم يُدفع أي تعويض.",
      NOT_CANCELLED: "التعويض يخص الطلبات الملغاة فقط.",
      CAPTAIN_CANCELLED: "السائق هو من ألغى الطلب، فلا يستحق تعويضاً.",
      SYSTEM_CANCELLED: "ألغى النظام الطلب قبل إسناده لسائق، فلا يوجد من يُعوَّض.",
      CC_EXCLUDED: "ألغى مركز الاتصال الطلب، وإلغاءات المركز غير مشمولة بالتعويض حسب الإعدادات.",
      BEFORE_START: "أُلغي الطلب قبل أن يبدأ السائق التحرّك نحو الراكب، فلا يستحق تعويضاً.",
      REDISTRIBUTED: "حوّل الراكب الحجز المسبق إلى طلب فوري، وهذا استبدال للطلب لا إلغاء.",
      NOT_PROCESSED: "الطلب مستحق للتعويض لكنه لم يُعالَج (أُلغي قبل تفعيل الآلية أو لم تُنفَّذ مهمة الطابور). يمكن لمن يملك صلاحية التسويات المالية معالجته الآن أو منحه يدوياً بمسافة يحددها.",
    },
    bases: {
      GPS_APPROACH: "مسار GPS الفعلي للسائق نحو الراكب",
      ARRIVED_FULL_APPROACH: "وصل السائق إلى نقطة الالتقاط: كامل مسافة الاقتراب من موقع بدء التحرك",
      STATUS_POINTS: "خط مستقيم بين موقعي السائق في سجل الحالات",
      MANUAL: "مسافة أدخلها مسؤول يدوياً",
      NONE: "لا يوجد",
    },
    referenceSources: {
      ESTIMATED_ROUTE_AT_START: "المسار المقدّر لحظة بدء التحرك",
      STARTED_TO_PICKUP_STRAIGHT_LINE: "خط مستقيم من موقع بدء التحرك إلى نقطة الالتقاط",
      ACCEPT_TIME_DRIVER_DISTANCE: "المسافة لحظة القبول (بدأ التحرك خلال 10 دقائق من القبول)",
    },
  },
  conversation: {
    title: "المحادثة",
    callLog: "سجل المكالمات",
    export: "تصدير المحادثة",
    noMessages: "لا توجد رسائل في هذه المحادثة.",
    noCalls: "لا توجد مكالمات لهذه الرحلة.",
    passenger: "الراكب",
    captain: "السائق",
    closed: "مغلقة",
    active: "نشطة",
    sentAt: "أُرسلت في",
    caller: "المتصل",
    callee: "المُتَّصَل به",
    status: "الحالة",
    duration: "المدة",
    startedAt: "بدأت",
    answeredAt: "تم الرد",
    endedAt: "انتهت",
    failReason: "السبب",
  },
  accountingPage: {
    searchNameOrAccount: "بحث بالاسم أو رقم الحساب (أو آخر خاناته)",
    performedBy: "الموظف المنفّذ",
    driversAccountingTitle: "محاسبة السائقين",
    transferCentersAccountingTitle: "محاسبة مراكز الشحن",
    driversDonePaymentsTitle: "مدفوعات السائقين المنجزة",
    driversPendingPaymentsTitle: "مدفوعات السائقين المعلّقة",
    transferCentersDonePaymentsTitle: "مدفوعات مراكز الشحن المنجزة",
    transferCentersPendingPaymentsTitle: "مدفوعات مراكز الشحن المعلّقة",
    driversTransfersTitle: "تحويلات السائقين",
    transferCentersTransfersTitle: "تحويلات مراكز الشحن",
    tabPending: "قيد الانتظار",
    tabDone: "منجزة",
    search: "بحث",
    noData: "لا توجد بيانات",
    firstName: "الاسم الأول",
    lastName: "الاسم الأخير",
    phone: "الهاتف",
    email: "البريد الإلكتروني",
    name: "الاسم",
    type: "النوع",
    balance: "الرصيد",
    actions: "الإجراءات",
    date: "التاريخ",
    amount: "المبلغ",
    user: "المستخدم",
    userType: "نوع المستخدم",
    userName: "اسم المستخدم",
    userEmail: "بريد المستخدم الإلكتروني",
    driverName: "اسم السائق",
    driverPhone: "رقم هاتف السائق",
    accountCode: "رقم حساب السائق",
    centerAccountCode: "رقم حساب مركز الشحن",
    transferCenterName: "اسم مركز الشحن",
    transferCenterPhone: "هاتف مركز الشحن",
    typeInternal: "سناب درايفر",
    typeExternal: "خارجي",
    typeDriver: "السائق",
    typeUser: "مستخدم",
    addTransfer: "إضافة تحويل",
    removeBalance: "سحب رصيد",
    addBalance: "إضافة رصيد",
    from: "من",
    to: "إلى",
    getData: "جلب البيانات",
    exportCsv: "تصدير CSV",
    transferAdded: "تمت إضافة التحويل بنجاح",
    transferAddedBalance: "تمت إضافة التحويل. الرصيد الجديد: {after} (السابق: {before})",
    errorOccurred: "حدث خطأ",
    requiredField: "هذا الحقل مطلوب",
    positiveNumber: "يجب أن يكون رقماً موجباً",
    invalidLength: "عدد الأحرف غير صالح، المطلوب {len}",
    selectDateRange: "يرجى اختيار نطاق زمني",
    fromBeforeTo: "يجب أن يكون تاريخ البداية قبل تاريخ النهاية",
  },
  accountingShared: {
    requiredField: "هذا الحقل مطلوب",
    mustBePositive: "يجب أن تكون القيمة موجبة",
    invalidValue: "قيمة غير صالحة",
    amount: "المبلغ",
    date: "التاريخ",
    time: "الوقت",
    note: "ملاحظة",
    submit: "إرسال",
    saved: "تم الحفظ",
    captain: "الكابتن",
    passenger: "الراكب",
    company: "الشركة",
    currency: "ل.س",
    proceedPaymentClosing: "إتمام إغلاق الدفعة",
    paymentCompletedUsing: "طريقة إتمام الدفع",
    bank: "مصرف",
    cash: "نقدي",
    chooseCashRegister: "اختر الصندوق النقدي",
    paidNotEqualClosing: "المبلغ المدفوع لا يساوي مبلغ الإغلاق",
    continueBtn: "متابعة",
    bonusType: "نوع المكافأة",
    onCaptainPassenger: "على الكابتن / الراكب",
    other: "أخرى",
    km: "كم",
    hour: "ساعة",
    noteForCaptain: "ملاحظة (تظهر للكابتن)",
    detailsForManagement: "التفاصيل (للإدارة)",
    bonusRequestSent: "تم إرسال طلب المكافأة وهو بحاجة إلى موافقة الإدارة",
    onRide: "على رحلة",
    onBooking: "على حجز",
    bookingId: "رقم الحجز",
    unit: "الوحدة",
    rideId: "رقم الرحلة",
    refunder: "جهة رد المبلغ",
    repay: "رد المبلغ",
    captainRefundDone: "تم رد المبلغ للكابتن بنجاح",
    passengerRefundDone: "تم رد المبلغ للراكب بنجاح",
    serverError: "فشلت العملية، خطأ في الخادم",
    reportTitle: "التقرير",
    show: "عرض",
    week: "الأسبوع",
    captainId: "معرف الكابتن",
    paymentId: "معرف الدفعة",
    from: "من",
    to: "إلى",
    ratingSummary: "({avg} من أصل {count} تقييم)",
    noRatings: "لا توجد تقييمات",
    restFromOldPayments: "المتبقي من دفعات سابقة",
    revenue: "الإيراد",
    meters: "العدادات",
    bonus: "المكافأة",
    due: "المستحق",
    profit: "الربح",
    cashReceived: "النقد المستلم",
    tips: "الإكراميات",
    penaltiesOn: "غرامات على الكابتن",
    penaltiesFor: "غرامات لصالح الكابتن",
    closingBalance: "رصيد الإغلاق",
    paymentDetails: "تفاصيل الدفعة",
    reason: "البند",
    quantity: "الكمية",
    earnings: "الأرباح",
    actions: "الإجراءات",
    details: "التفاصيل",
    dialogDetails: "تفاصيل {type}",
    warning: "تحذير",
    confirmQuestion: "هل أنت متأكد أنك تريد {action}؟",
    iAccept: "موافق",
    revokeRideEntries: "إلغاء قيود الرحلة",
    undoRevokeRideEntries: "التراجع عن إلغاء قيود الرحلة",
    revokeBonus: "إلغاء المكافأة",
    revokePenalty: "إلغاء الغرامة",
    revokeRideEntryAction: "إلغاء قيد هذه الرحلة",
    undoRevokeRideEntryAction: "التراجع عن إلغاء قيد هذه الرحلة",
    revokeBonusAction: "إلغاء هذه المكافأة",
    revokePenaltyAction: "إلغاء هذه الغرامة",
    invalidRange: "نطاق التاريخ غير صالح",
    failedGetReport: "تعذر جلب التقرير المطلوب",
    typeRides: "الرحلات",
    typeHours: "الساعات",
    typeRidesKm: "عداد كيلومترات الرحلات",
    typeGhostRidesKm: "عداد كيلومترات الرحلات الوهمية",
    typeBonus: "المكافآت",
    typePenalties: "الغرامات",
    typeBookings: "الحجوزات",
  },
  businessPage: {
    pageTitle: "محافظ الأعمال",
    tabRegistered: "المسجّلة",
    tabPending: "قيد الانتظار",
    tabBusinesses: "المنشآت",
    registeredTitle: "محافظ الأعمال المسجّلة",
    pendingTitle: "محافظ الأعمال قيد الانتظار",
    colId: "المعرف",
    colFullName: "الاسم الكامل",
    colBusinessName: "اسم المنشأة",
    colEmployeeEstablishment: "منشأة الموظف",
    colAccountNumber: "رقم الحساب",
    colAccountCode: "رقم حساب المنشأة",
    colPhoneNumber: "رقم الهاتف",
    colEmail: "البريد الإلكتروني",
    colAccountStatus: "حالة الحساب",
    colCreationDate: "تاريخ الإنشاء",
    viewProfile: "عرض الملف الشخصي",
    genderMale: "ذكر",
    genderFemale: "أنثى",
    searchLabel: "البحث عن منشأة (الاسم / النوع)",
    addBusiness: "إضافة منشأة",
    editBusiness: "تعديل المنشأة",
    pendingRechargeRequests: "طلبات شحن الرصيد قيد الانتظار",
    approve: "قبول",
    reject: "رفض",
    syp: "ل.س",
    active: "نشط",
    disabled: "معطّل",
    recharge: "شحن رصيد",
    edit: "تعديل",
    log: "السجل",
    docs: "المستندات",
    disable: "تعطيل",
    enable: "تفعيل",
    noAccounts: "لا توجد محافظ أعمال",
    name: "الاسم",
    type: "النوع",
    phoneNumber: "رقم الهاتف",
    email: "البريد الإلكتروني",
    address: "العنوان",
    maxPerOrderLabel: "الحد الأقصى لكل طلب (ل.س، اتركه فارغاً = غير محدود)",
    dailyLimitLabel: "الحد اليومي (ل.س، اتركه فارغاً = غير محدود)",
    status: "الحالة",
    allowAddEmployees: "السماح بإضافة موظفين",
    allowGuestForm: "السماح بنموذج طلبات الضيوف",
    cancel: "إلغاء",
    save: "حفظ",
    rechargeTitle: "شحن رصيد {name}",
    balance: "الرصيد",
    amountToAdd: "المبلغ المراد إضافته (ل.س)",
    noteHint: "ملاحظة (مثال: مرجع الحوالة المصرفية)",
    addBalance: "إضافة رصيد",
    transactionsTitle: "حركات حساب {name}",
    noTransactions: "لا توجد حركات بعد",
    documentsTitle: "مستندات {name}",
    view: "عرض",
    download: "تنزيل",
    delete: "حذف",
    noDocuments: "لا توجد مستندات",
    addDocument: "إضافة مستند",
    titleOptional: "العنوان (اختياري)",
    chooseFile: "اختيار ملف",
    upload: "رفع",
    docHint: "PDF, JPG, PNG, DOC/DOCX — بحجم أقصى 10MB. مرئية للمشرفين فقط.",
    close: "إغلاق",
    colBusiness: "المنشأة",
    colAmount: "المبلغ",
    colNote: "ملاحظة",
    colDate: "التاريخ",
    colName: "الاسم",
    colType: "النوع",
    colBalance: "الرصيد",
    colMaxPerOrder: "الحد الأقصى/طلب",
    colDaily: "الحد اليومي",
    colStatus: "الحالة",
    colSize: "الحجم",
    typeHotel: "فندق",
    typeHospital: "مشفى",
    typeCompany: "شركة",
    typeRestaurant: "مطعم",
    typeOffice: "مكتب",
    typeOther: "أخرى",
    statusPending: "قيد الانتظار",
    statusApproved: "مقبول",
    statusDisabled: "معطّل",
    txRecharge: "شحن رصيد",
    txDebitBooking: "خصم حجز",
    txAdjustment: "تعديل يدوي",
    toastApproved: "تمت الموافقة وشحن الرصيد",
    toastRejected: "تم الرفض",
    toastFailed: "فشلت العملية",
    toastFailedLoad: "فشل تحميل البيانات",
    toastNameRequired: "الاسم مطلوب",
    toastSaved: "تم الحفظ",
    toastEnterAmount: "أدخل مبلغاً",
    toastBalanceAdded: "تمت إضافة الرصيد",
    toastUploaded: "تم رفع المستند",
    toastUploadFailed: "فشل رفع المستند",
    toastFailedOpen: "فشل فتح المستند",
    toastFailedDownload: "فشل تنزيل المستند",
    toastDeleted: "تم الحذف",
  },
  captainProfilePage: {
    common: {
      required: "مطلوب",
      firstName: "الاسم الأول",
      lastName: "الاسم الأخير",
      date: "التاريخ",
      datetime: "التاريخ والوقت",
      status: "الحالة",
      stationId: "معرف المحطة",
      passenger: "الراكب",
      pickUpLocation: "موقع الانطلاق",
      dropOffLocation: "موقع الوصول",
      rating: "التقييم",
      price: "السعر",
      booking: "الحجز",
      bookingId: "معرف الحجز",
      id: "المعرف",
      logId: "معرف السجل",
      cancel: "إلغاء",
      delete: "حذف",
      orderDetails: "تفاصيل الطلب",
      loadingData: "جارٍ تحميل البيانات",
      errorTryLater: "حدث خطأ، يرجى المحاولة لاحقاً",
    },
    profile: {
      pageTitle: "ملف الكابتن",
      accept: "قبول",
      tabDriver: "السائق",
      tabCar: "السيارة",
      tabTrips: "الرحلات",
      tabPayments: "المدفوعات",
      tabServices: "الخدمات",
      information: "المعلومات",
      phoneNumber: "رقم الهاتف",
      email: "البريد الإلكتروني",
      type: "النوع",
      gender: "الجنس",
      male: "ذكر",
      female: "أنثى",
      typeInternal: "سناب درايف",
      typeExternal: "خارجي",
      documents: "المستندات",
      uploadLicenseFront: "رفع صورة رخصة القيادة (الوجه الأمامي)",
      uploadLicenseBack: "رفع صورة رخصة القيادة (الوجه الخلفي)",
      uploadIdFront: "رفع صورة البطاقة الشخصية (الوجه الأمامي)",
      uploadIdBack: "رفع صورة البطاقة الشخصية (الوجه الخلفي)",
      licenseFront: "صورة رخصة القيادة (الوجه الأمامي)",
      licenseBack: "صورة رخصة القيادة (الوجه الخلفي)",
      idCardFront: "البطاقة الشخصية (الوجه الأمامي)",
      idCardBack: "البطاقة الشخصية (الوجه الخلفي)",
      document: "المستند",
      action: "الإجراء",
      view: "عرض",
      noDocuments: "لا توجد مستندات مرفوعة.",
      save: "حفظ",
      brand: "الماركة",
      model: "الموديل",
      color: "اللون",
      plateNumber: "رقم اللوحة",
      vehicleType: "نوع المركبة",
      vehicleTypeCar: "سيارة",
      vehicleTypeMotorcycle: "دراجة نارية",
      manufactureYear: "سنة الصنع",
      carOwnership: "ملكية السيارة",
      carOwner: "مالك السيارة",
      ownershipDriver: "نموذج الوكيل - سيارة الغير (يملكها السائق)",
      ownershipCompany: "نموذج الأصيل - سيارة الشركة",
      ownershipOther: "نموذج مالكي السيارات - سيارة مالك مسجّل",
      addOwnersHint: "أضف المالكين من صفحة مالكي السيارات",
      saveCarInfo: "حفظ معلومات السيارة",
      carPicture: "صورة السيارة",
      changeCarPicture: "تغيير صورة السيارة",
      noCarPicture: "لا توجد صورة سيارة مرفوعة.",
      addService: "إضافة خدمة",
      selectService: "اختر الخدمة",
      add: "إضافة",
      block: "حظر",
      unblock: "إلغاء الحظر",
      blockDaily: "حظر (من 7 صباحاً حتى 7 مساءً)",
      unblockDaily: "إلغاء الحظر (من 7 صباحاً حتى 7 مساءً)",
      constraintsSaved: "تم حفظ القيود",
      checkYourInfo: "تحقق من المعلومات المدخلة",
      pickCarOwner: "اختر مالك السيارة",
      noCarYetFill: "لا توجد سيارة لهذا الكابتن بعد — يرجى تعبئة: {fields}",
      savedSuccessfully: "تم الحفظ بنجاح",
      carCreated: "تم إنشاء السيارة بنجاح",
      failedLoadServices: "فشل تحميل الخدمات",
      pleaseSelectService: "يرجى اختيار خدمة",
      serviceAdded: "تمت إضافة الخدمة بنجاح",
      failedAddService: "فشلت إضافة الخدمة",
      serviceRemoved: "تمت إزالة الخدمة بنجاح",
      failedRemoveService: "فشلت إزالة الخدمة",
      saved: "تم الحفظ",
      somethingWentWrong: "حدث خطأ ما!",
      pleaseCheckAllFields: "يرجى التحقق من جميع الحقول",
      captainAccepted: "تم قبول الكابتن",
      deleteConfirmation: "تأكيد الحذف",
      deleteConfirmText: "هل أنت متأكد من حذف {name}؟",
      thisService: "هذه الخدمة",
      changeTime: "وقت التغيير",
      clientName: "اسم الزبون",
      serviceName: "اسم الخدمة",
      active: "نشط",
      welcomeBonusLabel: "الرصيد الترحيبي",
      welcomeBonusHint: "رصيد مقيّد يُمنح عند الموافقة: يغطي عمولة الشركة فقط ولا يمكن سحبه أو تحويله",
      welcomeBonusGrantedAt: "تاريخ المنح",
      welcomeBonusStatusActive: "مفعّل",
      welcomeBonusLocked: "هذا المبلغ غير قابل للتعديل بعد الموافقة",
    },
    payments: {
      title: "المدفوعات",
      meterPrice: "سعر العداد",
      driverShareOfTotal: "حصة السائق (من الإجمالي)",
      companyPercent: "إيراد العمولة %",
      driverPercent: "نسبة السائق %",
      ownerPercent: "نسبة المالك %",
      companyAmount: "مبلغ الشركة",
      afterCommission: "بعد العمولة",
      driverAmount: "مبلغ السائق",
      driverCommission: "عمولة السائق",
      ownerCut: "إيراد الرحلة",
      voucher: "القسيمة",
      discountAmount: "مبلغ الحسم",
      paymentType: "طريقة الدفع",
      paymentSource: "مصدر الدفع",
      paymentDate: "تاريخ الدفع",
      entityType: "نوع الكيان",
      entityId: "معرف الكيان",
      user: "المستخدم",
      userType: "نوع المستخدم",
      driver: "السائق",
      businessPayer: "منشأة - {name}",
      paymentTypeWelcomeBonus: "تغطية عمولة من الرصيد الترحيبي",
      paymentTypeCancellationCompensation: "تعويض إلغاء رحلة",
    },
    // Owner item 2.1: the restricted welcome balance card of the captain
    // profile (summary, close / approve / cancel, movements) and the
    // approval-time amount.
    welcomeBonus: {
      title: "الرصيد الترحيبي (مقيّد)",
      granted: "الممنوح",
      consumed: "المستخدم لتغطية العمولة",
      remaining: "المتبقي",
      grantedAt: "تاريخ المنح",
      expiresAt: "ينتهي في",
      neverExpires: "بلا تاريخ انتهاء",
      closedAt: "تاريخ الإغلاق",
      statusActive: "فعّال",
      statusExhausted: "مستنفَد",
      statusExpired: "منتهي الصلاحية",
      statusRevoked: "ملغى",
      restrictedNote: "رصيد مقيّد: يغطي عمولة الشركة فقط، ولا يمكن سحبه أو تحويله",
      closeButton: "إغلاق الرصيد المتبقي",
      closeTitle: "إغلاق الرصيد الترحيبي المتبقي",
      closeIntro: "سيُغلق المتبقي ({amount}) ويُعكس قيده في الحسابات. الجزء المستخدم نهائي، ولا تتغير محفظة الكابتن.",
      closeApprovalNote: "إذا تجاوز المتبقي حد الموافقة الثانية المحدد في الإعدادات، ينتظر الإغلاق موافقة مستخدم آخر.",
      kindLabel: "نوع الإغلاق",
      kindRule: "اختر نوع الإغلاق",
      kindRevoke: "إلغاء",
      kindExpire: "انتهاء الصلاحية",
      kindGrant: "منح",
      kindConsume: "تغطية عمولة",
      reason: "السبب",
      reasonRule: "اكتب سبباً من 3 إلى 500 حرف",
      closeSubmit: "إغلاق الرصيد",
      closed: "تم إغلاق الرصيد الترحيبي المتبقي",
      closePending: "أُرسل طلب الإغلاق للموافقة",
      closeFailed: "تعذّر إغلاق الرصيد الترحيبي",
      pendingTitle: "طلب إغلاق بانتظار الموافقة",
      pendingDetail: "{kind}: {amount}، طلبه {name} بتاريخ {date}",
      approve: "موافقة",
      approveTitle: "الموافقة على إغلاق الرصيد الترحيبي",
      approveConfirm: "سيُغلق المتبقي ({amount}) نهائياً. لا يستطيع صاحب الطلب الموافقة عليه بنفسه.",
      approved: "تمت الموافقة وأُغلق الرصيد المتبقي",
      approveFailed: "تعذّرت الموافقة على الإغلاق",
      cancelRequest: "إلغاء الطلب",
      cancelTitle: "إلغاء طلب الإغلاق",
      cancelConfirm: "يبقى الرصيد الترحيبي كما هو.",
      cancelled: "أُلغي طلب الإغلاق",
      cancelFailed: "تعذّر إلغاء طلب الإغلاق",
      noPermission: "ليست لديك صلاحية لهذا الإجراء",
      movements: "حركات الرصيد الترحيبي",
      movementsFailed: "تعذّر تحميل حركات الرصيد الترحيبي",
      noMovements: "لا توجد حركات",
      movement: "الحركة",
      amount: "المبلغ",
      remainingBefore: "المتبقي قبل",
      remainingAfter: "المتبقي بعد",
      by: "بواسطة",
      approvedBy: "وافق عليه",
      overrideWhole: "أدخل مبلغاً بحد أقصى خانتين عشريتين",
      overrideAboveMax: "الحد الأعلى للرصيد الترحيبي هو {max}",
      overrideHint: "مبلغ بحد أقصى خانتين عشريتين",
      overrideHintMax: "مبلغ بحد أقصى خانتين عشريتين، بحد أعلى {max}",
      overrideNeedsPermission: "تعديل المبلغ يحتاج صلاحية إدارة الرصيد الترحيبي",
    },
    complaints: {
      category: "الفئة",
      count: "العدد",
      close: "إغلاق",
      submit: "إرسال",
      chooseBooking: "يرجى اختيار حجز",
      chooseCategory: "يرجى اختيار فئة",
    },
    schedule: {
      deleteShiftConfirm: "هل تريد حذف هذه المناوبة؟",
      available: "متاح",
      mustBeSameDay: "يجب أن تكون المناوبة ضمن اليوم نفسه",
    },
    chart: {
      filterByMonth: "تصفية حسب الشهر",
      ok: "موافق",
      type: "النوع",
      typeAll: "الكل",
      typeReservation: "حجز مسبق",
      typeShort: "قصيرة",
      typeInstant: "فورية",
      wrongLocation: "موقع خاطئ",
      clientPickup: "صعود الزبون",
      cancelledByDriver: "إلغاء من السائق",
      totalOrders: "إجمالي الطلبات",
      cancelledOrders: "الطلبات الملغاة",
      completedOrders: "الطلبات المكتملة",
      totalShifts: "إجمالي المناوبات",
      bookingsRate: "معدل حجوزات شهر {month}",
      favoriteShift: "المناوبة المفضلة",
    },
    shiftLogs: {
      filterByDay: "تصفية حسب اليوم",
      offline: "غير متصل",
      online: "متصل",
      from: "من",
      to: "إلى",
      getData: "جلب البيانات",
      datesInvalid: "التواريخ غير صالحة",
      tabTitle: "ساعات العمل",
    },
  },
  captainCreatePage: {
    pageTitleCaptains: "الكباتن",
    pageTitleCarRequests: "طلبات السيارات",
    pageTitleCars: "السيارات",
    driverTab: "السائق",
    vehicleTab: "المركبة",
    driverPersonalInfo: "المعلومات الشخصية للسائق",
    documentsInfo: "معلومات الوثائق",
    vehicleInformation: "معلومات المركبة",
    firstName: "الاسم الأول",
    lastName: "الاسم الأخير",
    phoneNumber: "رقم الهاتف",
    emailAddress: "البريد الإلكتروني",
    licenseNumber: "رقم الرخصة",
    gender: "الجنس",
    male: "ذكر",
    female: "أنثى",
    governorate: "المحافظة",
    nationalityId: "الرقم الوطني",
    profileImage: "الصورة الشخصية",
    idFront: "الهوية - الوجه الأمامي",
    idBack: "الهوية - الوجه الخلفي",
    drivingLicenseFront: "رخصة القيادة - الوجه الأمامي",
    drivingLicenseBack: "رخصة القيادة - الوجه الخلفي",
    proceed: "متابعة",
    selectBrand: "اختر الماركة",
    selectModel: "اختر الموديل",
    selectCarColor: "اختر لون السيارة",
    startTypingToSearch: "ابدأ الكتابة للبحث",
    plateNumber: "رقم اللوحة",
    vehicleType: "نوع المركبة",
    vehicleTypeCar: "سيارة",
    vehicleTypeMotorcycle: "دراجة نارية",
    optionalSuffix: "(اختياري)",
    carManufactureYear: "سنة صنع السيارة",
    carServices: "خدمات السيارة",
    carImage: "صورة السيارة",
    addCaptain: "إضافة كابتن",
    bluetoothBoxNumber: "رقم صندوق البلوتوث",
    vehicleTypes: "أنواع المركبات",
    constraints: "القيود",
    technicalControlExpiryDate: "تاريخ انتهاء الفحص الفني",
    renewalDocumentExpiryDate: "تاريخ انتهاء وثيقة التجديد",
    metrologicalLogExpiryDate: "تاريخ انتهاء سجل المعايرة",
    assurance: "وثيقة التأمين",
    registrationCertificate: "شهادة التسجيل",
    technicalControl: "الفحص الفني",
    renewalDocument: "وثيقة التجديد",
    metrologicalLog: "سجل المعايرة",
    addCar: "إضافة سيارة",
    ruleEmail: "يرجى إدخال بريد إلكتروني صالح",
    ruleLength: "طول الأحرف غير صالح، المطلوب {len}",
    rulePassword: "يجب أن تتكون كلمة المرور من 8 إلى 15 حرفاً.",
    rulePhone: "رقم الهاتف غير صالح!",
    ruleRequired: "هذا الحقل مطلوب",
    ruleUsernamePhone: "يجب أن يبدأ رقم الهاتف بالرقم 9 وأن يتكون من 9 أرقام",
    ruleNationalityId: "يجب أن يتكون الرقم الوطني من 11 رقماً",
    ruleLicense: "رقم الرخصة غير صالح",
    uploadAllImages: "يرجى رفع جميع الصور المطلوبة",
    captainAdded: "تمت إضافة الكابتن",
    captainCarAdded: "تمت إضافة سيارة الكابتن",
    checkYourInfo: "تحقق من المعلومات المدخلة",
    search: "بحث",
    id: "المعرف",
    captain: "الكابتن",
    brand: "الماركة",
    model: "الموديل",
    color: "اللون",
    number: "الرقم",
    insuranceExpire: "انتهاء التأمين",
    manuYear: "سنة الصنع",
    createdAt: "تاريخ الإنشاء",
    actions: "الإجراءات",
    approveCarTitle: "قبول السيارة",
    denyCarTitle: "رفض السيارة",
    approveHint: "إذا قبلت هذه السيارة فسيتمكن مالكها من استخدامها في وردياته",
    denyHint: "إذا رفضت هذه السيارة فلن يتمكن مالكها من استخدامها في وردياته ويجب تحديث معلومات السيارة لقبولها",
    denyReason: "سبب الرفض",
    denyReasonRequired: "سبب الرفض مطلوب",
    cancel: "إلغاء",
    approve: "قبول",
    deny: "رفض",
    newCar: "سيارة جديدة",
    carDocument: "وثيقة السيارة",
    noCarDocument: "لا توجد وثيقة سيارة",
    insuranceDocument: "وثيقة التأمين",
    noInsuranceDocument: "لا توجد وثيقة تأمين",
    insuranceExpiryDate: "تاريخ انتهاء التأمين",
    carOwnership: "ملكية السيارة",
    ownership: "الملكية",
    carOwner: "مالك السيارة",
    addOwnersHint: "أضف المالكين من صفحة مالكي السيارات",
    saveOwnership: "حفظ الملكية",
    driverOwnCar: "نموذج الوكيل - سيارة الغير (يملكها السائق)",
    companyCar: "نموذج الأصيل - سيارة الشركة",
    otherPersonCar: "نموذج مالكي السيارات - سيارة مالك مسجّل",
    setDefault: "تعيين كافتراضية",
    updateInsuranceInfo: "تحديث معلومات التأمين",
    create: "إنشاء",
    frontInsuranceImage: "صورة التأمين الأمامية",
    backInsuranceImage: "صورة التأمين الخلفية",
    pickCarOwner: "اختر مالك السيارة",
    ownershipSaved: "تم حفظ الملكية",
    failedToSave: "فشل الحفظ",
    fillAllFields: "يرجى تعبئة جميع الحقول",
    saved: "تم الحفظ",
  },
  captainsPage: {
    driversTitle: "السائقون",
    registeredTab: "المسجّلون",
    pendingTab: "قيد الانتظار",
    registeredDriversTitle: "السائقون المسجّلون",
    pendingDriversTitle: "السائقون قيد الانتظار",
    owner: "المالك",
    new: "جديد",
    autonome: "مستقل",
    normalMode: "عادي",
    male: "ذكر",
    female: "أنثى",
    snapDriver: "سناب درايفر",
    external: "خارجي",
    statusOnline: "متصل",
    statusOffline: "غير متصل",
    statusAtDestination: "عند الوجهة",
    statusBusy: "مشغول",
    creationDate: "تاريخ الإنشاء",
    email: "البريد الإلكتروني",
    wasApproved: "تمت الموافقة",
    firstName: "الاسم الأول",
    lastName: "الاسم الأخير",
    status: "الحالة",
    connectionStatus: "حالة الاتصال",
    phone: "الهاتف",
    gender: "الجنس",
    type: "النوع",
    licenseNumber: "رقم الرخصة",
    address: "العنوان",
    nationalityId: "الرقم الوطني",
    activeColumn: "نشط",
    averageRating: "متوسط التقييم",
    accountCode: "رقم حساب السائق",
    captainProfile: "ملف الكابتن",
    goToProfile: "الانتقال إلى الملف الشخصي",
    captainConfirmation: "تأكيد الكابتن",
    personalInfo: "المعلومات الشخصية",
    carInfo: "معلومات السيارة",
    contract: "العقد",
    finish: "إنهاء",
    previousStep: "السابق",
    approveAndSave: "الموافقة والحفظ",
    approveCaptain: "الموافقة على الكابتن",
  },
  // Owner item 3.1: the Active / Inactive / Banned state of a registered
  // driver or rider (drivers and riders lists, both profiles).
  accountState: {
    label: "حالة الحساب",
    all: "الكل",
    active: "فعال",
    inactive: "غير فعال",
    banned: "محظور",
    tips: {
      captain: {
        all: "جميع السائقين المقبولين أياً كان نشاطهم. طلبات الانضمام الجديدة في تبويب «قيد الانتظار».",
        active: "غير محظور، واتصل أو ردّ على طلب أو نفّذ رحلة خلال فترة النشاط.",
        inactive: "غير محظور، ولم يتصل ولم يردّ على أي طلب ولم ينفّذ أي رحلة خلال فترة النشاط.",
        banned: "محظور من الإدارة: لا يستطيع تسجيل الدخول.",
      },
      passenger: {
        all: "جميع الركاب في هذه القائمة أياً كان نشاطهم.",
        active: "غير محظور، وطلب رحلة واحدة على الأقل خلال فترة النشاط.",
        inactive: "غير محظور، ولم يطلب أي رحلة خلال فترة النشاط.",
        banned: "محظور من الإدارة: لا يستطيع تسجيل الدخول.",
      },
      window: "فترة النشاط: آخر {days} يوماً (من الإعدادات العامة).",
    },
    countsFailed: "تعذّر تحميل الأعداد",
    blocked: "تم حظر الحساب",
    unblocked: "تم إلغاء الحظر",
    blockTitle: "حظر السائق",
    blockCaptainConfirm: "هل أنت متأكد من حظر حساب هذا السائق؟",
    notePlaceholder: "سبب الحظر (اختياري، حتى 255 حرفاً)",
    noteLabel: "ملاحظة الحظر",
    activeRide: "لدى السائق رحلة جارية، يمكن حظره بعد انتهائها",
    alreadyBlocked: "هذا السائق محظور مسبقاً",
    blockFailed: "تعذّر تغيير حالة الحساب",
  },
  carOwnersPage: {
    pageTitle: "مالكو السيارات",
    searchLabel: "البحث عن مالك (الاسم / الهاتف)",
    newOwner: "مالك سيارة جديد",
    editOwner: "تعديل مالك السيارة",
    name: "الاسم",
    phone: "الهاتف",
    phoneNumber: "رقم الهاتف",
    notes: "ملاحظات",
    cars: "السيارات",
    drivers: "السائقون",
    balance: "الرصيد",
    syp: "ل.س",
    edit: "تعديل",
    settle: "تسوية",
    shares: "الحصص",
    noOwners: "لا يوجد مالكو سيارات",
    cancel: "إلغاء",
    save: "حفظ",
    settleTitle: "تسوية {name}",
    amountToPayOut: "المبلغ المراد دفعه (ل.س)",
    payOut: "دفع",
    sharesTitle: "{name} — إيراد الرحلة",
    noShares: "لا توجد حصص بعد",
    booking: "الحجز",
    driver: "السائق",
    amount: "المبلغ",
    date: "التاريخ",
    failedLoad: "فشل التحميل",
    nameRequired: "الاسم مطلوب",
    saved: "تم الحفظ",
    failed: "فشلت العملية",
    enterAmount: "أدخل مبلغاً",
    paidOut: "تم الدفع",
    accountCode: "رقم حساب المالك",
    carRef: "مرجع السيارة",
    fromDate: "من",
    toDate: "إلى",
    applyFilter: "تطبيق",
    exportExcel: "تصدير Excel",
    totalsTitle: "الإجماليات",
    dailyTotals: "الإجمالي اليومي",
    monthlyTotals: "الإجمالي الشهري",
    grandTotal: "الإجمالي الكلي",
    fromBeforeTo: "يجب أن يكون تاريخ البداية قبل تاريخ النهاية",
  },
  createBookingPage: {
    pageTitle: "إنشاء حجز",
    newOrder: "طلب جديد",
    newOrderSubtitle: "إرسال الطلبات عبر لوحة تحكم الإدارة",
    passengerName: "اسم الراكب",
    passengerNameError: "يرجى إدخال اسم الراكب",
    passengerPhone: "رقم هاتف الراكب",
    passengerPhoneError: "يرجى إدخال رقم هاتف صحيح",
    passengerEmail: "البريد الإلكتروني للراكب",
    passengerEmailError: "يرجى إدخال بريد إلكتروني صحيح",
    timeDate: "الوقت / التاريخ",
    pickup: "نقطة الانطلاق",
    pickupError: "يرجى اختيار نقطة انطلاق صحيحة",
    selectPickup: "اختر نقطة الانطلاق",
    destination: "الوجهة",
    destinationError: "يرجى اختيار وجهة صحيحة",
    voucherCode: "كود الحسم",
    specificDriver: "سائق محدد (اختياري)",
    specificDriverPlaceholder: "إرسال إلى سائق محدد (اختياري)",
    services: "الخدمات",
    serviceError: "يرجى اختيار خدمة",
    estimatedPrice: "السعر التقديري",
    loading: "جارٍ التحميل...",
    send: "إرسال",
    savedSuccessfully: "تم الحفظ بنجاح",
    errorOccurred: "حدث خطأ",
    cantLoadServices: "تعذّر تحميل الخدمات",
    createPhoneBooking: "إنشاء حجز هاتفي",
    choosePassenger: "اختر الراكب",
    createPassenger: "إنشاء راكب",
    enterPickupLocation: "أدخل موقع الانطلاق",
    enterPickupDetails: "أدخل تفاصيل نقطة الانطلاق",
    enterPullDownLocation: "أدخل موقع النزول",
    service: "الخدمة",
    chooseDate: "اختر التاريخ",
    chooseTime: "اختر الوقت",
    mobileNumberUsername: "رقم الهاتف المحمول (اسم المستخدم)",
    mobile: "رقم الهاتف",
    firstName: "الاسم الأول",
    lastName: "الاسم الأخير",
    gender: "الجنس",
    birthday: "تاريخ الميلاد",
    birthdate: "تاريخ الميلاد",
    save: "حفظ",
  },
  dashboardPage: {
    pageTitle: "لوحة التحكم",
    tabBasic: "أساسي",
    tabFinancial: "المالية",
    tabPassengers: "الركاب",
    tabCaptains: "الكباتن",
    tabMixed: "مختلط",
    tabOsm: "OSM",
    pendingRequests: "الطلبات قيد الانتظار",
    signupsToday: "التسجيلات اليوم",
    approvedPassengersToday: "الركاب المقبولون اليوم",
    unapprovedPassengersEver: "إجمالي الركاب غير المقبولين",
    unapprovedPassengersToday: "الركاب غير المقبولين اليوم",
    bookingsCountYesterday: "عدد الحجوزات أمس",
    incompleteBookingsYesterday: "الحجوزات غير المكتملة أمس",
    averageRatingToday: "متوسط التقييم اليوم",
    noRatingsToday: "لا توجد تقييمات اليوم",
    weeklyFinancial: "التقرير المالي الأسبوعي",
    from: "من",
    to: "إلى",
    revenue: "الإيراد",
    fee: "الرسوم",
    payroll: "الرواتب",
    discount: "الحسم",
    refund: "المبالغ المستردة",
    penalties: "الغرامات",
    bonusCaptain: "مكافآت الكباتن",
    bonusPassenger: "مكافآت الركاب",
    profit: "الربح",
    customizations: "التخصيصات",
    groupBy: "تجميع حسب",
    startDate: "تاريخ البداية",
    endDate: "تاريخ النهاية",
    day: "يوم",
    week: "أسبوع",
    month: "شهر",
    quarter: "ربع سنة",
    year: "سنة",
    bookings: "الحجوزات",
    successfulBookings: "الحجوزات الناجحة",
    rejectedBookings: "الحجوزات المرفوضة",
    acquiredVsApprovedPassengers: "الركاب المكتسبون مقابل المقبولين",
    activePassengers: "الركاب النشطون",
    passengersMonthDatetime: "الركاب (شهرياً) (وقت الحجز)",
    passengersWeekDatetime: "الركاب (أسبوعياً) (وقت الحجز)",
    passengersMonthCreation: "الركاب (شهرياً) (إنشاء الحجز)",
    passengersWeekCreation: "الركاب (أسبوعياً) (إنشاء الحجز)",
    bookingsCount: "عدد الحجوزات",
    acquiredPassengers: "الركاب المكتسبون",
    approvedPassengers: "الركاب المقبولون",
    labelConst: "دائمون",
    labelReturning: "عائدون",
    labelNew: "جدد",
    labelLost: "مفقودون",
    captainsFirstRide: "أول رحلة للكباتن",
    ghostVsMeterRide: "رحلات الشبح مقابل رحلات العداد",
    acquiredVsApprovedCaptains: "الكباتن المكتسبون مقابل المقبولين",
    activeCaptains: "الكباتن النشطون",
    onlineCaptains: "الكباتن المتصلون",
    captainsWeekCheckLog: "الكباتن (أسبوعياً) (سجل التواجد)",
    captainsMonthCheckLog: "الكباتن (شهرياً) (سجل التواجد)",
    captainsWeekRide: "الكباتن (أسبوعياً) (الرحلات)",
    captainsMonthRide: "الكباتن (شهرياً) (الرحلات)",
    captainsCount: "عدد الكباتن",
    avgGhostRide: "متوسط رحلات الشبح",
    avgMeterRide: "متوسط رحلات العداد",
    acquiredCaptains: "الكباتن المكتسبون",
    approvedCaptains: "الكباتن المقبولون",
    avgRating: "متوسط التقييم",
    captainRate: "تقييم الكابتن",
    passengerRate: "تقييم الراكب",
  },
  shared: {
    captainSearchFailed: "تعذّر البحث عن السائقين",
    fields: {
      actions: "الإجراءات",
      roles: "الأدوار",
      establishment_name: "اسم المنشأة",
      establishment_id: "معرّف المنشأة",
      status: "الحالة",
      doer: "المنفّذ",
      recipient: "المستلم",
      version: "رقم الإصدار",
      platform: "المنصة",
    },
    common: {
      loadFailed: "تعذر تحميل البيانات",
      search: "بحث",
      cancel: "إلغاء",
      save: "حفظ",
      saved: "تم الحفظ",
      from: "من",
      to: "إلى",
      date: "التاريخ",
      time: "الوقت",
      next: "التالي",
      other: "أخرى",
      apply: "تطبيق",
    },
    requestCard: {
      notApproved: "غير مقبول",
      withDocs: "مع وثائق",
      withoutDocs: "بدون وثائق",
      roundTrip: "ذهاب وإياب",
      requeued: "(أُعيد إلى قائمة الانتظار)",
      acceptedSuggestion: "قَبِل اقتراحاً",
      refusedSuggestion: "رفض اقتراحاً",
      noResponseSuggestion: "لم يرد على الاقتراح",
      noClass: "بدون فئة",
      eta: "(وصول متوقع +5)",
      withCaptain: "مع",
      creationTime: "وقت الإنشاء",
      stop: "توقف",
      voucher: "القسيمة",
      paxAccepted: "وافق الراكب",
      changeTo: "إلى",
      toVip: "إلى VIP",
      toFullCar: "إلى FC",
      toPooling: "إلى P",
      changeTime: "تغيير الوقت",
      detachVoucher: "فصل القسيمة عند الحاجة",
      update: "تحديث",
      notes: "الملاحظات",
      solve: "حل",
      airportDetailsTitle: "تفاصيل طلب المطار",
      agent: "الوكيل",
      airline: "شركة الطيران",
      paxName: "اسم الراكب",
      paxPhone: "هاتف الراكب",
      paxWhatsapp: "واتساب الراكب",
      ridersCount: "عدد الركاب",
      bagsCount: "عدد الحقائب",
      pnr: "PNR",
      airportCode: "رمز المطار",
      estimatedPrice: "السعر التقديري",
      okReceived: "حسناً، تم الاستلام",
      maxTwoHours: "يجب ألا يتجاوز الفرق ساعتين",
      confirmUpdateService: "هل أنت متأكد من تغيير الخدمة؟",
      suggestionAlreadySent: "تم إرسال هذا الاقتراح مسبقاً!",
      errorHappened: "حدث خطأ (راجع سجل الأخطاء)",
      noExtraDetails: "لا توجد تفاصيل إضافية",
      solved: "تم الحل",
    },
    bookingEditor: {
      changeBookingDetails: "تعديل تفاصيل الحجز",
      selectAction: "اختيار الإجراء",
      selectAttributes: "تحديد الخصائص",
      approveAction: "تأكيد الإجراء",
      changeCaptain: "تغيير الكابتن",
      joinBooking: "ضم الحجز",
      changeTime: "تغيير الوقت",
      cancelBooking: "إلغاء الحجز",
      actionLabel: "الإجراء",
      bookingLabel: "الحجز",
      captainCancelled: "الإلغاء من قبل الكابتن",
      fieldRequired: "هذا الحقل مطلوب",
      enterBookingId: "أدخل رقم الحجز المراد الضم إليه",
      chooseCaptain: "اختر الكابتن",
      changeCaptainReason: "سبب تغيير الكابتن",
      confirmChangeCaptain: "تريد تغيير الكابتن إلى:",
      confirmJoinRide: "تريد الضم إلى الرحلة:",
      confirmChangeTime: "تريد تغيير الوقت إلى:",
      confirmCancelBooking: "أنت على وشك إلغاء هذا الحجز",
      confirmNotCancelBooking: "لن يتم إلغاء هذا الحجز",
      captainName: "اسم الكابتن",
      captainNumber: "رقم الكابتن",
      applyToAllRide: "تطبيق ذلك على جميع الحجوزات في نفس الرحلة",
      applyPenalty: "تطبيق الغرامة",
      penaltyApplied: "سيتم تطبيق الغرامة إن كانت مستحقة",
      penaltyNotApplied: "لن يتم تطبيق أي غرامة",
      noCancel: "لا! تراجع عن ذلك",
      yesConfirm: "نعم، أنا متأكد من ذلك",
      willBeDeleted: "سيتم الإلغاء!",
    },
    dataTable: {
      new: "جديد",
      edit: "تعديل",
      noData: "لا توجد بيانات",
      reset: "إعادة ضبط",
      deleteConfirmation: "تأكيد الحذف",
      deleteConfirmText: "هل أنت متأكد من حذف {name}؟",
      thisItem: "هذا العنصر",
      deleted: "تم الحذف",
      errorHappened: "حدث خطأ (راجع سجل الأخطاء)",
      fillAllFields: "يرجى تعبئة جميع الحقول!",
      couldntSave: "تعذر الحفظ (حدث خطأ، راجع سجل الأخطاء)!",
    },
    searchAgent: {
      searching: "جارٍ البحث",
      active: "نشط",
      inactive: "غير نشط",
      archive: "مؤرشف",
      username: "اسم المستخدم",
      email: "البريد الإلكتروني",
      firstName: "الاسم الأول",
      lastName: "الاسم الأخير",
      status: "الحالة",
      createdAt: "تاريخ الإنشاء",
      deletedAt: "تاريخ الحذف",
    },
    searchInput: {
      searchBookings: "البحث عن الحجوزات",
      filter: "تصفية",
      advancedSearch: "بحث متقدم",
      noRequestsForFilters: "لا توجد طلبات مطابقة للفلاتر المحددة",
      filters: "الفلاتر",
      loading: "جارٍ التحميل...",
      clickToEditFilters: "انقر لتعديل الفلاتر",
      loadingMoreOrders: "جارٍ تحميل المزيد من الطلبات",
      endOfResults: "نهاية النتائج",
      passenger: "الراكب",
      passengerPlaceholder: "أدخل اسم الراكب أو رقم الهاتف أو البريد الإلكتروني",
      driver: "السائق",
      driverPlaceholder: "أدخل اسم السائق أو رقم التكسي",
      orderId: "رقم الطلب",
      orderIdPlaceholder: "أدخل رقم الطلب",
    },
  },
  passengersPage: {
    pageTitle: "الركاب",
    profileTitle: "الملف الشخصي للراكب",
    marketingTitle: "تسويق الركاب",
    statsTitle: "إحصائيات تطبيق الزبائن",
    filterByEstablishment: "تصفية حسب المنشأة",
    normalAccounts: "الحسابات العادية",
    viewProfile: "عرض الملف الشخصي",
    notAffiliated: "غير مرتبط بمنشأة",
    id: "المعرف",
    fullName: "الاسم الكامل",
    phoneNumber: "رقم الهاتف",
    business: "المنشأة",
    businessName: "اسم المنشأة",
    gender: "الجنس",
    male: "ذكر",
    female: "أنثى",
    dateOfBirth: "تاريخ الميلاد",
    email: "البريد الإلكتروني",
    accountStatus: "حالة الحساب",
    accountType: "نوع الحساب",
    hotel: "فندق",
    normal: "عادي",
    riderCode: "رمز الراكب",
    creationDate: "تاريخ الإنشاء",
    appVersion: "رقم الإصدار",
    active: "نشط",
    inactive: "غير نشط",
    archive: "مؤرشف",
    blacklisted: "محظور",
    block: "حظر",
    unblock: "إلغاء الحظر",
    accept: "قبول",
    save: "حفظ",
    saved: "تم الحفظ",
    required: "مطلوب",
    requiredField: "حقل مطلوب",
    passengerTab: "الراكب",
    tripsTab: "الرحلات",
    information: "المعلومات",
    bookingId: "رقم الحجز",
    date: "التاريخ",
    pickupLocation: "موقع الانطلاق",
    dropoffLocation: "موقع الوصول",
    driverName: "اسم السائق",
    driverGlAccount: "رقم حساب السائق",
    status: "الحالة",
    statusPending: "بانتظار الإسناد",
    statusAccepted: "تم إسناد الطلب",
    statusStarted: "السائق في الطريق",
    statusArrived: "وصل إلى نقطة الانطلاق",
    statusPickedUp: "بدأت الرحلة",
    statusDone: "وصل إلى الوجهة",
    statusPaid: "ناجحة",
    statusCaptainCancelled: "ألغيت من قبل السائق",
    statusPassengerCancelled: "ألغيت من قبل الزبون",
    statusSystemCancelled: "ألغيت من قبل النظام",
    statusCcCancelled: "ألغيت من قبل خدمة العملاء",
    blockAccount: "حظر الحساب",
    unblockAccount: "إلغاء حظر الحساب",
    blockConfirm: "هل أنت متأكد من حظر حساب هذا الراكب؟",
    unblockConfirm: "هل أنت متأكد من إلغاء حظر حساب هذا الراكب؟",
    accountBlockedSuccess: "تم حظر الحساب بنجاح",
    accountUnblockedSuccess: "تم تفعيل الحساب بنجاح",
    statusChangeFailed: "تعذر تغيير حالة الحساب",
    acceptAccount: "قبول الحساب",
    acceptConfirm: "هل أنت متأكد من قبول حساب هذا الراكب؟",
    accountAccepted: "تم قبول الحساب بنجاح",
    acceptFailed: "تعذر قبول الحساب",
    infoTitle: "معلومات {name}",
    passenger: "الراكب",
    captain: "الكابتن",
    approved: "مقبول",
    yes: "نعم",
    no: "لا",
    firstName: "الاسم الأول",
    username: "اسم المستخدم",
    birthday: "تاريخ الميلاد",
    certificateStart: "بداية شهادة القيادة",
    certificateEnd: "نهاية شهادة القيادة",
    idCardFront: "الهوية - الوجه الأمامي",
    idCardBack: "الهوية - الوجه الخلفي",
    noConviction: "وثيقة لا حكم عليه",
    filterPassengers: "تصفية الركاب",
    filterHint: "تصفية اختيارية. عند تعطيلها سيتم إرسال الرسالة إلى جميع الركاب النشطين.",
    enableFilter: "تفعيل التصفية",
    minBookings: "الحد الأدنى للحجوزات",
    fromDate: "من تاريخ",
    toDate: "إلى تاريخ",
    registeredFrom: "تاريخ التسجيل من",
    registeredTo: "تاريخ التسجيل إلى",
    inactiveDays: "زبائن غير نشطين منذ (أيام)",
    voucherCode: "استخدموا كود الخصم",
    hasUsedVoucher: "استخدموا أي كود خصم",
    passengerType: "نوع الزبون",
    captainInactiveDays: "كباتن غير نشطين منذ (أيام)",
    captainStatus: "حالة الكابتن",
    targetedCount: "عدد الركاب المستهدفين:",
    refreshCount: "تحديث العدد",
    messageContent: "محتوى الرسالة",
    messageHint: "اكتب المحتوى التسويقي واختر قنوات الإرسال.",
    message: "الرسالة",
    sendAsSms: "إرسال كرسالة نصية SMS",
    sendAsPush: "إرسال كإشعار تطبيق",
    audienceHint: "الجمهور المستهدف (اختر واحداً على الأقل)",
    passengers: "الركاب",
    driversSnapCaptain: "السائقون (سناب كابتن)",
    send: "إرسال",
    countLoadFailed: "فشل تحميل عدد الركاب",
    sendCampaignTitle: "إرسال حملة تسويقية",
    sendCampaignConfirm: "هل أنت متأكد من إرسال {channels} إلى {target}؟",
    filteredPassengers: "الركاب المطابقين للتصفية",
    allActivePassengers: "جميع الركاب النشطين",
    drivers: "السائقين",
    channelSms: "رسالة نصية",
    channelPush: "إشعار",
    campaignQueued: "تمت جدولة مهمة الإرسال بنجاح",
    campaignFailed: "فشل إرسال الحملة التسويقية",
    platform: "المنصّة",
    platformAndroid: "أندرويد",
    platformIos: "آي أو إس",
    language: "لغة التطبيق",
    languageAr: "العربية",
    languageEn: "الإنجليزية",
    governorate: "المحافظة",
    genderAny: "الكل",
    clearFilters: "مسح عوامل التصفية",
    scheduleLater: "الجدولة لوقت لاحق",
    scheduleDateTime: "الإرسال في",
    scheduleHint: "اترك الخيار متوقفاً للإرسال الآن",
    presetSectionTitle: "قوالب الجمهور",
    presetName: "اسم القالب",
    savePreset: "حفظ عوامل التصفية الحالية",
    loadPreset: "تحميل قالب",
    deletePreset: "حذف",
    presetSaved: "تم حفظ القالب",
    presetDeleted: "تم حذف القالب",
    presetSaveFailed: "فشل حفظ القالب",
    presetDeleteFailed: "فشل حذف القالب",
    presetNameRequired: "أدخل اسم القالب أولاً",
    noPresets: "لا توجد قوالب محفوظة",
    campaignHistory: "سجل الحملات",
    campaignDate: "التاريخ",
    campaignStatus: "الحالة",
    campaignChannels: "القنوات",
    campaignTargeted: "المستهدفون",
    campaignFilters: "عوامل التصفية",
    campaignMessage: "الرسالة",
    noCampaigns: "لا توجد حملات بعد",
    refreshHistory: "تحديث",
    filtersSummaryNone: "جميع النشطين (بلا تصفية)",
    // Marketing redesign (doc 2026-08-18)
    mkTemplatesTitle: "القوالب",
    mkTemplatesHint: "حمّل قالباً محفوظاً بضغطة واحدة، أو احفظ الإعداد الحالي كقالب جديد.",
    mkSaveAsTemplate: "حفظ كقالب",
    mkUpdateTemplate: "تحديث القالب",
    mkTemplateShared: "مشترك بين جميع مسؤولي التسويق",
    mkTemplateSharedHint: "أوقف الخيار لإبقاء القالب خاصاً بك",
    mkTemplateUpdated: "تم تحديث القالب",
    mkTemplateUpdateFailed: "فشل تحديث القالب",
    mkCancel: "إلغاء",
    mkAudienceTitle: "الجمهور المستهدف",
    mkSendToAll: "إرسال للجميع",
    mkSendToAllHint: "سيتم إرسال الإشعار إلى جميع المستخدمين النشطين في النظام.",
    mkFilterMode: "تصفية حسب تاريخ التسجيل والنشاط",
    mkSpecificUsers: "مستخدمون محددون",
    mkSpecificUsersCount: "مستخدمين محددين ({count})",
    mkRegisteredFromTip: "فقط المستخدمون الذين سجّلوا في هذا التاريخ أو بعده",
    mkRegisteredToTip: "فقط المستخدمون الذين سجّلوا في هذا التاريخ أو قبله",
    mkActivity: "النشاط",
    mkActivityActive: "نشط",
    mkActivityInactive: "غير نشط",
    mkActivityDays: "فترة النشاط (أيام)",
    mkActivityDaysHint: "الافتراضي 30 يوماً، قابلة للتعديل",
    mkActivityTip: "غير النشط = لم يقم بأي رحلة خلال آخر {days} يوماً (قابلة للتعديل)",
    mkSearchUsers: "بحث بالاسم أو رقم الهاتف أو المعرف",
    mkSearch: "بحث",
    mkSearchNoResults: "لا توجد نتائج",
    mkSearchFailed: "فشل البحث",
    mkAddUser: "إضافة",
    mkSelectedUsers: "المستخدمون المختارون",
    mkNoSelectedUsers: "لم يتم اختيار مستخدمين بعد — ابحث وأضفهم",
    mkRecipientsCount: "عدد المستلمين:",
    mkViewList: "عرض القائمة",
    mkExportCsv: "تصدير CSV",
    mkRecipientsTitle: "قائمة المستلمين",
    mkContentTitle: "محتوى الإشعار",
    mkNotificationTitle: "العنوان",
    mkNotificationText: "النص",
    mkNotificationUrl: "رابط (اختياري)",
    mkOptionsTitle: "خيارات الإرسال",
    mkChannelPushLabel: "إشعار فوري (Push)",
    mkChannelInAppLabel: "إشعار داخل التطبيق (In-App)",
    mkChannelSmsLabel: "رسالة نصية SMS",
    mkChannelInApp: "إشعار داخل التطبيق",
    mkDeferred: "إعادة المحاولة عند الاتصال (التسليم المؤجل)",
    mkDeferredHint: "يبقى الإشعار قيد المحاولة حتى 24 ساعة ويصل فور اتصال جهاز المستخدم بالإنترنت.",
    mkDeliveryStats: "حالة التسليم",
    mkStatusSent: "مرسل",
    mkStatusPending: "قيد الانتظار",
    mkStatusFailed: "فشل",
    mkStatusExpired: "منتهي",
    mkCampaignQueued: "بالانتظار",
    mkCampaignRunning: "قيد التنفيذ",
    mkCampaignDone: "مكتملة",
    mkCampaignFailed: "فشلت",
    type: "النوع",
    all: "الكل",
    reservation: "حجز مسبق",
    instant: "فوري",
    filterBy: "تصفية حسب",
    day: "يوم",
    month: "شهر",
    year: "سنة",
    from: "من",
    to: "إلى",
    selectYear: "اختر السنة",
    bookingsStats: "إحصائيات الحجوزات:",
    paymentsStats: "إحصائيات المدفوعات:",
    topCountries: "أكثر الدول:",
    stats: {
      allCompletedOrders: "جميع الطلبات المكتملة",
      customerAppTotalOrders: "إجمالي طلبات تطبيق الزبائن",
      customerAppCompletedOrders: "الطلبات المكتملة عبر تطبيق الزبائن",
      customerAppCancelledOrders: "الطلبات الملغاة عبر تطبيق الزبائن",
      ordersPerCustomer: "متوسط الطلبات لكل زبون",
      numberOfDifferentCustomers: "عدد الزبائن المختلفين",
      ordersPaidInside: "طلبات مدفوعة داخل التطبيق",
      ordersPaidOutside: "طلبات مدفوعة خارج التطبيق",
      totalPaidAmount: "إجمالي المبلغ المدفوع",
      totalTipAmount: "إجمالي الإكراميات",
      totalCancellationAmount: "إجمالي مبالغ الإلغاء",
      totalPaymentFeeAmount: "إجمالي رسوم الدفع",
      averageAmountPerOrder: "متوسط المبلغ لكل طلب",
      averageTipsPerOrder: "متوسط الإكرامية لكل طلب",
      difference: "الفرق",
    },
  },
  requestsPage: {
    pageTitle: "الطلبات",
    instantOrders: "الطلبات الفورية",
    reservation: "الحجز المسبق",
    newBooking: "حجز جديد",
    pending: "قيد الانتظار",
    dispatched: "تم الإسناد",
    driverOnTheWay: "السائق في الطريق",
    tripStarted: "بدأت الرحلة",
    completed: "مكتملة",
    noOrders: "لا توجد طلبات",
    next: "التالي",
  },
  ridePage: {
    pageTitle: "تفاصيل الطلب",
    unpaidRideTitle: "رحلة غير مدفوعة",
    unpaidRideHint: "الرحلة منتهية ولم تُسدَّد قيمتها. التسجيل كرحلة غير مدفوعة يُضيف حصة السائق إلى رصيده (وحصة مالك السيارة إن وُجد) كما في الدفع الإلكتروني، ويقيّد قيمة الرحلة على حساب الذمم المدينة الأخرى 12206.",
    settleUnpaid: "تسجيل كرحلة غير مدفوعة",
    settleUnpaidConfirmTitle: "تأكيد تسجيل رحلة غير مدفوعة",
    settleUnpaidConfirm: "ستُغلق الرحلة كمدفوعة في النظام، ويُضاف للسائق حصته، ويُرحَّل قيد آلي: مدين 12206 بقيمة الرحلة. لا يمكن التراجع عن القيد. هل تريد المتابعة؟",
    settledUnpaid: "تم تسجيل الرحلة كغير مدفوعة",
    settledUnpaidWithEntry: "تم تسجيل الرحلة كغير مدفوعة - القيد {ref}",
    settleUnpaidFailed: "تعذّر تسجيل الرحلة كغير مدفوعة",
    docTitle: "تفاصيل الطلب رقم {id} | سناب",
    complaints: "الشكاوى",
    pendingChip: "{count} قيد الانتظار",
    addComplaintLabel: "إضافة شكوى",
    complaintPlaceholder: "أدخل وصف الشكوى...",
    addComplaint: "إضافة شكوى",
    complaintPending: "قيد الانتظار",
    complaintResolved: "تم الحل",
    createdAt: "أُنشئت:",
    by: "بواسطة",
    resolvedAt: "تم الحل:",
    resolutionLabel: "الحل:",
    resolve: "حل الشكوى",
    noComplaints: "لا توجد شكاوى لهذا الحجز",
    pickupLocation: "نقطة انطلاق الحجز",
    dropoffLocation: "نقطة وصول الحجز",
    statusAtTime: "{status} عند الساعة {time}",
    noLocationForStatus: "لا يوجد موقع مسجل لهذا الحدث",
    passengerRealLocation: "موقع الزبون الفعلي",
    legendTripRoute: "المسار المسلوك (الرحلة)",
    legendApproachRoute: "مسار التوجه للزبون",
    legendTripEstimate: "الطريق المقترح",
    legendApproachEstimate: "الطريق المقترح للتوجه",
    followDriver: "تتبع السائق",
    customerInCar: "السائق والزبون في السيارة",
    liveFeedDisconnected: "انقطع البث المباشر - جاري إعادة الاتصال...",
    resolveComplaintTitle: "حل الشكوى",
    resolutionCommentLabel: "تعليق الحل (اختياري)",
    resolutionPlaceholder: "اذكر ما تم إجراؤه لحل هذه الشكوى...",
    cancel: "إلغاء",
    statusPending: "قيد الانتظار",
    statusAccepted: "مقبول",
    statusStarted: "انطلق السائق",
    statusArrived: "وصل إلى نقطة الانطلاق",
    statusPickedUp: "بدأت الرحلة",
    statusDone: "وصل إلى الوجهة",
    statusPaid: "مدفوع",
    statusSystemCancelled: "ألغاه النظام",
    statusPassengerCancelled: "ألغاه الزبون",
    statusCaptainCancelled: "ألغاه السائق",
    statusCcCancelled: "ألغاه مركز الاتصال",
    saved: "تم الحفظ",
    chooseCategory: "يرجى اختيار فئة",
    failedLoadComplaints: "فشل تحميل الشكاوى",
    enterComplaintDescription: "يرجى إدخال وصف الشكوى",
    complaintCreated: "تم إنشاء الشكوى بنجاح",
    failedCreateComplaint: "فشل إنشاء الشكوى",
    complaintResolvedToast: "تم حل الشكوى بنجاح",
    failedResolveComplaint: "فشل حل الشكوى",
    enterComplaintTitle: "أدخل وصف الشكوى",
    enterComplaint: "أدخل الشكوى",
    soundFiles: "ملفات صوتية",
    zoomIn: "انقر للتكبير",
    zoomOut: "انقر للتصغير",
    fileComplaint: "تقديم شكوى",
    status: "الحالة",
    notTreated: "غير معالجة",
    partiallyTreated: "معالجة جزئياً",
    treated: "معالجة",
  },
  orderCardX: {
    completed: "مكتمل",
    cancelledByCustomer: "ألغاه الزبون",
    cancelledByDriver: "ألغاه السائق",
    cancelledBySystem: "ألغاه النظام",
    cancelledByCc: "ألغاه مركز الاتصال",
    estimated: "السعر التقديري",
    fareShortTrackEstimate: "تنبيه: مسار GPS لهذه الرحلة ناقص (سُجّل {gps} كم فقط)، فحُسبت الأجرة على مسافة التقدير {billed} كم. راجِع الرحلة.",
    fareShortTrackStraight: "تنبيه: مسار GPS لهذه الرحلة ناقص (سُجّل {gps} كم فقط)، فحُسبت الأجرة على المسافة المستقيمة بين الصعود والإنهاء {billed} كم. راجِع الرحلة.",
    fareManualCorrection: "صُحّحت أجرة هذه الرحلة بموافقة الإدارة: المسافة المعتمدة {billed} كم (سجّل GPS {gps} كم فقط).",
    loading: "جارٍ التحميل",
    chooseDriverTitle: "اختر سائقاً لإسناد الحجز إليه",
    driver: "السائق",
    searchDriver: "ابحث عن سائق",
    close: "إغلاق",
    dispatch: "إسناد",
    cancellationReasonTitle: "سبب الإلغاء:",
    submit: "إرسال",
    statusPending: "بانتظار الإسناد",
    statusAccepted: "تم إسناد الطلب",
    statusStarted: "السائق في الطريق",
    statusArrived: "وصل إلى نقطة الانطلاق",
    statusPickedUp: "بدأت الرحلة",
    statusDone: "وصل إلى الوجهة",
    statusPaid: "تم بنجاح",
    statusCaptainCancelled: "ألغاه السائق",
    statusPassengerCancelled: "ألغاه الزبون",
    statusSystemCancelled: "ألغاه النظام",
    statusCcCancelled: "ألغاه مركز الاتصال",
    openDetailsHint: "فتح التفاصيل",
    cancelOrderHint: "انقر لإلغاء الطلب",
    dispatchHint: "انقر لإسناد الطلب يدوياً",
    orderLogsHint: "انقر لعرض سجلات الطلب",
    currency: "ل.س",
    pendingReminderTooSoon: "لا يمكن إرسال تذكير لطلب بانتظار الإسناد قبل مرور 15 دقيقة على إنشائه",
    sendReminder: "إرسال تذكير",
    confirmReminderDrivers: "هل أنت متأكد من إرسال تذكير إلى السائقين؟",
    confirmReminderDriver: "هل أنت متأكد من إرسال تذكير إلى السائق؟",
    reminderSent: "تم إرسال التذكير",
    errorOccurred: "حدث خطأ",
    dispatchedReminderTooSoon: "لا يمكن إرسال تذكير لطلب مُسند قبل موعد الطلب",
    orderDispatched: "تم إسناد الطلب رقم {id} بنجاح",
    chooseReason: "يرجى اختيار سبب",
    orderCancelled: "تم إلغاء الطلب رقم {id}",
    changeTimeTitle: "تغيير موعد الطلب رقم {id}",
    changeTimeParagraph: "يرجى اختيار الموعد الجديد للحجز رقم <b>{id}</b>، الراكب <b>{passenger}</b>، من <b>{from}</b> إلى <b>{to}</b> عند <b>{time}</b>.",
    enterNewDatetime: "أدخل الموعد الجديد",
    timeChanged: "تم تغيير موعد الحجز رقم {id} من {from} إلى {to}.",
    dispatchNoDriver: "لا يوجد سائق متاح - توقف الإسناد",
    dispatchNoDriverTargetRejected: "لا يوجد سائق متاح - رفض السائق المحدد الطلب",
    dispatchNoDriverRejected: "لا يوجد سائق متاح - رفضه {count} سائق",
    dispatchOffering: "يتم عرض الطلب على سائق",
    dispatchReleasedTargetOffering: "كان الطلب موجهاً لسائق محدد ولم يأخذه - يتم عرضه الآن على باقي السائقين",
    dispatchReleasedTargetNoDriver: "كان الطلب موجهاً لسائق محدد ولم يأخذه - أُعيد عرضه على باقي السائقين ولا يوجد سائق متاح",
  },
  ridesListPage: {
    pageTitle: "الرحلات",
    documentTitle: "الحجوزات",
    fromDate: "من تاريخ",
    toDate: "إلى تاريخ",
    orderId: "رقم الطلب",
    status: "الحالة",
    orderType: "نوع الطلب",
    drivers: "السائقون",
    passengers: "الركاب",
    services: "الخدمات",
    applyFilters: "تطبيق الفلاتر",
    reset: "إعادة ضبط",
    exportExcel: "تصدير Excel",
    statusPending: "قيد الانتظار",
    statusAccepted: "مقبول",
    statusStarted: "في الطريق",
    statusArrived: "وصل الكابتن",
    statusPickedUp: "تم التقاط الراكب",
    statusDone: "منتهي",
    statusPaid: "مدفوع",
    statusSystemCancelled: "ملغي من النظام",
    statusPassengerCancelled: "ملغي من الراكب",
    statusCaptainCancelled: "ملغي من الكابتن",
    statusCcCancelled: "ملغي من مركز الاتصال",
    timeInstant: "فوري",
    timeReservation: "حجز مسبق",
    colId: "المعرف",
    colPickup: "نقطة الانطلاق",
    colDropoff: "الوجهة",
    colDriverName: "اسم السائق",
    colPassengerName: "اسم الراكب",
    colService: "الخدمة",
    colPrice: "السعر",
    colDatetime: "التاريخ والوقت",
    viewDetails: "عرض التفاصيل",
    currency: "ل.س",
    complaintsTitle: "شكاوى الحجوزات",
    resolved: "محلولة",
    resolve: "حل",
    resolveComplaint: "حل الشكوى",
    resolutionCommentLabel: "تعليق الحل (اختياري)",
    resolutionCommentPlaceholder: "اكتب ما تم إجراؤه لحل هذه الشكوى...",
    cancel: "إلغاء",
    colBookingId: "رقم الحجز",
    colDescription: "الوصف",
    colCreatedAt: "تاريخ الإنشاء",
    colCreatedBy: "أنشئت بواسطة",
    colActions: "الإجراءات",
    colResolvedAt: "تاريخ الحل",
    colResolvedBy: "حُلّت بواسطة",
    colResolution: "الحل",
    failedLoadPending: "فشل تحميل الشكاوى قيد الانتظار",
    failedLoadResolved: "فشل تحميل الشكاوى المحلولة",
    complaintResolved: "تم حل الشكوى بنجاح",
    failedResolve: "فشل حل الشكوى",
  },
  transferCentersPage: {
    pageTitle: "مراكز الشحن",
    new: "جديد",
    id: "المعرف",
    name: "الاسم",
    phoneNumber: "رقم الهاتف",
    email: "البريد الإلكتروني",
    address: "العنوان",
    governorate: "المحافظة",
    balance: "الرصيد",
    accountStatus: "حالة الحساب",
    creationDate: "تاريخ الإنشاء",
    viewProfile: "عرض الملف الشخصي",
    createTitle: "إنشاء مركز شحن",
    password: "كلمة المرور",
    passwordConfirmation: "تأكيد كلمة المرور",
    locationDrag: "الموقع (اسحب العلامة لتحديده)",
    cancel: "إلغاء",
    create: "إنشاء",
    fieldRequired: "هذا الحقل مطلوب",
    validEmail: "يرجى إدخال بريد إلكتروني صالح",
    passwordMin: "يجب أن تتألف كلمة المرور من 8 أحرف على الأقل",
    passwordsNoMatch: "كلمتا المرور غير متطابقتين",
    invalidPhone: "رقم الهاتف غير صالح",
    setLocationToast: "يرجى تحديد الموقع على الخريطة",
    createdToast: "تم إنشاء مركز الشحن",
    createFailedToast: "تعذر إنشاء مركز الشحن",
    profileTitle: "ملف مركز الشحن",
    block: "حظر",
    unblock: "إلغاء الحظر",
    tabTransferCenter: "مركز الشحن",
    information: "المعلومات",
    required: "مطلوب",
    invalidEmail: "بريد إلكتروني غير صالح",
    active: "نشط",
    inactive: "غير نشط",
    location: "الموقع",
    save: "حفظ",
    tabAdminTransfers: "تحويلات الإدارة",
    tabCaptainsTransfers: "تحويلات الكباتن",
    userEmail: "البريد الإلكتروني للمستخدم",
    userName: "اسم المستخدم",
    amount: "المبلغ",
    creationTime: "وقت الإنشاء",
    driverPhoneNumber: "رقم هاتف السائق",
    driverName: "اسم السائق",
    accountCode: "رقم حساب مركز الشحن",
    driverAccountCode: "رقم حساب السائق",
    savedToast: "تم الحفظ",
    blockAccount: "حظر الحساب",
    unblockAccount: "إلغاء حظر الحساب",
    blockConfirm: "هل أنت متأكد من رغبتك في حظر حساب مركز الشحن هذا؟",
    unblockConfirm: "هل أنت متأكد من رغبتك في إلغاء حظر حساب مركز الشحن هذا؟",
    accountBlockedToast: "تم حظر الحساب بنجاح",
    accountUnblockedToast: "تم تفعيل الحساب بنجاح",
    statusChangeFailed: "تعذر تغيير حالة الحساب",
  },
  walletsPage: {
    pageTitle: "محافظ الركاب",
    searchLabel: "البحث عن راكب (الاسم / الهاتف / رمز الراكب / المعرّف)",
    refresh: "تحديث",
    pendingRequestsTitle: "طلبات شحن رصيد نقدي قيد الانتظار",
    syp: "ل.س",
    approve: "قبول",
    reject: "رفض",
    log: "السجل",
    noWallets: "لا توجد محافظ",
    balance: "الرصيد",
    noteLabel: "ملاحظة (مثال: رقم مرجع الحوالة / المندوب)",
    cancel: "إلغاء",
    addBalance: "إضافة رصيد",
    apply: "تطبيق",
    statementTitle: "كشف حساب المحفظة",
    noTransactions: "لا توجد حركات بعد",
    rider: "الراكب",
    amount: "المبلغ",
    channel: "المصدر",
    note: "ملاحظة",
    date: "التاريخ",
    riderNo: "رقم الراكب",
    name: "الاسم",
    phone: "الهاتف",
    riderCode: "رمز الراكب",
    type: "النوع",
    booking: "الحجز",
    reason: "السبب",
    failed: "فشلت العملية",
    failedToLoad: "فشل تحميل البيانات",
    approvedCredited: "تم القبول وإضافة الرصيد",
    rejectedToast: "تم الرفض",
    enterAmount: "أدخل المبلغ",
    balanceAdded: "تمت إضافة الرصيد",
    reasonRequired: "السبب مطلوب",
    adjusted: "تم التعديل",
  },
  shell: {
    clickToHide: "انقر للإخفاء",
    productionWarning: "أنت متصل بخادم بيئة الإنتاج",
    show: "عرض",
    newTicket: "تذكرة جديدة::",
    name: "الاسم:",
    type: "النوع:",
    onType: "بخصوص (النوع):",
    onIdentifier: "بخصوص (المعرّف):",
    creationDate: "تاريخ الإنشاء:",
    assignToMe: "إسنادها إليّ",
    lateBookingToast: "الكابتن {captain} ينتظر الراكب منذ الساعة {time}",
    lateCaptainToast: "الكابتن {captain} متأخر عن الراكب {passenger} الذي كان يجب اصطحابه قبل الساعة {time}",
    keepOrderTitle: "الاستمرار بالبحث عن سائق للطلب #{id}؟",
    keepOrderParagraph: "هل أنت متأكد أنك تريد متابعة البحث عن سائق <b>للطلب #{id}</b>؟",
    orderExtended: "تم تمديد مهلة الطلب #{id}",
  },
  auth: {
    welcomeTitle: "مرحباً بك في لوحة تحكم سناب",
    emailAddress: "البريد الإلكتروني",
    password: "كلمة المرور",
    confirmPassword: "تأكيد كلمة المرور",
    verificationCode: "رمز التحقق",
    login: "تسجيل الدخول",
    resetPassword: "إعادة تعيين كلمة المرور",
    sendEmail: "إرسال البريد الإلكتروني",
    invalidEmail: "يرجى إدخال بريد إلكتروني صالح",
    invalidLength: "طول الأحرف غير صالح، المطلوب {len}",
    passwordRule: "يجب أن تتكون كلمة المرور من 8 إلى 15 حرفاً، وأن تحتوي على حرف كبير وحرف صغير ورقم ورمز خاص واحد على الأقل.",
    passwordLengthRule: "يجب أن تتكون كلمة المرور من 8 إلى 15 حرفاً.",
    passwordRequired: "كلمة المرور مطلوبة",
    fieldRequired: "هذا الحقل مطلوب",
    passwordsDontMatch: "كلمتا المرور غير متطابقتين",
    checkInfo: "تحقق من معلوماتك",
    resetEmailSentToast: "أرسلنا إليك بريداً إلكترونياً لإعادة تعيين كلمة المرور.",
    resetPasswordDoneToast: "تم تغيير كلمة المرور بنجاح.",
  },
  camerasPage: {
    pageTitle: "الكاميرات (الرحلة الآمنة)",
    logsTitle: "سجل البث",
    streamLogsButton: "سجل البث",
    colImei: "IMEI",
    colName: "الاسم",
    colProvider: "المزوّد",
    colCar: "السيارة",
    colCars: "السيارات",
    colStatus: "الحالة",
    colLastSeen: "آخر اتصال",
    colNotes: "ملاحظات",
    colDateCreated: "تاريخ الإنشاء",
    colBooking: "الحجز",
    colPassenger: "الراكب",
    colSuccess: "نجاح",
    colError: "الخطأ",
    colRequestedAt: "وقت الطلب",
    unbound: "غير مربوطة",
    statusUnknown: "غير معروف",
    statusOnline: "متصلة",
    statusOffline: "غير متصلة",
    liveUrlMissing: "منصة الكاميرات لم تُرجع رابط بث",
    liveUrlFailed: "تعذر جلب رابط البث المباشر",
    unbindTitle: "فك ربط الكاميرا",
    unbindConfirm: "فك ربط الكاميرا {imei} عن جميع السيارات المرتبطة بها؟",
    unbindDone: "تم فك ربط الكاميرا",
    errorOccurred: "حدث خطأ",
    ruleRequired: "مطلوب",
    ruleImei: "يجب أن يتكون IMEI من 8-20 رقماً",
    searchCarHint: "ابحث عن السيارة برقم اللوحة أو الماركة أو اسم السائق أو رقمه",
    carsSearching: "جارٍ البحث...",
    noCarMatches: "لا توجد سيارة مطابقة",
    carsLoadFailed: "تعذر جلب قائمة السيارات",
    multiCarHint: "اختر كل سجلات السيارة نفسها — سجل لكل كابتن يقودها — وإلا ستغيب الكاميرا عن رحلاته.",
    colViewer: "شوهد من قبل (أدمن)",
  },
  catalogPage: {
    pageTitleServices: "الخدمات",
    pageTitlePrices: "الأسعار",
    pageTitleLocations: "المواقع",
    pageTitleCars: "السيارات",
    pageTitlePaymentMethods: "طرق الدفع",
    pageTitleCarBrands: "ماركات السيارات",
    pageTitleBrands: "الماركات",
    pageTitleModels: "الموديلات",
    pageTitleColors: "الألوان",
    pageTitleBanks: "المصارف",
    pricesTitle: "{name} - الأسعار",
    attachedLocationsTitle: "{name} - المواقع المرتبطة",
    attachedCaptainsTitle: "{name} - الكباتن المرتبطون",
    brandModelsTitle: "{name} - الموديلات",
    new: "جديد",
    edit: "تعديل",
    delete: "حذف",
    close: "إغلاق",
    save: "حفظ",
    from: "من",
    to: "إلى",
    unknown: "غير معروف",
    notAvailable: "غير متوفر",
    unloadable: "تعذر تحميل الصورة",
    yes: "نعم",
    no: "لا",
    deleted: "تم الحذف",
    failed: "فشلت العملية",
    errorOccurred: "حدث خطأ",
    checkYourInfo: "تحقق من المعلومات المدخلة",
    updatedSuccessfully: "تم التحديث بنجاح",
    createdSuccessfully: "تم الإنشاء بنجاح",
    enterValidHours: "يرجى إدخال ساعات صالحة",
    ruleRequired: "هذا الحقل مطلوب",
    ruleNumber: "يجب أن يكون رقماً",
    rulePositiveNumber: "يجب أن يكون رقماً موجباً",
    rulePercentage: "يجب أن تكون القيمة بين 0 و100",
    ruleLength: "عدد الأحرف غير صالح، المطلوب {len}",
    colNameEn: "الاسم (بالإنجليزية)",
    colNameAr: "الاسم (بالعربية)",
    colDateCreated: "تاريخ الإنشاء",
    colDateUpdated: "تاريخ التحديث",
    colLastDateUpdated: "تاريخ آخر تحديث",
    colInfo: "معلومات",
    colPriority: "الأولوية",
    colIcon: "الأيقونة",
    colActive: "نشط",
    colSafeRide: "رحلة آمنة",
    safeRideHint: "شارة فقط: تظهر الخدمة للركاب كالمعتاد. زر المشاهدة المباشرة يظهر للراكب فقط إذا كانت سيارة الكابتن مزوّدة بكاميرا",
    colCompanyPercent: "إيراد العمولة %",
    colDriverPercent: "نسبة السائق %",
    colOwnerPercent: "نسبة المالك %",
    colMerchantAccount: "حساب التاجر",
    colName: "الاسم",
    colCreatedAt: "تاريخ الإنشاء",
    colUpdatedAt: "تاريخ التحديث",
    colCreationDate: "تاريخ الإنشاء",
    colBaseFare: "الأجرة الأساسية (USD)",
    colWaitingCostPerMin: "كلفة الانتظار/دقيقة (USD)",
    colBookingCostPerMin: "كلفة الحجز/دقيقة (USD)",
    colBookingCostPerKm: "كلفة الحجز/كم (USD)",
    colMinCharge: "الحد الأدنى للأجرة (USD)",
    colStartTime: "وقت البداية",
    colEndTime: "وقت النهاية",
    colPlateNumber: "رقم اللوحة",
    colManuYear: "سنة الصنع",
    colColor: "اللون",
    colCaptain: "الكابتن",
    colBrand: "الماركة",
    colModel: "الموديل",
    chooseCaptain: "اختر الكابتن",
    locationsToAdd: "المواقع المراد إضافتها",
    baseFare: "الأجرة الأساسية",
    waitingCostPerMin: "كلفة الانتظار/دقيقة",
    bookingCostPerMin: "كلفة الحجز/دقيقة",
    bookingCostPerKm: "كلفة الحجز/كم",
    minCharge: "الحد الأدنى للأجرة",
    baseFareHint: "بالدولار الأمريكي (USD). أجرة فتح الرحلة، تُحتسب مرة واحدة في كل رحلة.",
    waitingCostPerMinHint: "بالدولار الأمريكي (USD) لكل دقيقة. تُحتسب عن كل دقيقة انتظار عند نقطة الانطلاق بعد انتهاء مدة الانتظار المجانية.",
    bookingCostPerMinHint: "بالدولار الأمريكي (USD) لكل دقيقة. تُحتسب عن كل دقيقة من صعود الراكب حتى الوصول إلى الوجهة.",
    bookingCostPerKmHint: "بالدولار الأمريكي (USD) لكل كيلومتر. تُحتسب عن كل كيلومتر يُقطع والراكب على متن السيارة، والطريق إلى نقطة الانطلاق مجاني.",
    minChargeHint: "بالدولار الأمريكي (USD). أدنى أجرة للرحلة: تحلّ محلّ المجموع إذا كان أقل منها، ولا تُضاف إليه أبداً.",
    activateServiceTitle: "تفعيل الخدمة",
    activateServiceConfirm: "هل أنت متأكد من تفعيل الخدمة {name}؟",
    serviceActivated: "تم تفعيل الخدمة",
    deactivateServiceTitle: "تعطيل الخدمة",
    inactiveServicesHint: "الخدمات المعطّلة تُخفى من تطبيق الركاب وتُستثنى من الإسناد.",
    deactivateServiceConfirm: "هل أنت متأكد من تعطيل الخدمة {name}؟",
    serviceDeactivated: "تم تعطيل الخدمة",
    deleteServiceTitle: "حذف الخدمة",
    deleteServiceConfirm: "هل أنت متأكد من حذف الخدمة {name}؟",
    serviceDeleted: "تم حذف الخدمة",
    deleteRowTitle: "حذف الصف",
    deleteRowConfirm: "هل أنت متأكد من حذف هذا الصف؟",
    rowDeleted: "تم حذف الصف",
    activatePaymentMethodTitle: "تفعيل طريقة الدفع",
    activatePaymentMethodConfirm: "هل أنت متأكد من تفعيل طريقة الدفع {name}؟",
    paymentMethodActivated: "تم تفعيل طريقة الدفع",
    deactivatePaymentMethodTitle: "تعطيل طريقة الدفع",
    inactivePaymentMethodsHint: "طرق الدفع المعطّلة تُخفى من تطبيق الركاب.",
    deactivatePaymentMethodConfirm: "هل أنت متأكد من تعطيل طريقة الدفع {name}؟",
    paymentMethodDeactivated: "تم تعطيل طريقة الدفع",
    modelsAction: "الموديلات",
  },
  complaintsPage: {
    pageTitle: "قائمة الشكاوى",
    filters: "الفلاتر",
    selectCaptain: "اختر الكابتن",
    choosePassenger: "اختر الراكب",
    startDate: "تاريخ البداية",
    endDate: "تاريخ النهاية",
    colId: "المعرف",
    colBookingId: "رقم الحجز",
    colLicenseNumber: "رقم الرخصة",
    colBookingTime: "وقت الحجز",
    colCategory: "الفئة",
    colCount: "العدد",
    details: "التفاصيل",
    titleBookingId: "رقم الحجز",
    titleWhoComplained: "مقدم الشكوى",
    titleEntityId: "معرف الكابتن/الطلب",
    titleDescription: "الوصف",
    titleUpdatedAt: "آخر تحديث",
    titleCreatedAt: "تاريخ الإنشاء",
    captainComplaintsTitle: "شكاوى الكابتن",
    captainComplaintsHeading: "شكاوى الكابتن {name}:",
    colDescription: "الوصف",
    colDate: "التاريخ",
    colDoer: "مقدم الشكوى",
    lostFoundTitle: "المفقودات",
    newBtn: "جديد",
    newLostFound: "بلاغ مفقودات جديد",
    editLostFound: "تعديل بلاغ المفقودات",
    colObject: "الغرض",
    colDay: "اليوم",
    colStartTime: "وقت البداية",
    colEndTime: "وقت النهاية",
    colCreatedBy: "أُنشئ بواسطة",
    colPassengerNumber: "رقم الراكب",
    colCaptain: "الكابتن",
    colMessage: "الرسالة",
    colFound: "تم العثور عليه",
    yes: "نعم",
    no: "لا",
    edit: "تعديل",
    sendReminder: "إرسال تذكير",
    delete: "حذف",
    deleteItemTitle: "حذف العنصر رقم {id}",
    deleteItemParagraph: "هل أنت متأكد من حذف <b>العنصر رقم {id}</b>؟",
    deletedSuccessfully: "تم الحذف بنجاح",
    somethingWentWrong: "حدث خطأ ما",
    reminderTitle: "إرسال تذكير للعنصر رقم {id}",
    reminderParagraph: "هل أنت متأكد من إرسال تذكير بخصوص <b>العنصر رقم {id}</b>؟",
    sentSuccessfully: "تم الإرسال بنجاح",
    object: "الغرض المفقود",
    message: "الرسالة",
    captain: "الكابتن",
    searchForCaptain: "ابحث عن كابتن",
    passengerNumber: "رقم الراكب",
    day: "اليوم",
    from: "من",
    to: "إلى",
    create: "إنشاء",
    save: "حفظ",
    markAsFound: "تم العثور على الغرض",
    fieldRequired: "هذا الحقل مطلوب",
    invalidLength: "عدد الأحرف غير صالح، المطلوب {len}",
    enterValidHours: "يرجى إدخال ساعات صالحة",
    createdSuccessfully: "تم الإنشاء بنجاح",
    savedSuccessfully: "تم الحفظ بنجاح",
    checkYourInfo: "تحقق من المعلومات المدخلة",
    byDoer: "بواسطة {doer}",
    availableSoundFiles: "الملفات الصوتية المتاحة",
    playAudio: "تشغيل الصوت",
    download: "تنزيل",
    loading: "جارٍ التحميل",
    commentsSection: "قسم التعليقات",
    writeComment: "اكتب تعليقاً",
    send: "إرسال",
    commentSoundFiles: "الملفات الصوتية للتعليق:",
    cancel: "إلغاء",
    ok: "موافق",
    commentEmpty: "لا يمكن أن يكون نص التعليق فارغاً",
    commentAdded: "تمت إضافة التعليق!",
    savedToast: "تم الحفظ!",
    idLabel: "المعرف {id}",
  },
  globalsShared: {
    suggestPopup: {
      title: "تذكير: اقتراح وقت (تغيير الوقت)",
      passengerName: "اسم الراكب:",
      passengerWhatsapp: "واتساب الراكب:",
      captainName: "اسم الكابتن:",
      originalTime: "الوقت الأصلي:",
      newTime: "الوقت الجديد:",
      passengerOk: "وافق الراكب",
      passengerNo: "رفض الراكب",
      noResponse: "لا يوجد رد بعد",
    },
    snoozePopup: {
      title: "الإسناد",
      letAiDispatch: "حسناً، دع الذكاء الاصطناعي يقوم بالإسناد",
      snooze: "تأجيل",
      from: "من",
      to: "إلى",
      captainLocation: "موقع الكابتن",
      minutesAbbr: "د",
    },
    dialog: {
      select: "اختيار",
      availableSoundFiles: "الملفات الصوتية المتاحة",
      playAudio: "تشغيل الصوت",
      download: "تنزيل",
      loading: "جارٍ التحميل",
      cancel: "إلغاء",
      ok: "موافق",
    },
    confirmPassenger: {
      title: "تأكيد الراكب",
      personalInfo: "المعلومات الشخصية",
      finish: "إنهاء",
      previous: "السابق",
      approveAndSave: "الموافقة والحفظ",
      approvePassenger: "الموافقة على الراكب",
    },
    chooseCars: {
      startTypingToSearch: "ابدأ الكتابة للبحث",
      cars: "السيارات",
      selectedCars: "السيارات المحددة",
      number: "الرقم",
    },
    statusToggle: {
      active: "نشط",
      blocked: "محظور",
      blockTitle: "حظر الحساب",
      activateTitle: "تفعيل الحساب",
      confirmBlock: "هل أنت متأكد من حظر هذا الحساب؟",
      confirmActivate: "هل أنت متأكد من تفعيل هذا الحساب؟",
      statusChanged: "تم تغيير حالة الحساب إلى {status} بنجاح",
      statusChangeFailed: "تعذر تغيير حالة الحساب",
    },
    bookingSuggestion: {
      title: "تم رفض اقتراح الحجز",
      captain: "الكابتن",
      passenger: "الراكب",
      pickup: "نقطة الانطلاق",
      status: "الحالة",
    },
    timeline: {
      day: "اليوم",
      from: "من",
      to: "إلى",
      tooltipFrom: "من",
      tooltipTo: "إلى",
      user: "المستخدم",
      estimatedTime: "الوقت التقديري",
      estimatedPrice: "السعر التقديري",
      createdAt: "تاريخ الإنشاء",
      bookingId: "رقم الحجز",
      rideId: "رقم الرحلة",
      endOfList: "لقد وصلت إلى نهاية القائمة",
      statusApproved: "موافَق عليه",
      statusAccepted: "مقبول",
      statusStarted: "في الطريق",
      statusArrived: "وصل الكابتن",
      statusPickedUp: "تم التقاط الراكب",
      statusDone: "منتهي",
      statusPaid: "مدفوع",
      statusCancelled: "ملغي",
      statusPaxCancelled: "ملغي من الراكب",
      statusCaxCancelled: "ملغي من الكابتن",
      statusSystemCancelled: "ملغي من النظام",
      statusOnline: "متصل",
    },
  },
  priceRulesPage: {
    pageTitle: "قواعد التسعير",
    newPriceRules: "قاعدة تسعير جديدة",
    colId: "المعرف",
    colPullDownCluster: "تجمّع النزول",
    colMaxPrice: "الحد الأقصى للسعر",
    colMinPrice: "الحد الأدنى للسعر",
    colMinTime: "الحد الأدنى للوقت",
    editAction: "تعديل قاعدة التسعير",
    deleteAction: "حذف قاعدة التسعير",
    toastDeleted: "تم حذف قاعدة التسعير بنجاح",
    somethingWentWrong: "حدث خطأ ما",
    createPageTitle: "إضافة قاعدة تسعير",
    createTitle: "إنشاء قاعدة تسعير جديدة",
    chooseCluster: "اختر التجمّع",
    minPriceLabel: "الحد الأدنى للسعر",
    maxPriceLabel: "الحد الأقصى للسعر",
    minTimeLabel: "الحد الأدنى للوقت",
    createBtn: "إنشاء قاعدة التسعير",
    fieldRequired: "هذا الحقل مطلوب",
    checkYourInfo: "تحقق من المعلومات المدخلة",
    toastCreated: "تمت إضافة قاعدة التسعير",
    editPageTitle: "تعديل قاعدة التسعير",
    minPriceFor: "الحد الأدنى للسعر لتجمّع {cluster}",
    maxPriceFor: "الحد الأقصى للسعر لتجمّع {cluster}",
    minTimeFor: "الحد الأدنى للوقت لتجمّع {cluster}",
    minPriceValue: "قيمة الحد الأدنى للسعر",
    maxPriceValue: "قيمة الحد الأقصى للسعر",
    minTimeValue: "قيمة الحد الأدنى للوقت",
    enterValidNumber: "يرجى إدخال رقم صالح",
    toastSaved: "تم حفظ قاعدة التسعير",
    toastSaveFailed: "فشل حفظ قاعدة التسعير",
    smsCodes: {
      pageTitle: "رموز التحقق (SMS)",
      colPhone: "الهاتف",
      colCode: "الرمز",
      colCreationTime: "وقت الإنشاء",
      colEndTime: "وقت الانتهاء",
    },
    notFound: {
      pageTitle: "الصفحة غير موجودة",
      message: "عذراً، الصفحة غير موجودة",
      goHome: "العودة إلى الرئيسية",
    },
    noteEditor: {
      noteLabel: "الملاحظة",
      noteMinLength: "يجب أن تتألف الملاحظة من أكثر من 3 أحرف",
      dateLabel: "التاريخ",
      showOnDispatch: "إظهار في شاشة الإسناد",
      noExpiryDate: "بدون تاريخ انتهاء",
      submitNote: "إرسال الملاحظة",
    },
  },
  reservationsPage: {
    pageTitle: "الحجوزات المسبقة",
    filterByDay: "تصفية حسب اليوم",
    statusPaxCancelled: "ألغيت من قبل الزبون",
    statusCaptainCancelled: "ألغيت من قبل السائق",
    statusSystemCancelled: "ألغيت من قبل مركز الاتصال",
    statusPending: "بانتظار الإسناد",
    statusAccepted: "تم إسناد الطلب",
    statusStarted: "السائق في الطريق",
    statusArrived: "وصل إلى نقطة الانطلاق",
    statusPickedUp: "بدأت الرحلة",
    statusDone: "وصل إلى الوجهة",
    statusPaid: "ناجحة",
    statusDeleted: "ملغاة",
    noData: "لا توجد بيانات متاحة",
    transformed: "محوّل",
    normal: "عادي",
    seatsCount: "راكب واحد | {count} ركاب",
    constraintEncompte: "على العداد",
    constraintLowCar: "سيارة منخفضة",
    constraintWheelchair: "كرسي متحرك",
    constraintPets: "حيوانات أليفة",
    constraintAmex: "AMEX",
    constraintMad: "MAD",
    constraintTest: "اختبار",
    comments: "الملاحظات:",
    creationDate: "تاريخ الإنشاء:",
    redistributeConfirm: "إعادة توزيع الطلب رقم {id}؟",
    no: "لا",
    yes: "نعم",
    savingChanges: "جارٍ حفظ التغييرات...",
    cancellationReason: "سبب الإلغاء:",
    close: "إغلاق",
    submit: "إرسال",
    colId: "المعرف",
    colClientName: "اسم الزبون",
    colTime: "الوقت",
    colRoomNumber: "رقم الغرفة",
    colPickup: "نقطة الانطلاق",
    colDropoff: "الوجهة",
    colVehicle: "المركبة",
    colStatus: "الحالة",
    colTaxiNumber: "رقم التكسي",
    colType: "النوع",
    changeTimeTitle: "تغيير موعد الطلب رقم {id}",
    changeTimeParagraph: "يرجى اختيار الموعد الجديد للحجز رقم <b>{id}</b> من <b>{pickup}</b> إلى <b>{dropoff}</b> عند <b>{time}</b>.",
    changeTimeParagraphNoDropoff: "يرجى اختيار الموعد الجديد للحجز رقم <b>{id}</b> من <b>{pickup}</b> عند <b>{time}</b>.",
    enterNewDatetime: "أدخل الموعد الجديد",
    timeChanged: "تم تغيير موعد الحجز رقم {id} من {from} إلى {to}.",
    orderRedistributed: "تمت إعادة توزيع الطلب رقم {id}",
    chooseReason: "يرجى اختيار سبب",
    orderCancelled: "تم إلغاء الطلب رقم {id}",
    logPageTitle: "سجل الحجز",
    logActionType: "نوع الإجراء",
    logActorSystem: "النظام",
    logActorCustomerDashboard: "لوحة العملاء",
    logActorAdminDashboard: "لوحة الإدارة",
    logStatusAccepted: "مقبول",
    logStatusRejected: "مرفوض",
    logStatusNoResponse: "بدون رد",
    logStatusPending: "قيد الانتظار",
    logTypeAll: "الكل",
    logTypeCreateBooking: "إنشاء حجز",
    logTypeCaptainSuggestion: "اقتراح كابتن",
    logTypeManualDispatch: "إسناد يدوي",
    logColCreationDate: "تاريخ الإنشاء",
    logColType: "النوع",
    logColDoer: "المنفّذ",
    logColRecipient: "المستلم",
    logColOldTime: "الوقت السابق",
    logColNewTime: "الوقت الجديد",
    blockedCaptainsTitle: "الكباتن المحظورون",
    tabActiveBlocks: "الحظر النشط",
    tabHistoricalBlocks: "سجل الحظر",
    username: "اسم المستخدم",
    colCaptainId: "معرف الكابتن",
    colCaptainUsername: "اسم مستخدم الكابتن",
    colStationId: "معرف المحطة",
    colOrderId: "رقم الطلب",
    colSuggestionTime: "وقت الاقتراح",
    colEndTime: "وقت الانتهاء",
    colBlocked: "محظور",
    dispatchingTitle: "الإسناد",
    dispatchingSettingsTitle: "إعدادات خوارزميات الإسناد",
    algorithm: "الخوارزمية",
    chooseValue: "اختر القيمة",
    switchTime: "وقت التبديل",
    save: "حفظ",
    invalidLength: "طول الأحرف غير صالح، المطلوب {len}",
    fieldRequired: "هذا الحقل مطلوب",
    settingsSaved: "تم حفظ الإعدادات",
    settingsSaveFailed: "فشل حفظ الإعدادات",
  },
  complaintsSystem: {
    pageTitle: "شكاوى المستخدمين",
    filters: {
      status: "الحالة",
      category: "الفئة",
      complainantType: "نوع مقدم الشكوى",
      from: "من",
      to: "إلى",
      bookingId: "رقم الحجز",
      search: "بحث بالاسم / الهاتف",
      apply: "تطبيق",
      reset: "إعادة تعيين",
    },
    columns: {
      id: "المعرف",
      createdAt: "تاريخ الإنشاء",
      complainant: "مقدم الشكوى",
      category: "الفئة",
      detail: "التفصيل",
      booking: "الحجز",
      status: "الحالة",
    },
    statuses: {
      NEW: "جديدة",
      IN_REVIEW: "قيد المراجعة",
      RESOLVED: "محلولة",
      REJECTED: "مرفوضة",
    },
    complainantTypes: {
      PASSENGER: "راكب",
      CAPTAIN: "سائق",
    },
    categories: {
      1: "شكوى على التطبيق",
      2: "شكوى على السائق",
      3: "شكوى على الخدمة",
      4: "شكوى على الراكب",
    },
    details: {
      101: "التطبيق بطيء أو يتجمد",
      102: "أخطاء في الخريطة أو تحديد الموقع",
      103: "مشكلة في الدفع أو المحفظة",
      104: "أخطاء في الإشعارات",
      105: "مشكلة في تسجيل الدخول",
      106: "مشكلة في واجهة التطبيق (UI/UX)",
      107: "أخرى",
      201: "سائق مدخن",
      202: "سائق غير مهذب",
      203: "سائق متأخر",
      204: "سائق يقود بتهور",
      205: "سائق لا يعرف الطريق",
      206: "سيارة غير نظيفة",
      207: "سيارة غير مكيفة",
      208: "تلاعب بالسعر",
      209: "إلغاء الرحلة دون سبب",
      210: "أخرى",
      301: "سعر الرحلة غير دقيق",
      302: "مسار الرحلة غير صحيح",
      303: "تأخير في وصول السيارة",
      304: "إلغاء الرحلة من قبل السائق",
      305: "مشكلة في الدفع",
      306: "الوجهة غير صحيحة",
      307: "أخرى",
      401: "راكب غير مهذب",
      402: "راكب متأخر",
      403: "إلغاء الرحلة دون سبب",
      404: "تغيير الوجهة دون إبلاغ",
      405: "تقييم غير عادل",
      406: "سلوك مشبوه",
      407: "أخرى",
    },
    actionTypes: {
      CAPTAIN_FINE: "غرامة شكوى على السائق",
      CAPTAIN_COMPENSATION: "تعويض شكوى للسائق",
      PASSENGER_FINE: "غرامة شكوى على الراكب",
      PASSENGER_COMPENSATION: "تعويض شكوى للراكب",
      WARNING: "تحذير",
      CLOSE: "إغلاق الشكوى",
    },
    detailsDialog: {
      title: "الشكوى #{id}",
      complainant: "مقدم الشكوى",
      against: "المشتكى عليه",
      phone: "الهاتف",
      booking: "الحجز",
      createdAt: "تاريخ الإنشاء",
      resolvedAt: "تاريخ الحل",
      category: "الفئة",
      detail: "التفصيل",
      description: "الوصف",
      noDescription: "لا يوجد وصف إضافي.",
      attachments: "المرفقات",
      noAttachments: "لا توجد مرفقات.",
      download: "تنزيل",
      attachmentLoadFailed: "فشل تحميل المرفق",
      actionsHistory: "سجل الإجراءات",
      noActions: "لا توجد إجراءات بعد.",
      colType: "الإجراء",
      colAmount: "المبلغ",
      colReason: "السبب",
      colAdmin: "بواسطة",
      colDate: "التاريخ",
      startReview: "بدء المراجعة",
      reject: "رفض",
      takeAction: "اتخاذ إجراء",
      rejectConfirmTitle: "رفض الشكوى",
      rejectConfirmText: "هل أنت متأكد من رفض الشكوى #{id}؟",
      close: "إغلاق",
    },
    actionModal: {
      title: "اتخاذ إجراء",
      actionType: "نوع الإجراء",
      amount: "المبلغ",
      reason: "السبب",
      submit: "تنفيذ",
      cancel: "إلغاء",
    },
    toasts: {
      loadFailed: "فشل تحميل الشكاوى",
      detailsFailed: "فشل تحميل تفاصيل الشكوى",
      statusUpdated: "تم تحديث حالة الشكوى",
      actionSubmitted: "تم تنفيذ الإجراء بنجاح",
      actionTypeRequired: "اختر نوع الإجراء",
      reasonRequired: "السبب مطلوب",
      amountRequired: "يجب إدخال مبلغ أكبر من صفر",
    },
  },
  routeTitles: {
    test: "اختبار",
    debugView: "عرض التصحيح",
    notifications: "الإشعارات",
    availableInterviewTimes: "مواعيد المقابلات المتاحة",
    interviews: "المقابلات",
    timeline: "الخط الزمني",
    pathDrawer: "راسم المسار",
    map: "الخريطة",
    hotels: "الفنادق",
    createHotel: "إنشاء فندق",
    editHotel: "تعديل فندق",
    users: "المستخدمون",
    createRestaurant: "إنشاء مطعم",
    editRestaurant: "تعديل مطعم",
    companyRequests: "طلبات الشركات",
    companyRequest: "طلب شركة",
    unregisteredPassengers: "الركاب غير المسجلين",
    unregisteredCaptains: "الكباتن غير المسجلين",
    ticketsMonitoring: "مراقبة التذاكر",
    ratingCauses: "أسباب التقييم",
    bonusPackages: "باقات المكافآت",
    bonusPackage: "باقة المكافآت",
    bonuses: "المكافآت",
    bonusTimeSlices: "الفترات الزمنية للمكافأة",
    anas: "المكافأة المشروطة",
    businessBalances: "أرصدة محافظ الأعمال",
    monacoEditor: "محرر موناكو",
    mapEditor: "محرر الخرائط",
    nationalities: "الجنسيات",
    locationContainers: "حاويات المواقع",
    addLocationContainer: "إضافة حاوية مواقع",
    editLocationContainer: "تعديل حاوية مواقع",
    landmarks: "المعالم",
    stations: "المحطات",
    addStation: "إضافة محطة",
    editStation: "تعديل محطة",
    addLandmark: "إضافة معلم",
    editLandmark: "تعديل معلم",
    sectors: "القطاعات",
    updateSeasonalDestinations: "تحديث الوجهات الموسمية",
    vehicleType: "أنواع المركبات",
    levels: "المستويات",
    changeCaptainReasons: "أسباب تغيير الكابتن",
    contractTemplate: "قالب العقد",
    restrictedAreas: "المناطق المحظورة",
    addRestrictedArea: "إضافة منطقة محظورة",
    editRestrictedArea: "تعديل منطقة محظورة",
    locations: "المواقع",
    addLocation: "إضافة موقع",
    editLocation: "تعديل موقع",
    captainsMap: "خريطة الكباتن",
    driversAnnouncements: "إعلانات السائقين",
    createDriver: "إنشاء سائق جديد",
    createCar: "إنشاء سيارة جديدة",
    captainCancellationReasons: "أسباب إلغاء الكابتن",
    cancellationReasons: "أسباب الإلغاء",
    punishment: "العقوبات",
    shiftsMap: "خريطة الورديات",
    testMaps: "خرائط تجريبية",
    events: "الفعاليات",
    createEvent: "إنشاء فعالية",
    eventDetails: "تفاصيل الفعالية",
    reservationQueue: "قائمة انتظار الحجوزات",
    shifts: "الورديات",
    termsAndConditions: "الشروط والأحكام",
    createTermsAndConditions: "إنشاء شروط وأحكام",
    broadcast: "البث",
    monitor: "المراقبة",
    ridesSearch: "البحث في الرحلات",
    bookingComplaints: "شكاوى الحجوزات",
    userComplaints: "شكاوى المستخدمين",
    analyticsSummary: "ملخص التحليلات",
    messages: "الرسائل",
    bookingLog: "سجل الحجز",
    surveys: "الاستبيانات",
    survey: "الاستبيان",
    createSurvey: "إنشاء استبيان",
    constraints: "القيود",
    createConstraint: "إنشاء قيد",
    editConstraint: "تعديل قيد",
    vacations: "الإجازات",
    globalMessages: "الرسائل العامة",
    maxBookingCount: "الحد الأقصى لعدد الحجوزات",
    seasonalReservations: "الحجوزات الموسمية",
    createSeasonalReservation: "إنشاء حجز موسمي",
    editSeasonalReservation: "تعديل حجز موسمي",
    captainComplaints: "شكاوى الكابتن",
    lostAndFound: "المفقودات",
    createLostAndFound: "بلاغ مفقودات جديد",
    editLostAndFound: "تعديل بلاغ مفقودات",
  },
  settingsPage: {
    pageTitle: "الإعدادات",
    tabGeneral: "عام",
    tabOnboardingVouchers: "قسائم الانضمام",
    tabMobileVersions: "إصدارات التطبيقات",
    tabServiceCommissions: "عمولات الخدمات",
    save: "حفظ",
    ruleEmail: "يرجى إدخال بريد إلكتروني صالح",
    ruleLength: "عدد الأحرف غير صالح، المطلوب {len}",
    ruleRequired: "هذا الحقل مطلوب",
    rulePositiveNumber: "يجب أن يكون رقماً موجباً",
    ruleVersion: "يجب أن يكون بتنسيق إصدار صالح (مثال: 1.0.0)",
    rulePercentage: "يجب أن يكون رقماً بين 0 و 100",
    unsavedChanges: "لديك تغييرات غير محفوظة. هل أنت متأكد من المغادرة؟",
    enterValidValues: "يرجى إدخال قيم صالحة",
    settingsSaved: "تم حفظ الإعدادات",
    failedSaveSettings: "فشل حفظ الإعدادات",
    generalTitle: "الإعدادات العامة",
    safeRideEnabled: "الرحلة الآمنة (كاميرات السيارات)",
    safeRideEnabledHint: "يتحكم بالبث المباشر فقط. عند الإيقاف يُمنع فتح الكاميرا، لكن الخدمات المؤشَّر عليها تبقى ظاهرة للركاب كالمعتاد",
    targetCaptainFallback: "إعادة عرض الطلبات الموجهة لسائق محدد على المنطقة",
    targetCaptainFallbackHint: "عند التفعيل يُعرض الطلب الموجه لسائق واحد على باقي سائقي المنطقة فور عدم أخذه له، بدلاً من انتظار الإلغاء التلقائي",
    proposalStaticMapEnabled: "صورة الخريطة في نافذة قبول الطلب لدى السائق",
    proposalStaticMapEnabledHint: "تستخدم خدمة خرائط جوجل الثابتة وتُحاسب على كل صورة. عند الإيقاف تبقى الخريطة التخطيطية المرسومة",
    captainRerouteEnabled: "إعادة رسم المسار في تطبيق الكابتن",
    captainRerouteEnabledHint: "عند التفعيل يطلب تطبيق الكابتن مساراً جديداً عندما تخرج السيارة عن المسار المرسوم، في الطريق إلى الراكب وأثناء الرحلة. عند الإيقاف يبقى المسار المرسوم عند قبول الطلب. لا يغيّر الأجرة",
    fareDistanceGuardEnabled: "حماية مسافة الأجرة",
    fareDistanceGuardEnabledHint: "عند التفعيل تُحتسب الرحلة التي لم تتحرك فيها السيارة على مسافتها المقاسة (أي الحد الأدنى للأجرة) بدل المسافة التقديرية للطلب، ولا تتجاوز المسافة المحتسبة ما تسمح به مدة الرحلة. عند الإيقاف يعود الحساب القديم: إذا لم تُسجَّل مسافة GPS تُحتسب المسافة التقديرية",
    accountActivitySection: "نشاط السائقين والركاب (تصنيف فعال / غير فعال)",
    captainActivityWindowDays: "فترة نشاط السائقين (أيام)",
    captainActivityWindowDaysHint: "يُعدّ السائق فعالاً إذا اتصل أو ردّ على طلب أو نفّذ رحلة خلال هذه المدة. الافتراضي 30 يوماً",
    passengerActivityWindowDays: "فترة نشاط الركاب (أيام)",
    passengerActivityWindowDaysHint: "يُعدّ الراكب فعالاً إذا طلب رحلة واحدة على الأقل خلال هذه المدة. الافتراضي 30 يوماً",
    ruleWholeDays: "يجب أن يكون عدداً صحيحاً من الأيام، 1 أو أكثر",
    welcomeBonusSection: "الرصيد الترحيبي للسائقين الجدد",
    welcomeBonusEnabled: "تفعيل الرصيد الترحيبي",
    welcomeBonusEnabledHint: "عند التفعيل يُمنح الكابتن عند الموافقة عليه رصيداً ترحيبياً مقيّداً يغطي عمولة الشركة على رحلاته فقط، ولا يمكن سحبه أو تحويله. الإيقاف يمنع المنح الجديد فقط",
    welcomeBonusDefault: "القيمة الافتراضية للرصيد الترحيبي (ل.س)",
    welcomeBonusDefaultHint: "يُمنح للكابتن عند الموافقة كرصيد مقيّد يغطي عمولة الشركة فقط، ولا يمكن سحبه أو تحويله؛ 0 = بدون رصيد ترحيبي",
    welcomeBonusValidityDays: "مدة صلاحية الرصيد الترحيبي (أيام)",
    welcomeBonusValidityDaysHint: "عدد الأيام التي يبقى فيها الرصيد صالحاً من تاريخ منحه، وبعدها يُغلق المتبقي تلقائياً بمهمة يومية. لا يغيّر تواريخ الانتهاء المحددة سابقاً؛ 0 = بلا انتهاء",
    welcomeBonusMax: "الحد الأعلى للرصيد الترحيبي للكابتن الواحد (ل.س)",
    welcomeBonusMaxHint: "لا يُمنح أي كابتن أكثر من هذا المبلغ، ويُرفض أي مبلغ أعلى منه في شاشة الموافقة؛ 0 = بلا حد أعلى",
    welcomeBonusMateriality: "حد الموافقة الثانية لإغلاق الرصيد الترحيبي (ل.س)",
    welcomeBonusMaterialityHint: "إغلاق رصيد ترحيبي متبقٍّ أعلى من هذا المبلغ ينتظر موافقة مستخدم آخر يملك صلاحية الموافقة؛ 0 = بلا موافقة ثانية",
    ruleWholeNumber: "يجب أن يكون عدداً صحيحاً، 0 أو أكثر",
    // Operational entries doc 2026-10-03, items 1.3/1.4/1.6 (online payments).
    onlinePaymentsSection: "الدفع الإلكتروني وتسوية الرحلات",
    onlinePaymentPendingWaitMinutes: "مهلة انتظار الدفع الإلكتروني المعلّق (دقائق)",
    onlinePaymentPendingWaitMinutesHint: "إذا بدأ الراكب دفعاً إلكترونياً خلال هذه المدة، يُطلب من السائق الانتظار قبل تأكيد استلام الأجرة. الافتراضي 15",
    onlineUnconfirmedCaptainSettle: "عند تأكيد السائق استلام أجرة رحلة إلكترونية لم يصل تأكيد دفعها",
    onlineUnconfirmedCaptainSettleHint: "لا يُقيَّد أي مبلغ على حساب بوابة الدفع إلا بعد تأكيد البوابة. نقدي: تُسجَّل الرحلة كرحلة نقدية استلم السائق أجرتها. رفض: لا يمكن للسائق إنهاء الدفع حتى يدفع الراكب",
    onlineUnconfirmedSettleCash: "تسجيلها كرحلة نقدية (افتراضي)",
    onlineUnconfirmedSettleRefuse: "رفض الإنهاء حتى يؤكَّد الدفع",
    unpaidOnlineRideAfterHours: "تسجيل الرحلة الإلكترونية غير المدفوعة كذمة بعد (ساعات)",
    unpaidOnlineRideAfterHoursHint: "رحلة بدفع إلكتروني بقيت منتهية دون دفع مؤكد أو معلّق بعد هذه المدة تُسجَّل آلياً كرحلة غير مدفوعة (مدين 12206). 0 = إيقاف التسجيل الآلي. الافتراضي 24",
    walletRequireBalanceAtBooking: "اشتراط رصيد كافٍ في المحفظة عند طلب رحلة بالمحفظة",
    walletRequireBalanceAtBookingHint: "عند التفعيل يُرفض طلب الرحلة بالمحفظة إذا كان الرصيد أقل من السعر التقديري. الإيقاف (الافتراضي) يسمح بالطلب ويدفع الراكب الفرق نقداً",
    cancellationCompensationSection: "تعويض إلغاء الرحلة للسائق",
    cancellationCompensationEnabled: "تفعيل التعويض التلقائي عند إلغاء الراكب بعد تحرّك السائق",
    cancellationCompensationEnabledHint: "عندما يلغي الراكب الطلب بعد أن بدأ السائق التحرّك نحوه (أو بعد وصوله) يُضاف إلى محفظة السائق تعويض عن كل كيلومتر من مسافة الاقتراب فوق المسافة المجانية، ويُقيَّد على الشركة (مدين 503 / دائن حساب السائق)",
    cancellationCompensationPerKm: "قيمة التعويض عن كل كيلومتر (ل.س)",
    cancellationCompensationPerKmHint: "المبلغ الذي يُضاف للسائق عن كل كيلومتر مستحق من مسافة الاقتراب",
    cancellationCompensationFreeKm: "المسافة المجانية (كم)",
    cancellationCompensationFreeKmHint: "الكيلومترات الأولى من مسافة الاقتراب التي لا يُعوَّض عنها",
    cancellationCompensationRounding: "طريقة احتساب الكيلومترات",
    cancellationCompensationRoundingHint: "كيلومترات كاملة فقط (3.7 كم = 1 كم فوق 2) أو احتساب الكسر نسبياً (1.7 كم)",
    cancellationCompensationRoundingFloor: "كيلومترات كاملة فقط",
    cancellationCompensationRoundingProrata: "نسبياً مع الكسور",
    cancellationCompensationMaxKm: "الحد الأعلى لمسافة الاقتراب المعوَّضة (كم)",
    cancellationCompensationMaxKmHint: "لا تُحتسب أي مسافة اقتراب أطول من هذا الحد؛ 0 = بلا حد أعلى",
    cancellationCompensationTolerance: "نسبة السماح فوق مسافة الاقتراب المرجعية (%)",
    cancellationCompensationToleranceHint: "مسافة الاقتراب الفعلية (GPS) لا تتجاوز مسافة الطريق من موقع السائق لحظة ضغطه «بدء» حتى نقطة الراكب مضافاً إليها هذه النسبة، منعاً لاحتساب الالتفاف أو الدوران",
    cancellationCompensationArrivedRadius: "نطاق الوصول حول نقطة الراكب (متر)",
    cancellationCompensationArrivedRadiusHint: "ضغط السائق «وصلت» يُحتسب مسافة اقتراب كاملة فقط إذا كان على بعد هذا العدد من الأمتار أو أقل من نقطة الراكب؛ خارج النطاق تُعتمد مسافة GPS المقاسة",
    cancellationCompensationIncludeCc: "يشمل الإلغاء من مركز الاتصال",
    cancellationCompensationIncludeCcHint: "النظام لا يعرف إن كان إلغاء مركز الاتصال بطلب من الراكب أو بسبب السائق؛ فعّله فقط إذا كانت إلغاءات المركز تتم بطلب الراكب",
    bookingProposalTimeSeconds: "مدة اقتراح الحجز بالثواني",
    bookingProposalTime: "مدة اقتراح الحجز",
    minReservationMinutes: "الحد الأدنى بالدقائق ليُعامل الحجز المسبق كطلب فوري",
    minDistanceMeters: "الحد الأدنى للمسافة لإنشاء طلب (متر)",
    minDistance: "الحد الأدنى للمسافة لإنشاء طلب",
    allowedWaitingTimeMin: "مدة الانتظار المسموحة (دقيقة)",
    allowedWaitingTime: "مدة الانتظار المسموحة",
    exchangeRate: "سعر الصرف",
    maxSearchSpaceKm: "أقصى نطاق للبحث (كم)",
    maxSearchSpace: "أقصى نطاق للبحث",
    dispatchMode: "وضع توزيع الطلبات الفورية",
    dispatchModeHint: "SEQUENTIAL = كابتن واحد بالتتابع · HYBRID = الأقرب أولاً ثم بث جماعي",
    hybridBroadcastAfterSec: "بدء البث الجماعي بعد (ثانية)",
    hybridBroadcastAfter: "مدة أولوية الأقرب قبل البث",
    broadcastBatchSize: "عدد الكباتن في دفعة البث",
    // Final-version doc 2026-10-05 (dormant): DISPATCH_MAX_NO_RESPONSE_OFFERS.
    dispatchMaxNoResponseOffers: "الحد الأقصى لإعادة عرض نفس الطلب على كابتن تجاهله (0 = بلا حد)",
    dispatchMaxNoResponseOffersHint: "للطلبات الفورية فقط: الكابتن الذي لم يردّ على نفس الطلب هذا العدد من المرات لا يُعرض عليه مجدداً. الرفض الصريح يستبعده دائماً. الافتراضي 0 = السلوك الحالي",
    instantTimeToCancelMin:"مهلة الإلغاء للطلبات الفورية (دقيقة)",
    instantTimeToCancel: "مهلة الإلغاء للطلبات الفورية",
    reservationTimeToCancelMin: "مهلة الإلغاء للحجوزات المسبقة (دقيقة)",
    reservationTimeToCancel: "مهلة الإلغاء للحجوزات المسبقة",
    reservationDispatchStartTimeMin: "وقت بدء إسناد الحجوزات المسبقة (دقيقة)",
    reservationDispatchStartTime: "وقت بدء إسناد الحجوزات المسبقة",
    reservationSectionTitle: "تذكيرات وتأكيد الحجوزات المسبقة",
    reservationReminderCadence: "مواعيد التذكير (دقائق قبل الموعد، مفصولة بفواصل)",
    reservationReminderCadenceHint: "تذكيرات تصاعدية، مثال: 120,60,30,15",
    reservationConfirmDeadline: "مهلة التأكيد (دقائق قبل الموعد)",
    reservationConfirmDeadlineMin: "مهلة التأكيد (دقيقة)",
    reservationConfirmRequired: "اشتراط تأكيد الكابتن للحجوزات المسبقة",
    reservationConfirmRequiredHint: "عند التفعيل يجب على الكابتن تأكيد الحجز المجدول قبل انتهاء المهلة",
    reservationSuggestionTime: "مدة اقتراح الحجز المسبق (ثواني)",
    reservationSuggestionTimeHint: "اتركه فارغاً للرجوع إلى مدة اقتراح الطلب الفوري",
    pricingSectionTitle: "التسعير المسبق",
    upfrontPricingEnabled: "تفعيل التسعير المسبق (السعر الثابت)",
    upfrontPricingEnabledHint: "عند التفعيل يُثبَّت السعر المقتبس عند الحجز، ولا تُضاف إلا الزيادات المبرَّرة في النهاية",
    extraKmTolerancePct: "سماحية المسافة الإضافية (%)",
    extraKmTolerancePctHint: "الكيلومترات الزائدة فوق هذه السماحية يمكن احتسابها فوق السعر الثابت",
    maxFareIncreasePct: "أقصى زيادة على السعر (%)",
    maxFareIncreasePctHint: "سقف تجاوز السعر النهائي للسعر المقتبس",
    stagingAllowedPhones: "أرقام مسموحة على بيئة الاختبار (مفصولة بفواصل)",
    stagingAllowedPhonesHint: "قائمة أمان بيئة الاختبار؛ اتركها فارغة للإبقاء على السلوك الحالي (بلا أثر على الإنتاج)",
    ruleCsvNumbers: "يجب أن تكون أرقاماً مفصولة بفواصل (مثال: 120,60,30,15)",
    maxNegativeAmountSyp: "أقصى مبلغ سالب (ل.س)",
    maxNegativeAmount: "أقصى مبلغ سالب",
    snapPhone: "هاتف سناب",
    snapEmail: "البريد الإلكتروني لسناب",
    snapWhatsapp: "واتساب سناب",
    onboardingTitle: "إعدادات قسائم الانضمام",
    voucherTitle: "العنوان",
    voucherCode: "الرمز",
    periodDays: "المدة (أيام)",
    period: "المدة",
    discountType: "نوع الحسم",
    discountTypePercentage: "نسبة مئوية",
    discountTypeFixed: "مبلغ ثابت",
    amount: "المبلغ",
    mobileVersionsTitle: "إعدادات إصدارات التطبيقات",
    passengerApp: "تطبيق الركاب",
    captainApp: "تطبيق الكابتن (السائق)",
    applePassenger: "آبل (iOS) - الركاب",
    androidPassenger: "أندرويد - الركاب",
    appleCaptain: "آبل (iOS) - الكابتن",
    androidCaptain: "أندرويد - الكابتن",
    updateMessagesPassenger: "رسائل التحديث - الركاب",
    updateMessagesCaptain: "رسائل التحديث - الكابتن",
    majorVersion: "الإصدار الرئيسي",
    minorVersion: "الإصدار الفرعي",
    generalMessageAr: "الرسالة العامة (العربية)",
    generalMessageEn: "الرسالة العامة (الإنجليزية)",
    forceUpdateMessageAr: "رسالة التحديث الإجباري (العربية)",
    forceUpdateMessageEn: "رسالة التحديث الإجباري (الإنجليزية)",
    optionalUpdateMessageAr: "رسالة التحديث الاختياري (العربية)",
    optionalUpdateMessageEn: "رسالة التحديث الاختياري (الإنجليزية)",
    serviceCommissionsTitle: "عمولات الخدمات",
    commissionsHint: "تُقتطع نسبة إيراد العمولة من الإجمالي؛ وتتقاسم نسبتا السائق والمالك المبلغ المتبقي (يجب أن يكون مجموعهما 100).",
    service: "الخدمة",
    selectService: "اختر خدمة",
    companyCommissionPercent: "إيراد العمولة (%)",
    companyCommission: "إيراد العمولة",
    driverCommissionPercent: "عمولة السائق (% من المتبقي)",
    driverCommission: "عمولة السائق",
    ownerCommissionPercent: "عمولة مالك السيارة (% من المتبقي)",
    ownerCommission: "عمولة مالك السيارة",
    remainderLine: "السائق + المالك = {sum} (يجب أن يساوي المجموع 100)",
    failedLoadServices: "فشل تحميل الخدمات",
    driverOwnerMustEqual100: "يجب أن يساوي مجموع نسبة السائق ونسبة المالك 100",
    commissionSaved: "تم حفظ العمولة",
    failedSaveCommission: "فشل حفظ العمولة",
  },
  staffPage: {
    pageTitle: "الموظفون",
    new: "جديد",
    id: "المعرف",
    email: "البريد الإلكتروني",
    firstName: "الاسم الأول",
    lastName: "الاسم الأخير",
    gender: "الجنس",
    dateOfBirth: "تاريخ الميلاد",
    phoneNumber: "رقم الهاتف",
    joinedAt: "تاريخ الانضمام",
    profileImage: "الصورة الشخصية",
    password: "كلمة المرور",
    role: "الدور",
    blacklistedAt: "تاريخ الحظر",
    blacklistNote: "ملاحظة الحظر",
    notAvailable: "غير متوفر",
    genderShortMale: "ذكر",
    genderShortFemale: "أنثى",
    addStaffTitle: "إضافة موظف جديد",
    genderMale: "ذكر",
    genderFemale: "أنثى",
    create: "إنشاء",
    cancel: "إلغاء",
    ruleEmail: "يرجى إدخال بريد إلكتروني صالح",
    rulePassword: "يجب أن تتكون كلمة المرور من 8 إلى 15 حرفاً.",
    ruleRequired: "هذا الحقل مطلوب",
    staffAdded: "تمت إضافة الموظف بنجاح",
    checkInfo: "تحقق من المعلومات المدخلة",
    profilePageTitle: "الملف الشخصي للموظف",
    disable: "تعطيل",
    personalInformation: "المعلومات الشخصية",
    status: "الحالة",
    noDataAvailable: "لا توجد بيانات",
    active: "نشط",
    inactive: "غير نشط",
    documents: "المستندات",
    workingContract: "عقد العمل",
    iban: "IBAN",
    paySlip: "كشف الراتب",
    planning: "جدول الدوام",
    open: "فتح",
    accountDisabled: "تم تعطيل الحساب بنجاح",
    accountEnabled: "تم تفعيل الحساب بنجاح",
    saved: "تم الحفظ",
    pleaseCheckAllFields: "يرجى التحقق من جميع الحقول",
    colDate: "التاريخ",
    colPickUpLocation: "موقع الانطلاق",
    colDropOffLocation: "موقع الوصول",
    colPassenger: "الراكب",
    colPrice: "السعر",
    colRating: "التقييم",
    colDatetime: "التاريخ والوقت",
    colStatus: "الحالة",
    colStationId: "معرف المحطة",
    captainProfile: "ملف الكابتن",
    rolesPageTitle: "الصلاحيات",
    colName: "الاسم",
    createdAt: "تاريخ الإنشاء",
    updatedAt: "تاريخ التعديل",
    permissionsCount: "عدد الصلاحيات",
    permissions: "الصلاحيات",
    permissionsBadge: "{count} صلاحية",
  },
  statisticsPage: {
    pageTitle: "الإحصائيات",
    analyticsSummaryTitle: "ملخص التحليلات",
    tabAutomaticReport: "التقرير التلقائي",
    tabCustomReport: "تقرير مخصص",
    tabOnlineCaptains: "الكباتن المتصلون",
    tabComplaintsStats: "إحصائيات الشكاوى",
    tabCustomerAppStats: "إحصائيات تطبيق الزبائن",
    type: "النوع",
    filterBy: "تصفية حسب",
    from: "من",
    to: "إلى",
    selectYear: "اختر السنة",
    typeAll: "الكل",
    typeReservation: "حجز مسبق",
    typeInstant: "فوري",
    filterDay: "يوم",
    filterMonth: "شهر",
    filterYear: "سنة",
    driverType: "نوع السائق",
    driverTypeAll: "الكل",
    driverTypeNormal: "عادي",
    driverTypeSeasonal: "موسمي",
    driverTypeSpecific: "سائق محدد",
    captain: "الكابتن",
    searchForCaptain: "ابحث عن كابتن",
    user: "المستخدم",
    searchForUser: "ابحث عن مستخدم",
    passenger: "الراكب",
    searchForPassenger: "ابحث عن راكب",
    exportPdf: "تصدير PDF",
    percentage: "النسبة",
    count: "العدد",
    statKeys: {
      pending: "قيد الانتظار",
      cancelled: "الملغاة",
      completed: "المكتملة",
    },
    sectionOrderType: "نوع الطلب",
    instant: "فوري",
    reservation: "حجز مسبق",
    sectionOrderStatus: "حالة الطلب",
    created: "منشأة",
    completed: "مكتملة",
    cancelled: "ملغاة",
    sectionDestinationType: "نوع الوجهة",
    destMc: "MC",
    destPext: "PEXT",
    destExt: "EXT",
    sectionOrderOrigin: "مصدر الطلب",
    originCc: "مركز الاتصال (CC)",
    originApp: "التطبيق",
    originHotel: "فندق",
    originCompany: "شركة",
    sectionOrderCancellation: "إلغاء الطلب",
    ccCancelledWithReason: "إلغاء مركز الاتصال ({reason})",
    driverCancelledWithReason: "إلغاء السائق ({reason})",
    customerCancelled: "ألغاه الزبون",
    hotelCancelled: "ألغاه الفندق",
    companyCancelled: "ألغته الشركة",
    companyCancelledAuto: "إلغاء تلقائي من الشركة",
    parentCancelledAuto: "إلغاء تلقائي للطلب الأصلي",
    sectionReservationType: "نوع الحجز المسبق",
    reservationNormal: "عادي",
    reservationTransformed: "محوَّل",
    reservationShort: "قصير",
    sectionPaymentMethod: "طريقة الدفع",
    paymentInside: "داخل التطبيق",
    paymentOutside: "خارج التطبيق",
    encompt: "على الحساب (En Compte)",
    paymentFamily: "عائلي",
    paymentCompany: "شركة",
    sectionVehicleType: "نوع المركبة",
    sectionConstraints: "القيود",
    priorityOrder: "طلب ذو أولوية",
    replacedWith2Cars: "استُبدل بسيارتين",
    sectionSpecialActions: "إجراءات خاصة",
    driverRedispatched: "أُعيد إسناد السائق",
    editedBooking: "حجز معدَّل",
    ccRedispatched: "أعاد مركز الاتصال الإسناد",
    driverTransferred: "تم نقل السائق",
    driverExchanged: "تم تبديل السائق",
    directDispatch: "إسناد مباشر",
    proposalRejected: "اقتراح مرفوض",
    noAnswerInStation: "لا يوجد رد في المحطة",
    noAnswerFree: "لا يوجد رد (متاح، عند الوجهة)",
    gotPunished: "تعرّض لعقوبة",
    clientChangedPaymentMethod: "غيّر الزبون طريقة الدفع",
    extAffectedToSeasonal: "أُسند EXT إلى سائق موسمي",
    dispatchedTwiceSameDriver: "أُسند مرتين لنفس السائق",
    sectionComplaints: "الشكاوى",
    hasComplaint: "يتضمن شكوى",
    sectionTips: "الإكراميات",
    withTip: "مع إكرامية",
    withoutTip: "بدون إكرامية",
    ordersDestinations: "وجهات الطلبات",
    ordersPickups: "نقاط انطلاق الطلبات",
    getData: "جلب البيانات",
    clearFilter: "مسح الفلاتر",
    getPdf: "تنزيل PDF",
    constraintsNotLoaded: "تعذر تحميل القيود",
    vehicleTypesNotLoaded: "تعذر تحميل أنواع المركبات",
    captainCancellationReasonsNotLoaded: "تعذر تحميل أسباب إلغاء الكباتن",
    fromDate: "من تاريخ",
    toDate: "إلى تاريخ",
    loadData: "تحميل البيانات",
    bookings: "الحجوزات",
    canceledOrders: "الطلبات الملغاة",
    completedOrders: "الطلبات المكتملة",
    financials: "المالية",
    bookingRevenue: "إيراد الحجوزات",
    redeemedVouchers: "القسائم المستخدمة",
    captainsProfit: "أرباح الكباتن",
    snapProfit: "أرباح سناب",
    commissionOwnership: "العمولة والملكية",
    driverShare: "حصة السائق",
    companyCommission: "إيراد العمولة",
    carOwnersShareExternal: "حصة مالكي السيارات (2118)",
    companyCarsShare: "إيراد الرحلة (سيارات الشركة)",
    ownerShareTotal: "إيراد الرحلة (الإجمالي)",
    companyTotalRevenue: "إجمالي إيراد الشركة",
    companyRevenueNote: "إجمالي إيراد الشركة = إيراد العمولة + إيراد الرحلة لسيارات الشركة.",
    passengersDrivers: "الركاب والسائقون",
    newPassengers: "الركاب الجدد",
    activePassengers: "الركاب النشطون",
    activeDrivers: "السائقون النشطون",
    selectDateRange: "يرجى اختيار نطاق زمني",
    selectBothDates: "يرجى اختيار تاريخي البداية والنهاية",
    fromBeforeTo: "يجب أن يكون تاريخ البداية قبل تاريخ النهاية",
    currency: "ل.س",
  },
  vouchersPage: {
    pageTitleMarketing: "القسائم التسويقية",
    pageTitlePersonal: "القسائم الشخصية",
    pageTitleMarketingPending: "القسائم التسويقية قيد الانتظار",
    pageTitleMarketingExpired: "القسائم التسويقية المنتهية",
    pageTitlePersonalPending: "القسائم الشخصية قيد الانتظار",
    pageTitlePersonalExpired: "القسائم الشخصية المنتهية",
    tabPending: "قيد الانتظار",
    tabExpired: "منتهية الصلاحية",
    new: "جديد",
    addVoucherTitle: "إضافة قسيمة",
    title: "العنوان",
    code: "الرمز",
    type: "النوع",
    discountType: "نوع الحسم",
    amount: "المبلغ",
    startDate: "تاريخ البداية",
    endDate: "تاريخ النهاية",
    useTimes: "عدد مرات الاستخدام",
    maxRedemption: "الحد الأقصى للاستخدام",
    usedAmount: "المبلغ المستخدم",
    createdBy: "أنشئت بواسطة",
    active: "نشطة",
    creationDate: "تاريخ الإنشاء",
    passenger: "الراكب",
    searchPassengerPlaceholder: "ابحث عن راكب",
    add: "إضافة",
    cancel: "إلغاء",
    discountTypePercentage: "نسبة مئوية",
    discountTypeFixed: "مبلغ ثابت",
    typeDedicated: "مخصصة",
    typeOnboarding: "ترحيبية",
    system: "النظام",
    voucherAdded: "تمت إضافة القسيمة بنجاح",
    errorOccurred: "حدث خطأ",
    ruleRequired: "هذا الحقل مطلوب",
    ruleNumber: "يجب أن يكون رقماً موجباً",
    ruleLength: "عدد الأحرف غير صالح، المطلوب {len}",
  },
  zonesPage: {
    pageTitle: "المناطق",
    editorPageTitle: "محرر المناطق",
    editorTitle: "محرر المنطقة",
    name: "الاسم",
    save: "حفظ",
    cancel: "إلغاء",
    saveChangesQuestion: "حفظ التغييرات؟",
    savingChanges: "جارٍ حفظ التغييرات...",
    saved: "تم الحفظ",
    notSaved: "لم يتم الحفظ",
    choosePolygon: "يرجى رسم حدود المنطقة على الخريطة!",
    centroidInside: "يجب أن تكون نقطة المركز داخل حدود المنطقة",
    required: "هذا الحقل مطلوب",
    mustBeNumber: "يجب أن تكون القيمة رقماً",
    dateCreated: "تاريخ الإنشاء",
    dateUpdated: "تاريخ التعديل",
    lastDateUpdated: "آخر تعديل",
    cancellationReasonsTitle: "أسباب الإلغاء",
    captainCancellationReasonsTitle: "أسباب إلغاء الكباتن",
    showDeleted: "عرض المحذوفة",
    notAvailable: "غير متوفر",
    textEn: "النص (بالإنجليزية)",
    textAr: "النص (بالعربية)",
    showToUser: "عرض للمستخدم",
    showToCaptain: "عرض للكابتن",
    showToPassenger: "عرض للراكب",
    id: "المعرف",
    pleaseStandBy: "يرجى الانتظار",
    statusBusy: "مشغول",
    statusFree: "متاح",
    statusAtDestination: "عند الوجهة",
    statusUnavailable: "غير متاح",
    notificationsTitle: "الإشعارات",
    allNotifications: "الكل",
    liveFeedDisconnected: "انقطع البث المباشر - جاري إعادة الاتصال...",
    allCaptains: "الكل",
    captainsFetchFailed: "تعذر تحديث قائمة الكباتن، يتم عرض آخر المواقع المعروفة",
  },
  acquisitionPage: {
    pageTitleInterviews: "المقابلات",
    pageTitleAvailableInterviews: "المقابلات المتاحة",
    pageTitleCompanyRequests: "طلبات الشركات",
    pageTitleCompanyRequest: "طلب شركة",
    newStatus: "حالة جديدة",
    search: "بحث",
    searchInterviewsTitle: "البحث عن مقابلات الكابتن",
    captain: "الكابتن",
    updateStatusTitle: "تعديل حالة موجودة",
    createStatusTitle: "إنشاء حالة جديدة",
    statusName: "اسم الحالة",
    ruleMinThreeChars: "يجب ألا تقل عن 3 أحرف",
    colorLabel: "اللون:",
    ruleRequired: "مطلوب",
    save: "حفظ",
    editInterviewTitle: "تعديل تفاصيل المقابلة",
    date: "التاريخ",
    time: "الوقت",
    goToProfile: "الذهاب إلى الملف الشخصي",
    noCaptain: "لا يوجد كابتن",
    status: "الحالة",
    toastCaptainCreated: "تم إنشاء الكابتن",
    toastDeleted: "تم الحذف",
    toastDeleteStatusFailed: "تعذّر الحذف. يرجى التأكد من إزالة جميع المقابلات المرتبطة بهذه الحالة.",
    deleteShiftConfirm: "هل تريد حذف هذه الفترة؟",
    cancel: "إلغاء",
    delete: "حذف",
    updateSliceTitle: "تعديل مدة المقابلة",
    interviewInterval: "مدة المقابلة (بالدقائق)",
    updateMaxCaptainsTitle: "تعديل الحد الأقصى للكباتن لكل مقابلة",
    maxCaptainsLabel: "الحد الأقصى للكباتن (لكل مقابلة)",
    available: "متاح",
    toastSaved: "تم الحفظ!",
    toastErrorLog: "حدث خطأ (راجع سجل الأخطاء)",
    sameDayAlert: "يجب أن يكون في نفس اليوم",
    colCompanyName: "اسم الشركة",
    colContactName: "اسم جهة الاتصال",
    colEmail: "البريد الإلكتروني",
    colPhone: "الهاتف",
    colLegalForm: "الشكل القانوني",
    colStreet: "الشارع",
    colNo: "الرقم",
    colPostalCode: "الرمز البريدي",
    colCity: "المدينة",
    colRciNo: "رقم السجل التجاري",
    colCreationDate: "تاريخ الإنشاء",
    colApprovalDate: "تاريخ الموافقة",
    actionCompanyRequest: "طلب شركة",
    approve: "موافقة",
    approved: "تمت الموافقة",
    information: "المعلومات",
    id: "المعرّف",
    additionalInfo: "معلومات إضافية",
    rciExtract: "مستخرج السجل التجاري",
    open: "فتح",
  },
  bonusPackagePage: {
    pageTitle: "باقات المكافآت",
    conditionalBonus: "المكافأة المشروطة",
    search: "بحث",
    new: "جديد",
    save: "حفظ",
    saved: "تم الحفظ بنجاح",
    noResults: "لم يُعثر على نتائج للبحث عن \"{search}\".",
    id: "المعرّف",
    actions: "الإجراءات",
    bonusesPageTitle: "مكافآت الباقة",
    packageBonusesTitle: "مكافآت {name}",
    addNewBonus: "إضافة مكافأة جديدة",
    timeSlicesAction: "الفترات الزمنية",
    minRides: "الحد الأدنى للرحلات",
    minBookings: "الحد الأدنى للحجوزات",
    minOnlineHours: "الحد الأدنى لساعات الاتصال",
    minRating: "الحد الأدنى للتقييم",
    minRejectRate: "الحد الأدنى لمعدل الرفض",
    minCancellationRate: "الحد الأدنى لمعدل الإلغاء",
    specificAreas: "مناطق محددة",
    specificServices: "خدمات محددة",
    priseType: "نوع المكافأة",
    priseValue: "قيمة المكافأة",
    captainsPageTitle: "كباتن الباقة",
    packageCaptainsPre: "الكباتن المشتركون في باقة",
    packageCaptainsPost: "للمكافآت",
    addNewCaptains: "إضافة كباتن جدد",
    captains: "الكباتن",
    uploadCsvHint: "أو ارفع ملف CSV (كل سطر يمثّل معرّف كابتن)",
    joinDate: "تاريخ الانضمام:",
    detach: "فصل",
    detachConfirm: "هل أنت متأكد من فصل {name}؟",
    captain: "الكابتن",
    startDate: "تاريخ البدء",
    bonusTimeSlices: "الفترات الزمنية للمكافأة",
    addNewTimeSlice: "إضافة فترة زمنية جديدة",
    startTime: "وقت البدء",
    endTime: "وقت الانتهاء",
  },
  companiesPage: {
    companiesPageTitle: "الشركات",
    hotelsPageTitle: "الفنادق",
    companyPageTitle: "شركة",
    hotelPageTitle: "فندق",
    editHotelPageTitle: "تعديل الفندق",
    new: "جديد",
    newHotel: "فندق جديد",
    profile: "الملف الشخصي",
    editHotel: "تعديل الفندق",
    deleteHotel: "حذف الفندق",
    tableCompanies: "الشركات",
    tableHotelsUsers: "مستخدمو الفنادق",
    tableHotels: "الفنادق",
    colNumber: "الرقم",
    colId: "المعرف",
    colCompanyName: "اسم الشركة",
    colHotelName: "اسم الفندق",
    colName: "الاسم",
    colPhoneNumber: "رقم الهاتف",
    colPhone: "رقم الهاتف",
    colCreationDate: "تاريخ الإنشاء",
    colWebsite: "الموقع الإلكتروني",
    colAddress: "العنوان",
    colBillingEmail: "بريد الفوترة",
    colEmail: "البريد الإلكتروني",
    colUserName: "اسم المستخدم",
    colLandmark: "معلم قريب",
    createCompanyAccount: "إنشاء حساب شركة",
    createHotelAccount: "إنشاء حساب فندق",
    createNewHotel: "إنشاء فندق جديد",
    companyName: "اسم الشركة",
    managerFullName: "الاسم الكامل للمدير",
    email: "البريد الإلكتروني",
    password: "كلمة المرور",
    address: "العنوان",
    addressPlaceholder: "أدخل عنوانك",
    phoneNumber: "رقم الهاتف",
    businessEmail: "البريد الإلكتروني للأعمال",
    hotelName: "اسم الفندق",
    hotelsLabel: "الفنادق",
    selectHotelPlaceholder: "اختر فندقك",
    create: "إنشاء",
    save: "حفظ",
    ruleValidEmail: "الرجاء إدخال بريد إلكتروني صحيح",
    ruleCharLength: "طول غير صالح، المطلوب {len}",
    rulePassword: "يجب أن تتكوّن كلمة المرور من 8 إلى 15 حرفاً.",
    rulePhone: "رقم هاتف غير صالح !",
    ruleWebsite: "موقع إلكتروني غير صالح.",
    ruleRequired: "هذا الحقل مطلوب",
    toastCompanyCreated: "تم إنشاء الشركة",
    toastCheckInfo: "تحقق من معلوماتك",
    toastHotelCreated: "تم إنشاء الفندق",
    toastHotelDeleted: "تم حذف الفندق بنجاح",
    toastSomethingWrong: "حدث خطأ ما",
    toastFillData: "الرجاء تعبئة جميع البيانات",
    toastHotelSaved: "تم حفظ الفندق",
    toastHotelSaveFailed: "فشل حفظ الفندق",
  },
  debugPage: {
    estimatedTime: "الوقت المقدر هو {estimated}",
    datetime: "التاريخ والوقت",
    checkResponse: "التحقق من الاستجابة",
    filter: "تصفية",
    filterBoth: "كلاهما",
    filterPassenger: "راكب",
    filterCaptain: "كابتن",
  },
  legacySettingsPage: {
    pageTitle: "الإعدادات",
    heading: "الإعدادات",
    tabBasic: "أساسي",
    tabAi: "الذكاء الاصطناعي",
    tabMobileVersions: "إدارة إصدارات التطبيقات",
    tabCaptain: "الكابتن",
    tabHrAccounting: "محاسبة الموارد البشرية",
    warehouseRefresh: "تحديث المستودع",
    differenceGoReturn: "الفارق بين رحلة الذهاب والعودة للرحلات ذهاباً وإياباً (بالدقائق)",
    maxDaysBgChecked: "الحد الأقصى لأيام عمل الكباتن المدقّقين أمنياً",
    maxRidesBgChecked: "الحد الأقصى لرحلات الكباتن المدقّقين أمنياً",
    maxCaptainLateness: "أقصى تأخير للكابتن دون فرض غرامة على الراكب (بالدقائق)",
    interviewSlice: "فاصل المقابلات (المدة بين المقابلات)",
    maxCaptainsPerInterview: "الحد الأقصى للكباتن في المقابلة الواحدة",
    defaultWhatsapp: "واتساب الافتراضي",
    successfulPoolingFactor: "معامل التجميع الناجح",
    unsuccessfulPoolingFactor: "معامل التجميع غير الناجح",
    longDistancePerKm: "ما يُعدّ مسافة طويلة (لكل كم)",
    paymentLimit: "حد الدفع",
    landMarkRadius: "نطاق المعلم (بالأمتار)",
    penaltyTimeLimit: "مهلة الغرامة (بالدقائق)",
    minDistanceToPlaceRequest: "الحد الأدنى للمسافة لإنشاء طلب (بالأمتار)",
    captainMinimumCharge: "الحد الأدنى لأجر الكابتن (ل.س)",
    smsWhenWhatsappDown: "الأرقام التي تُرسل إليها رسالة عند تعطّل خادم واتساب",
    commaSeparated: "مفصولة بفواصل",
    anasBabyVoucherGenerator: "مولّد قسائم أنس بيبي",
    captainSuggestionInstant: "مدة انتظار اقتراح الكابتن بالثواني للطلبات الفورية",
    captainSuggestionReservation: "مدة انتظار اقتراح الكابتن بالثواني للحجوزات المسبقة",
    maxSetDestinationPerDay: "الحد الأقصى لتحديد الوجهة يومياً",
    uploadIdDialogForRegisteredAfter: "نافذة رفع الهوية للمسجّلين بعد",
    aiUserId: "معرّف مستخدم الذكاء الاصطناعي",
    autoDispatchAi: "الإسناد التلقائي (الذكاء الاصطناعي)",
    aiSuggestionUpdateTime: "اقتراح الذكاء الاصطناعي (تحديث الوقت)",
    maxTimeToDispatchAi: "أقصى وقت للإسناد (الذكاء الاصطناعي) بالدقائق",
    aiSnoozeDuration: "مدة تأجيل الذكاء الاصطناعي (بالدقائق)",
    aiBookingSnoozeDuration: "مدة تأجيل الحجز الفوري للذكاء الاصطناعي (بالثواني)",
    minDiffCreationNowAi: "الحد الأدنى للفارق بين الآن ووقت الإنشاء ليقوم الذكاء الاصطناعي بالإسناد (بالدقائق)",
    aiCostPerMinute: "تكلفة الذكاء الاصطناعي (لكل دقيقة)",
    aiCostPerKm: "تكلفة الذكاء الاصطناعي (لكل كم)",
    aiCostPerRefusedBooking: "تكلفة الذكاء الاصطناعي (لكل حجز مرفوض)",
    captainApp: "تطبيق الكابتن",
    captainAppLastUpdateVersion: "أحدث رقم إصدار لتحديث تطبيق الكابتن",
    captainAppLastRequiredVersion: "أحدث رقم إصدار مطلوب لتطبيق الكابتن",
    passengerApp: "تطبيق الراكب",
    passengerAppLastUpdateVersion: "أحدث رقم إصدار لتحديث تطبيق الراكب",
    passengerAppLastRequiredVersion: "أحدث رقم إصدار مطلوب لتطبيق الراكب",
    minRatingToAccept: "الحد الأدنى للتقييم لقبول الاقتراحات",
    minRatingToSeeDestination: "الحد الأدنى للتقييم لرؤية الوجهة",
    minAcceptanceRatioToAccept: "الحد الأدنى لنسبة القبول لقبول الطلبات",
    minAcceptanceRatioToSeeDestination: "الحد الأدنى لنسبة القبول لرؤية الوجهة",
    general: "عام",
    numberOfDaysMonthly: "عدد الأيام شهرياً",
    monthStartingDay: "يوم بدء الشهر",
    maxMissedFingerprints: "الحد الأقصى للبصمات الفائتة شهرياً",
    maxReportingTimeDays: "الحد الأقصى لمدة الإبلاغ (بالأيام)",
    dailyMeetings: "الاجتماعات اليومية:",
    startTime: "وقت البدء",
    maxUnjustifiedLateDays: "الحد الأقصى لأيام التأخير غير المبرّر",
    latenessPenalty: "غرامة التأخير",
    holidays: "الإجازات:",
    sickDaysLimit: "حد الأيام المرضية",
    personalDaysLimit: "حد الأيام الشخصية",
    save: "حفظ",
    toastDone: "تم!",
    toastError: "خطأ!",
    toastSaved: "تم الحفظ!",
    toastSaveProblem: "حدثت مشكلة أثناء الحفظ (راجع سجل الأخطاء)",
  },
  legacyProfilePage: {
    userPageTitle: "ملف المستخدم",
    captainPageTitle: "ملف الكابتن",
    addNote: "إضافة ملاحظة جديدة",
    applyJustifyTicket: "تقديم تذكرة تبرير",
    userInfo: "معلومات المستخدم",
    usersEmail: "البريد الإلكتروني للمستخدم",
    email: "البريد الإلكتروني",
    firstName: "الاسم الأول",
    lastName: "الاسم الأخير",
    gender: "الجنس",
    male: "ذكر",
    female: "أنثى",
    phoneNumber: "رقم الهاتف",
    phone: "الهاتف",
    birthday: "تاريخ الميلاد",
    workingContract: "عقد العمل",
    iban: "الآيبان (IBAN)",
    paySlip: "قسيمة الراتب",
    planning: "التخطيط",
    from: "من",
    to: "إلى",
    ticketsAssigned: "التذاكر المُسندة",
    ticketsResolved: "التذاكر المحلولة",
    activeTickets: "التذاكر النشطة",
    avgTicketLifetimeHour: "متوسط عمر التذكرة (ساعة)",
    rejectionRate: "معدل الرفض",
    averageDelayMinute: "متوسط التأخير (دقيقة)",
    tabInfo: "المعلومات",
    tabStats: "الإحصائيات",
    tabLog: "السجل",
    tabNotes: "الملاحظات",
    tabLeaves: "الإجازات",
    tabExtraHours: "الساعات الإضافية",
    tabSalaryReport: "تقرير الراتب",
    ruleRequired: "هذا الحقل مطلوب.",
    ruleEmail: "بريد إلكتروني غير صالح.",
    rulePhone: "رقم هاتف غير صالح (يجب أن يكون 9 أرقام بالضبط)",
    rulePassword: "يجب أن تكون كلمة المرور بين 6 و32 حرفاً",
    rulePasswordMatch: "يجب أن تطابق كلمة المرور",
    notesExpiryDate: "تاريخ الانتهاء",
    notesCreatedAt: "تاريخ الإنشاء",
    notesAuthor: "الكاتب",
    notesNote: "الملاحظة",
    logsDate: "التاريخ",
    logsAction: "الإجراء",
    logCreated: "أنشأ {resource} جديداً بالمعرّف {id}",
    logChanged: "{event} {resource} بالمعرّف {id}",
    forEver: "دائماً",
    toastSent: "تم الإرسال",
    toastSaved: "تم الحفظ",
    toastCheckFields: "يرجى التحقق من جميع الحقول",
    toastSavedMeta: "تم حفظ البيانات",
    loadingData: "جارٍ تحميل البيانات",
    enterMessage: "أدخل الرسالة المراد إرسالها",
    message: "الرسالة",
    requiredField: "حقل مطلوب",
    sendMessage: "إرسال رسالة",
    ratingSummary: "{avg} من {count} تقييم",
    noRatings: "لا توجد تقييمات",
    captainAvgSpeed: "متوسط سرعة الكابتن",
    allAvgSpeed: "متوسط السرعة العام",
    kmh: "كم/س",
    resetPicture: "إعادة تعيين الصورة",
    photo: "الصورة",
    selectImage: "اختر صورة",
    save: "حفظ",
    noConviction: "وثيقة عدم المحكومية",
    captainTabInfo: "المعلومات",
    captainTabRateHistory: "سجل التقييمات",
    captainTabCheckLog: "سجل الحضور",
    captainTabContracts: "العقود",
    captainTabCars: "السيارات",
    captainTabSchedule: "الجدول",
    captainTabRides: "الرحلات",
    captainTabAccounting: "المحاسبة",
    captainTabNotes: "الملاحظات",
    captainTabStats: "الإحصائيات",
    captainTabTimeline: "الخط الزمني",
    captainTabBlacklistLog: "سجل القائمة السوداء",
    captainNotFound: "الكابتن غير موجود",
    failedGetCaptain: "فشل جلب بيانات الكابتن، يرجى فتح أداة الفحص وأخذ لقطة شاشة",
    tried: "تمت المحاولة",
    saved: "تم الحفظ",
    checkFields: "يرجى التحقق من جميع الحقول",
    checkLog: {
      checkLogsFor: "سجل حضور {name}",
      summary: "الملخّص",
      search: "بحث",
      id: "المعرّف",
      type: "النوع",
      kilometers: "الكيلومترات",
      from: "من",
      to: "إلى",
      noResults: "لم يُعثر على نتائج لبحثك عن \"{query}\".",
      details: "التفاصيل",
      stillOnline: "لا يزال متصلاً",
    },
  },
  ticketingPage: {
    pageTitle: "التذكرة",
    monitoringTitle: "مراقبة التذاكر",
    ticketNo: "التذكرة {id}",
    info: "المعلومات",
    name: "الاسم",
    type: "النوع",
    rate: "التقييم",
    resTickets: "التذاكر المحلولة",
    unresTickets: "التذاكر غير المحلولة",
    ticketType: "نوع التذكرة",
    createdAt: "أُنشئت في",
    showRide: "عرض الرحلة",
    onPassenger: "على الراكب",
    storedTime: "( الوقت المخزَّن)",
    onCaptain: "على الكابتن",
    assignedTo: "مُسندة إلى",
    noOne: "لا أحد",
    ticketPath: "مسار التذكرة",
    takeAction: "اتخاذ إجراء",
    selectAction: "اختر إجراءً",
    ticketReport: "تقرير التذكرة",
    ticketEventsLog: "سجل أحداث التذكرة",
    relatedTickets: "التذاكر ذات الصلة",
    noRelatedTickets: "لا توجد تذاكر ذات صلة",
    reportUser: "المستخدم",
    reportProblem: "المشكلة",
    reportSolution: "الحل",
    reportDate: "التاريخ",
    na: "غير متاح",
    noteTag: "(ملاحظة)",
    confirmClose: "هل أنت متأكد من إغلاق هذه التذكرة؟",
    confirmReopen: "هل أنت متأكد من إعادة فتح هذه التذكرة؟",
    enterMessage: "أدخل الرسالة المراد إرسالها",
    voucherGift: "هدية قسيمة",
    walletBonus: "مكافأة المحفظة",
    editRide: "تعديل الرحلة",
    givePenalty: "فرض غرامة",
    revokePenalty: "إلغاء الغرامة",
    confirmFreeRide: "هل أنت متأكد من منح قسيمة رحلة مجانية؟",
    confirmReassign: "هل أنت متأكد من إعادة إسناد التذكرة؟",
    addingNote: "إضافة ملاحظة إلى التذكرة",
    changeCheckLogTime: "تغيير وقت سجل الحضور",
    revokeRide: "إلغاء الرحلة",
    justifyCheckLog: "تبرير سجل الحضور",
    problem: "المشكلة",
    problemPlaceholder: "يرجى وصف المشكلة",
    measuresTaken: "الإجراءات المتخذة",
    measuresPlaceholder: "يرجى وصف ما قمت به لحل المشكلة",
    note: "الملاحظة",
    notePlaceholder: "أدخل ملاحظتك هنا",
    message: "الرسالة",
    user: "المستخدم",
    typeLabel: "النوع",
    amount: "المبلغ",
    amountSyp: "المبلغ (ل.س)",
    confirmRevokePenalty: "هل أنت متأكد من إلغاء الغرامة على هذا الحجز؟",
    confirmRevokeRide: "هل أنت متأكد من إلغاء الرحلة؟",
    poolingNote: "ملاحظة: إذا كانت هذه الرحلة تشاركية فسيتم إلغاء جميع الحجوزات",
    updateMeterPrice: "تحديث سعر العدّاد",
    meterPrice: "سعر العدّاد",
    refunder: "الجهة المُعيدة للمبلغ",
    submit: "إرسال",
    updatePaidAmount: "تحديث المبلغ المدفوع",
    passenger: "الراكب",
    paidAmount: "المبلغ المدفوع",
    original: "الأصلي",
    newStart: "البداية الجديدة : ",
    newEnd: "النهاية الجديدة : ",
    close: "إغلاق",
    continue: "متابعة",
    rideDetails: "تفاصيل الرحلة",
    captainRefund: " (استرداد للكابتن)",
    passengerRefund: " (استرداد للراكب)",
    captainCashOut: " (سحب نقدي للكابتن)",
    passengerCashOut: " (سحب نقدي للراكب)",
    required: "مطلوب",
    requiredField: "حقل مطلوب",
    requiredFieldLower: "حقل مطلوب",
    invalidValue: "قيمة غير صالحة",
    fieldRequired: "الحقل مطلوب",
    invalidInfo: "معلومات غير صالحة",
    done: "تم",
    ticketStatus: "حالة التذكرة",
    ticketsTypes: "أنواع التذاكر",
    viewTicket: "عرض التذكرة",
    empty: "فارغ",
  },
  locationsPage: {
    restrictedAreasTitle: "المناطق المحظورة",
    restrictedAreaEditorTitle: "محرر المنطقة المحظورة",
    name: "الاسم",
    polygon: "المضلع",
    from: "من",
    to: "إلى",
    dateCreated: "تاريخ الإنشاء",
    dateUpdated: "تاريخ التعديل",
    actionDuplicate: "تكرار",
    confirmDuplicate: "هل أنت متأكد من تكرار هذا العنصر؟",
    toastDuplicated: "تم التكرار",
    errorHappened: "حدث خطأ (راجع سجل الأخطاء)",
    save: "حفظ",
    cancel: "إلغاء",
    saved: "تم الحفظ",
    notSaved: "لم يتم الحفظ",
    saveChangesQuestion: "حفظ التغييرات؟",
    savingChanges: "جارٍ حفظ التغييرات...",
    choosePolygon: "يرجى رسم المضلع على الخريطة!",
    ruleRequired: "هذا الحقل مطلوب",
    ruleNumber: "يجب أن تكون القيمة رقماً",
    stationsTitle: "المحطات",
    stationEditorTitle: "محرر المحطة",
    entrancePolygon: "مضلع الدخول",
    ejectionPolygon: "مضلع الإخراج",
    landmarksTitle: "المعالم",
    landmarkEditorTitle: "محرر المعلم",
    streetName: "اسم الشارع",
    streetNumber: "رقم الشارع",
    selectCity: "اختر المدينة",
    containersTitle: "الحاويات",
    containerListTitle: "قائمة حاويات المواقع",
    containerEditorTitle: "محرر حاوية الموقع",
    sectorsTitle: "القطاعات",
    blacklistedSectorsTitle: "القطاعات المحظورة",
    updateSeasonalDestinationsTitle: "تحديث الوجهات الموسمية",
    destinationsTab: "الوجهات",
    editSeasonalDestinations: "تعديل الوجهات الموسمية",
    seasonalDestinationsPlaceholder: "الوجهات الموسمية",
    update: "تحديث",
    destinationsUpdated: "تم تحديث الوجهات",
    checkYourInfo: "يرجى التحقق من المعلومات المُدخلة",
  },
  messagingPage: {
    provider: "الجهة المستهدفة",
    csvFile: "ملف CSV",
    selectManually: "اختيار يدوي",
    choosePassengers: "اختر ركّاباً",
    chooseCaptains: "اختر سائقين",
    csvFileHint: "ملف CSV (كل سطر يمثل معرّف {provider})",
    broadcastUse: "قنوات البث",
    whatsappNumber: "رقم واتساب",
    presets: "الإعدادات المسبقة",
    preset: "الإعداد",
    description: "الوصف",
    since: "منذ",
    active: "مُفعّل",
    message: "الرسالة",
    submit: "إرسال",
    fieldRequired: "هذا الحقل مطلوب",
    completeInfo: "يرجى إكمال المعلومات المطلوبة",
    broadcastStarted: "بدأ البث بنجاح",
    broadcastFailed: "فشل الإرسال، يرجى فتح أداة الفحص والتقاط صورة للشاشة",
    search: "بحث",
    loading: "جارٍ التحميل",
    seen: "تم الاطّلاع",
    sent: "أُرسلت",
    sendMessagePlaceholder: "اكتب رسالة",
    connectingToTwilio: "جارٍ الاتصال بـ Twilio",
    connectionErrorTwilio: "خطأ أثناء الاتصال بـ Twilio",
    selectConversation: "اختر محادثة",
    toStartMessaging: "لبدء المراسلة",
    pageTitle: "الرسائل المجدولة",
    newScheduledMessage: "رسالة مجدولة جديدة",
    colId: "المعرّف",
    start: "البداية",
    end: "النهاية",
    interval: "الفاصل الزمني",
    deleteScheduledMessage: "حذف الرسالة المجدولة",
    deletedSuccessfully: "تم الحذف بنجاح",
    somethingWrong: "حدث خطأ ما",
    createNewScheduledMessage: "إنشاء رسالة مجدولة جديدة",
    numberOfDays: "عدد الأيام",
    step: "الخطوة",
    create: "إنشاء",
    singleTitle: "رسالة مجدولة",
    invalidLength: "طول غير صالح، المطلوب {len}",
    enterValidHours: "يرجى إدخال ساعات صحيحة",
    createdSuccessfully: "تم الإنشاء بنجاح",
    checkYourInfo: "تحقّق من معلوماتك",
    broadcastHeading: "بث",
    selectDriversHint: "اختر السائقين الذين تريد البث إليهم",
    send: "إرسال",
    confirmSendNotifications: "هل أنت متأكد من إرسال إشعارات إلى {count} سائق؟",
    sentSuccessfully: "تم الإرسال بنجاح",
    eventsPageTitle: "تقارير الفعاليات",
    from: "من",
    to: "إلى",
    eventType: "نوع الفعالية",
    get: "عرض",
    exportCSV: "تصدير CSV",
    weekdayAndDate: "اليوم والتاريخ",
    shift: "الوردية",
    completedOrders: "عدد الطلبات المكتملة",
    registeredDrivers: "السائقون المسجّلون",
    missingDrivers: "السائقون الغائبون",
    activeDrivers: "السائقون النشطون",
    extraDrivers: "السائقون الإضافيون",
    eventRange: "{type} من {start} إلى {end}",
    savingChanges: "جارٍ حفظ التغييرات...",
    success: "تم بنجاح",
    downloadFailed: "فشل التنزيل",
  },
  monitoringPage: {
    common: {
      name: "الاسم",
      createdAt: "تاريخ الإنشاء",
      updatedAt: "تاريخ التحديث",
    },
    monitor: {
      pageTitle: "المراقبة",
      onlineCaptains: "الكباتن المتصلون: {online}/{available}",
      delayAvgMax: "متوسط/أقصى التأخير: {avg} د / {max} د",
      sendTrafficNotification: "إرسال إشعار ازدحام للكباتن غير المتصلين",
      target: "الهدف",
      delay: "التأخير",
      hourlyBookings: "الحجوزات بالساعة",
      dailyBookings: "الحجوزات اليومية",
      editSurgeMessage: "تعديل رسالة التحفيز:",
      broadcastUse: "قنوات الإرسال",
      send: "إرسال",
      surgeConfirm: "هل أنت متأكد من إرسال التحفيز للكباتن؟",
    },
    pathDrawer: {
      pageTitle: "مسار الرحلة",
      selectRideType: "اختر نوع الرحلة",
      rideId: "معرّف الرحلة",
      ghostRideId: "معرّف الرحلة الوهمية",
      search: "بحث",
      legendPaxPick: "التقاط الراكب",
      legendPaxPull: "إنزال الراكب",
      legendPending: "قيد الانتظار",
      legendAccepted: "مقبول",
      legendStarted: "بدأت",
      legendArrived: "وصل",
      legendPickedUp: "تم الالتقاط",
      legendDone: "منتهية",
      legendStop: "توقف",
    },
    ridesSearch: {
      pageTitle: "البحث عن رحلة",
      rideId: "معرّف الرحلة",
    },
    ridesTracking: {
      pageTitle: "تتبع الرحلات",
    },
    ratingCauses: {
      pageTitle: "أسباب التقييم",
      captainRatingCauses: "أسباب تقييم الكابتن",
      passengerRatingCauses: "أسباب تقييم الراكب",
      cause: "السبب",
      ruleRequired: "حقل مطلوب",
      ruleMinChars: "يجب أن يكون 3 أحرف على الأقل",
      addNewCause: "إضافة سبب جديد",
      colCreatedAt: "تاريخ الإنشاء",
    },
    anas: {
      pageTitle: "ركاب الرحلة الأولى",
      voucherAttached: "القسائم المرفقة: {count}",
      idReminderActivated: "نسبة تفعيل تذكير الهوية: {value}%",
      idReminderTotal: "إجمالي تذكيرات الهوية: {value}",
      tableTitle: "إحصائيات أنس",
    },
    vehicleType: {
      pageTitle: "أنواع المركبات",
      colMaxSeats: "أقصى عدد مقاعد",
      unloadable: "غير قابل للتحميل",
      ruleNumber: "يجب أن يكون رقماً",
      ruleRequired: "هذا الحقل مطلوب",
    },
    nationalities: {
      pageTitle: "الجنسيات",
    },
    unregisteredAgent: {
      pageTitle: "غير مسجّل",
    },
  },
  planningPage: {
    shiftsTitle: "الورديات",
    createEventTitle: "إنشاء فعالية",
    eventDetailsTitle: "تفاصيل الفعالية",
    eventsTitle: "الفعاليات",
    shiftsMapTitle: "تفاصيل الفعالية",
    reservationQueueTitle: "قائمة انتظار الحجوزات",
    startDate: "تاريخ البدء",
    endDate: "تاريخ الانتهاء",
    shiftsCount: "الورديات",
    planType: "نوع الخطة",
    id: "#",
    day: "اليوم",
    from: "من",
    to: "إلى",
    currentDrivers: "السائقون الحاليون",
    expectedDrivers: "السائقون المتوقعون",
    edit: "تعديل",
    captainProfile: "ملف السائق",
    info: "معلومات",
    editShiftTitle: "تعديل عدد السائقين المتوقعين للوردية رقم {id}",
    editShiftParagraph: "يرجى إدخال العدد الجديد للسائقين المتوقعين",
    editShiftInput: "أدخل العدد الجديد",
    createEventHeadline: "إنشاء فعالية جديدة",
    eventName: "اسم الفعالية",
    startShift: "وردية البدء",
    endShift: "وردية الانتهاء",
    lastApplianceDate: "آخر موعد للتقديم",
    create: "إنشاء",
    requiredField: "هذا الحقل مطلوب",
    invalidEmail: "يرجى إدخال بريد إلكتروني صالح",
    invalidLength: "عدد الأحرف غير صالح، المطلوب {len}",
    invalidPassword: "يجب أن تتكون كلمة المرور من 8 إلى 15 حرفاً",
    eventCreated: "تم إنشاء الفعالية",
    checkYourInfo: "تحقق من بياناتك",
    lastApplianceDateCol: "آخر موعد للتقديم",
    registeredDrivers: "السائقون المسجلون",
    creationDate: "تاريخ الإنشاء",
    lastTimeToApply: "آخر موعد للتقديم",
    captainsAppliedToShift: "السائقون المتقدمون لهذه الوردية",
    eventsDetails: "تفاصيل الفعاليات",
    startShiftDate: "تاريخ بدء الوردية",
    endShiftDate: "تاريخ انتهاء الوردية",
    captainCount: "عدد السائقين",
    captainName: "اسم السائق",
    applyDate: "تاريخ التقديم",
    filterByDay: "التصفية حسب اليوم",
    captain: "السائق",
    shift: "الوردية",
    paths: "المسارات",
    logs: "السجلات",
    bookingPickupLocation: "موقع انطلاق الحجز {id}",
    bookingDropoffLocation: "موقع وصول الحجز {id}",
    logStatusAt: "{status} في {time}",
    bookingPathTitle: "مسار الحجز {id}",
    statusLabel: "الحالة",
    pickupLocationLabel: "موقع الانطلاق",
    dropoffLocationLabel: "موقع الوصول",
    createdAtLabel: "تاريخ الإنشاء",
    captainIdCol: "معرّف السائق",
    captainUsernameCol: "اسم مستخدم السائق",
    captainNameCol: "اسم السائق",
    orderCol: "الترتيب",
    enterNewPosition: "أدخل الترتيب الجديد للسائق",
    enterNewPositionPlaceholder: "أدخل الترتيب الجديد",
    close: "إغلاق",
    submit: "إرسال",
  },
  restaurantsPage: {
    pageTitle: "المطاعم",
    restaurantDocTitle: "مطعم",
    editRestaurantDocTitle: "تعديل مطعم",
    new: "جديد",
    newRestaurant: "مطعم جديد",
    colNumber: "الرقم",
    colUserName: "اسم المستخدم",
    colRestaurantName: "اسم المطعم",
    colPhoneNumber: "رقم الهاتف",
    colCreationDate: "تاريخ الإنشاء",
    colId: "المعرف",
    colName: "الاسم",
    colAddress: "العنوان",
    colLandmark: "أقرب معلم",
    profile: "الملف الشخصي",
    editRestaurant: "تعديل المطعم",
    deleteRestaurant: "حذف المطعم",
    restaurantDeleted: "تم حذف المطعم بنجاح",
    somethingWentWrong: "حدث خطأ ما",
    createAccountTitle: "إنشاء حساب مطعم",
    createRestaurantTitle: "إنشاء مطعم جديد",
    selectRestaurant: "المطعم",
    selectRestaurantPlaceholder: "اختر المطعم",
    email: "البريد الإلكتروني",
    password: "كلمة المرور",
    phoneNumber: "رقم الهاتف",
    restaurantName: "اسم المطعم",
    address: "العنوان",
    addressPlaceholder: "أدخل العنوان",
    editHeading: "اسم المطعم",
    create: "إنشاء",
    save: "حفظ",
    restaurantCreated: "تم إنشاء المطعم",
    restaurantSaved: "تم حفظ المطعم",
    failedToSaveRestaurant: "فشل حفظ المطعم",
    checkYourInfo: "تحقق من المعلومات المدخلة",
    fillAllData: "يرجى تعبئة جميع البيانات",
    fieldRequired: "هذا الحقل مطلوب",
    invalidEmail: "يرجى إدخال بريد إلكتروني صالح",
    invalidLength: "طول الأحرف غير صالح، المطلوب {len}",
    passwordLength: "يجب أن تتكون كلمة المرور من 8 إلى 15 حرفاً.",
    invalidPhone: "رقم الهاتف غير صالح!",
  },
  seasonalPage: {
    newSeasonalTime: "وقت حجز موسمي جديد",
    reservationAllowanceTitle: "سماحية الحجز الموسمي",
    idLabel: "المعرّف",
    day: "اليوم",
    startTime: "وقت البدء",
    endTime: "وقت الانتهاء",
    editTimeTooltip: "تعديل وقت الحجز الموسمي",
    deleteTimeTooltip: "حذف وقت الحجز الموسمي",
    deletedSuccess: "تم الحذف بنجاح",
    somethingWentWrong: "حدث خطأ ما",
    createSeasonalHeadline: "إنشاء وقت حجز موسمي جديد",
    createPageTitle: "إنشاء حجز موسمي",
    editPageTitle: "تعديل حجز موسمي",
    from: "من",
    to: "إلى",
    create: "إنشاء",
    save: "حفظ",
    invalidHours: "الرجاء إدخال ساعات صحيحة",
    createdSuccess: "تم الإنشاء بنجاح",
    savedSuccess: "تم الحفظ بنجاح",
    checkInfo: "تحقّق من معلوماتك",
    fieldRequired: "هذا الحقل مطلوب",
    invalidLength: "طول غير صالح، المطلوب {len}",
    changeCaptainReasonsTitle: "أسباب تغيير الكابتن",
    reason: "السبب",
    name: "الاسم",
    percentage: "النسبة المئوية",
    perHour: "لكل ساعة",
    perKm: "لكل كيلومتر",
    perBooking: "لكل حجز",
    newLevel: "مستوى جديد",
    addLevel: "إضافة مستوى:",
    contractTemplate: "قالب العقد",
    levelSummary: "النسبة المئوية: {percentage}%، لكل ساعة: {perHour}%، لكل كيلومتر: {perKm}%، لكل حجز: {perBooking}",
    chooseBonusPackages: "اختر حزم المكافآت",
    submit: "إرسال",
    levelsTitle: "المستويات",
    noContractTemplate: "لا يوجد قالب عقد",
    saved: "تم الحفظ",
    genericError: "حدث خطأ",
    dateLabel: "التاريخ:",
    noDataAvailable: "لا توجد بيانات متاحة",
    openFile: "فتح الملف",
    newButton: "جديد",
    termsPageTitle: "الشروط والأحكام",
    captainUsername: "اسم مستخدم الكابتن",
    captainName: "اسم الكابتن",
    answer: "الرد",
    answeredAt: "وقت الرد",
    uploadTermsHeadline: "رفع شروط وأحكام جديدة",
    termsDocumentName: "الشروط والأحكام",
    upload: "رفع",
    createTermsPageTitle: "إنشاء شروط وأحكام",
    termCreated: "تم إنشاء الشروط",
    vacationsUpcomingTab: "الإجازات القادمة",
    vacationsPastTab: "الإجازات السابقة",
    startDate: "تاريخ البدء",
    endDate: "تاريخ الانتهاء",
    captain: "الكابتن",
    searchForCaptain: "ابحث عن كابتن",
    search: "بحث",
    colUsername: "اسم المستخدم",
    reservationTab: "الحجز",
    shortReservationTab: "الحجز القصير",
    instantTab: "الفوري",
    timeRange: "{from} إلى {to}",
    colTime: "الوقت",
    colMon: "الإثنين",
    colTue: "الثلاثاء",
    colWed: "الأربعاء",
    colThu: "الخميس",
    colFri: "الجمعة",
    colSat: "السبت",
    colSun: "الأحد",
    updateAll: "تحديث الكل",
    updatedToast: "تم التحديث",
  },
  surveysPage: {
    surveysTitle: "الاستبيانات",
    surveyProfileTitle: "تفاصيل الاستبيان",
    createSurveyTitle: "إضافة استبيان",
    constraintsTitle: "القيود",
    createConstraintTitle: "إضافة قيد",
    editConstraintTitle: "تعديل القيد",
    newSurvey: "استبيان جديد",
    surveyAnswers: "إجابات الاستبيان",
    colId: "المعرف",
    titleLabel: "العنوان",
    questionLabel: "السؤال",
    startDateLabel: "تاريخ البدء",
    endDateLabel: "تاريخ الانتهاء",
    totalDriversAnswered: "إجمالي السائقين المجيبين",
    surveyOptions: "خيارات الاستبيان",
    percentage: "النسبة",
    count: "العدد",
    captainUsername: "اسم مستخدم الكابتن",
    captainName: "اسم الكابتن",
    answer: "الإجابة",
    answeredAt: "تاريخ الإجابة",
    surveyTab: "استبيان",
    surveyInformation: "معلومات الاستبيان",
    surveyTitleField: "عنوان الاستبيان",
    surveyQuestionField: "سؤال الاستبيان",
    surveyEndDate: "تاريخ انتهاء الاستبيان",
    surveyEndTime: "وقت انتهاء الاستبيان",
    createSurvey: "إنشاء استبيان",
    toastSurveyAdded: "تمت إضافة الاستبيان",
    newConstraint: "قيد جديد",
    colConstraintName: "اسم القيد",
    colAbbreviation: "الاختصار",
    colCustomerAppMessage: "رسالة تطبيق الزبون",
    colShownInCustomerApp: "يظهر في تطبيق الزبون؟",
    colType: "النوع",
    colStrikeThrough: "الشطب",
    editConstraint: "تعديل القيد",
    deleteConstraint: "حذف القيد",
    toastConstraintDeleted: "تم حذف القيد بنجاح",
    toastSomethingWrong: "حدث خطأ ما",
    constraintTab: "قيد",
    constraintInformation: "معلومات القيد",
    constraintNameField: "اسم القيد",
    constraintAbbreviationField: "اختصار القيد",
    constraintCustomerAppMessageField: "رسالة القيد في تطبيق الزبون",
    customerAppMessageField: "رسالة تطبيق الزبون",
    canDriverEdit: "هل يمكن للسائق تعديله؟",
    showInCustomerApp: "إظهار في تطبيق الزبون؟",
    strikeThrough: "شطب النص؟",
    constraintType: "نوع القيد",
    createConstraint: "إنشاء قيد",
    optionYes: "نعم",
    optionNo: "لا",
    editConstraintHeading: "تعديل القيد: {name}",
    save: "حفظ",
    toastConstraintAdded: "تمت إضافة القيد",
    toastFillAllData: "يرجى تعبئة جميع البيانات",
    toastConstraintSaved: "تم حفظ القيد",
    toastFailedSaveConstraint: "فشل حفظ القيد",
    toastCheckInfo: "تحقق من المعلومات المدخلة",
    ruleRequired: "هذا الحقل مطلوب",
    ruleEmail: "يرجى إدخال بريد إلكتروني صالح",
    ruleLength: "طول الأحرف غير صالح، المطلوب {len}",
    rulePassword: "يجب أن تتكون كلمة المرور من 8 إلى 15 حرفاً.",
    rulePhone: "رقم الهاتف غير صالح!",
    ruleLicense: "رقم الرخصة غير صالح",
  },
};